import { d as ut, _ as Gt, e as oe, w as Si, f as se, h as wi, i as le, k as ht, l as qt, m as nt, n as Oi, o as ct, u as Ci, q as pn, t as wt, v as Ii, x as Ei, y as _i, c as kn, z as Mi, A as Pi, B as vo, C as Ri, D as ra, j as x, E as $i, a as Cn, F as Di, G as Ot, H as Ni, I as Ct, J as oa, p as Li, K as aa, g as ia } from "./country-d4e42059.js";
import * as y from "react";
import Ke, { useState as me, useRef as re, useEffect as Se, useTransition as Ti, useMemo as la } from "react";
import { T as ji, i as Fi, R as sa, o as ki, t as Ir, b as Vi, s as D, d as ca, l as mr, u as zi, a as Ai, B as Bi, c as Hi, Q as Wi } from "./index-384e14bf.js";
import { j as Er, n as ua, a as In, u as Qt, l as Jt, p as da, c as Bn, b as En, v as Gi, k as gn, q as Ki, s as Zi, t as Xi, w as Ui, x as Yi } from "./index-23ca9bfe.js";
import { a as Ji, S as qi, b as Qi, c as el, s as tl, d as nl, u as fa, e as rl, f as ol, A as ma, C as Hn, E as al } from "./index-6f309963.js";
import { u as _r, a as po, i as yt, b as il, c as ll, d as sl, n as cl, e as Pt, f as Wn, r as va, g as en, l as ul, h as tn, s as Gn, A as Fr, j as dl, w as pa, D as fl, L as ga } from "./reactNode-61f1c13f.js";
import { K as ee, p as Vn, i as mn } from "./lib-1be19634.js";
import { F as ml, L as vl } from "./LoginOpt-0950fbbf.js";
import { c as pl, o as gl, u as hl, C as yl } from "./index-10651ff7.js";
import { M as bl, H as Kn, N as xl } from "./index-6b21cdcf.js";
import { L as Sl } from "./link-94e20c90.js";
import { D as wl } from "./index-510f96a1.js";
var Zn = function(t) {
  var n = t.className, r = t.customizeIcon, o = t.customizeIconProps, a = t.children, i = t.onMouseDown, l = t.onClick, u = typeof r == "function" ? r(o) : r;
  return /* @__PURE__ */ y.createElement("span", {
    className: n,
    onMouseDown: function(m) {
      m.preventDefault(), i == null || i(m);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: l,
    "aria-hidden": !0
  }, u !== void 0 ? u : /* @__PURE__ */ y.createElement("span", {
    className: ut(n.split(/\s+/).map(function(p) {
      return "".concat(p, "-icon");
    }))
  }, a));
}, Ol = function(t, n, r, o, a) {
  var i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, l = arguments.length > 6 ? arguments[6] : void 0, u = arguments.length > 7 ? arguments[7] : void 0, p = Ke.useMemo(function() {
    if (Gt(o) === "object")
      return o.clearIcon;
    if (a)
      return a;
  }, [o, a]), m = Ke.useMemo(function() {
    return !!(!i && o && (r.length || l) && !(u === "combobox" && l === ""));
  }, [o, i, r.length, l, u]);
  return {
    allowClear: m,
    clearIcon: /* @__PURE__ */ Ke.createElement(Zn, {
      className: "".concat(t, "-clear"),
      onMouseDown: n,
      customizeIcon: p
    }, "×")
  };
}, ha = /* @__PURE__ */ y.createContext(null);
function ya() {
  return y.useContext(ha);
}
function Cl() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = y.useState(!1), n = oe(t, 2), r = n[0], o = n[1], a = y.useRef(null), i = function() {
    window.clearTimeout(a.current);
  };
  y.useEffect(function() {
    return i;
  }, []);
  var l = function(p, m) {
    i(), a.current = window.setTimeout(function() {
      o(p), m && m();
    }, e);
  };
  return [r, l, i];
}
function ba() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = y.useRef(null), n = y.useRef(null);
  y.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function r(o) {
    (o || t.current === null) && (t.current = o), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, r];
}
function Il(e, t, n, r) {
  var o = y.useRef(null);
  o.current = {
    open: t,
    triggerOpen: n,
    customizedTrigger: r
  }, y.useEffect(function() {
    function a(i) {
      var l;
      if (!((l = o.current) !== null && l !== void 0 && l.customizedTrigger)) {
        var u = i.target;
        u.shadowRoot && i.composed && (u = i.composedPath()[0] || u), o.current.open && e().filter(function(p) {
          return p;
        }).every(function(p) {
          return !p.contains(u) && p !== u;
        }) && o.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", a), function() {
      return window.removeEventListener("mousedown", a);
    };
  }, []);
}
function El(e) {
  return ![
    // System function button
    ee.ESC,
    ee.SHIFT,
    ee.BACKSPACE,
    ee.TAB,
    ee.WIN_KEY,
    ee.ALT,
    ee.META,
    ee.WIN_KEY_RIGHT,
    ee.CTRL,
    ee.SEMICOLON,
    ee.EQUALS,
    ee.CAPS_LOCK,
    ee.CONTEXT_MENU,
    // F1-F12
    ee.F1,
    ee.F2,
    ee.F3,
    ee.F4,
    ee.F5,
    ee.F6,
    ee.F7,
    ee.F8,
    ee.F9,
    ee.F10,
    ee.F11,
    ee.F12
  ].includes(e);
}
var _l = function(t, n) {
  var r, o = t.prefixCls, a = t.id, i = t.inputElement, l = t.disabled, u = t.tabIndex, p = t.autoFocus, m = t.autoComplete, s = t.editable, h = t.activeDescendantId, v = t.value, c = t.maxLength, f = t.onKeyDown, d = t.onMouseDown, g = t.onChange, b = t.onPaste, w = t.onCompositionStart, S = t.onCompositionEnd, C = t.open, I = t.attrs, O = i || /* @__PURE__ */ y.createElement("input", null), _ = O, Z = _.ref, j = _.props, F = j.onKeyDown, N = j.onChange, $ = j.onMouseDown, E = j.onCompositionStart, A = j.onCompositionEnd, G = j.style;
  return Si(!("maxLength" in O.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), O = /* @__PURE__ */ y.cloneElement(O, se(se(se({
    type: "search"
  }, j), {}, {
    // Override over origin props
    id: a,
    ref: wi(n, Z),
    disabled: l,
    tabIndex: u,
    autoComplete: m || "off",
    autoFocus: p,
    className: ut("".concat(o, "-selection-search-input"), (r = O) === null || r === void 0 || (r = r.props) === null || r === void 0 ? void 0 : r.className),
    role: "combobox",
    "aria-expanded": C || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(a, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(a, "_list"),
    "aria-activedescendant": C ? h : void 0
  }, I), {}, {
    value: s ? v : "",
    maxLength: c,
    readOnly: !s,
    unselectable: s ? null : "on",
    style: se(se({}, G), {}, {
      opacity: s ? null : 0
    }),
    onKeyDown: function(P) {
      f(P), F && F(P);
    },
    onMouseDown: function(P) {
      d(P), $ && $(P);
    },
    onChange: function(P) {
      g(P), N && N(P);
    },
    onCompositionStart: function(P) {
      w(P), E && E(P);
    },
    onCompositionEnd: function(P) {
      S(P), A && A(P);
    },
    onPaste: b
  })), O;
}, kr = /* @__PURE__ */ y.forwardRef(_l);
process.env.NODE_ENV !== "production" && (kr.displayName = "Input");
function Vr(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var Ml = typeof window < "u" && window.document && window.document.documentElement, Pl = process.env.NODE_ENV !== "test" && Ml;
function Rl(e) {
  return e != null;
}
function $l(e) {
  return !e && e !== 0;
}
function go(e) {
  return ["string", "number"].includes(Gt(e));
}
function xa(e) {
  var t = void 0;
  return e && (go(e.title) ? t = e.title.toString() : go(e.label) && (t = e.label.toString())), t;
}
function Dl(e, t) {
  Pl ? y.useLayoutEffect(e, t) : y.useEffect(e, t);
}
function Nl(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var ho = function(t) {
  t.preventDefault(), t.stopPropagation();
}, Ll = function(t) {
  var n = t.id, r = t.prefixCls, o = t.values, a = t.open, i = t.searchValue, l = t.autoClearSearchValue, u = t.inputRef, p = t.placeholder, m = t.disabled, s = t.mode, h = t.showSearch, v = t.autoFocus, c = t.autoComplete, f = t.activeDescendantId, d = t.tabIndex, g = t.removeIcon, b = t.maxTagCount, w = t.maxTagTextLength, S = t.maxTagPlaceholder, C = S === void 0 ? function(H) {
    return "+ ".concat(H.length, " ...");
  } : S, I = t.tagRender, O = t.onToggleOpen, _ = t.onRemove, Z = t.onInputChange, j = t.onInputPaste, F = t.onInputKeyDown, N = t.onInputMouseDown, $ = t.onInputCompositionStart, E = t.onInputCompositionEnd, A = y.useRef(null), G = me(0), k = oe(G, 2), P = k[0], z = k[1], B = me(!1), ve = oe(B, 2), ge = ve[0], te = ve[1], ce = "".concat(r, "-selection"), ue = a || s === "multiple" && l === !1 || s === "tags" ? i : "", ke = s === "tags" || s === "multiple" && l === !1 || h && (a || ge);
  Dl(function() {
    z(A.current.scrollWidth);
  }, [ue]);
  var q = function(T, V, ne, we, fe) {
    return /* @__PURE__ */ y.createElement("span", {
      title: xa(T),
      className: ut("".concat(ce, "-item"), le({}, "".concat(ce, "-item-disabled"), ne))
    }, /* @__PURE__ */ y.createElement("span", {
      className: "".concat(ce, "-item-content")
    }, V), we && /* @__PURE__ */ y.createElement(Zn, {
      className: "".concat(ce, "-item-remove"),
      onMouseDown: ho,
      onClick: fe,
      customizeIcon: g
    }, "×"));
  }, he = function(T, V, ne, we, fe, xe) {
    var Ne = function(Ae) {
      ho(Ae), O(!a);
    };
    return /* @__PURE__ */ y.createElement("span", {
      onMouseDown: Ne
    }, I({
      label: V,
      value: T,
      disabled: ne,
      closable: we,
      onClose: fe,
      isMaxTag: !!xe
    }));
  }, ye = function(T) {
    var V = T.disabled, ne = T.label, we = T.value, fe = !m && !V, xe = ne;
    if (typeof w == "number" && (typeof ne == "string" || typeof ne == "number")) {
      var Ne = String(xe);
      Ne.length > w && (xe = "".concat(Ne.slice(0, w), "..."));
    }
    var ze = function(Be) {
      Be && Be.stopPropagation(), _(T);
    };
    return typeof I == "function" ? he(we, xe, V, fe, ze) : q(T, xe, V, fe, ze);
  }, L = function(T) {
    var V = typeof C == "function" ? C(T) : C;
    return typeof I == "function" ? he(void 0, V, !1, !1, void 0, !0) : q({
      title: V
    }, V, !1);
  }, R = /* @__PURE__ */ y.createElement("div", {
    className: "".concat(ce, "-search"),
    style: {
      width: P
    },
    onFocus: function() {
      te(!0);
    },
    onBlur: function() {
      te(!1);
    }
  }, /* @__PURE__ */ y.createElement(kr, {
    ref: u,
    open: a,
    prefixCls: r,
    id: n,
    inputElement: null,
    disabled: m,
    autoFocus: v,
    autoComplete: c,
    editable: ke,
    activeDescendantId: f,
    value: ue,
    onKeyDown: F,
    onMouseDown: N,
    onChange: Z,
    onPaste: j,
    onCompositionStart: $,
    onCompositionEnd: E,
    tabIndex: d,
    attrs: Vn(t, !0)
  }), /* @__PURE__ */ y.createElement("span", {
    ref: A,
    className: "".concat(ce, "-search-mirror"),
    "aria-hidden": !0
  }, ue, " ")), M = /* @__PURE__ */ y.createElement(ml, {
    prefixCls: "".concat(ce, "-overflow"),
    data: o,
    renderItem: ye,
    renderRest: L,
    suffix: R,
    itemKey: Nl,
    maxCount: b
  });
  return /* @__PURE__ */ y.createElement(y.Fragment, null, M, !o.length && !ue && /* @__PURE__ */ y.createElement("span", {
    className: "".concat(ce, "-placeholder")
  }, p));
}, Tl = function(t) {
  var n = t.inputElement, r = t.prefixCls, o = t.id, a = t.inputRef, i = t.disabled, l = t.autoFocus, u = t.autoComplete, p = t.activeDescendantId, m = t.mode, s = t.open, h = t.values, v = t.placeholder, c = t.tabIndex, f = t.showSearch, d = t.searchValue, g = t.activeValue, b = t.maxLength, w = t.onInputKeyDown, S = t.onInputMouseDown, C = t.onInputChange, I = t.onInputPaste, O = t.onInputCompositionStart, _ = t.onInputCompositionEnd, Z = t.title, j = y.useState(!1), F = oe(j, 2), N = F[0], $ = F[1], E = m === "combobox", A = E || f, G = h[0], k = d || "";
  E && g && !N && (k = g), y.useEffect(function() {
    E && $(!1);
  }, [E, g]);
  var P = m !== "combobox" && !s && !f ? !1 : !!k, z = Z === void 0 ? xa(G) : Z, B = y.useMemo(function() {
    return G ? null : /* @__PURE__ */ y.createElement("span", {
      className: "".concat(r, "-selection-placeholder"),
      style: P ? {
        visibility: "hidden"
      } : void 0
    }, v);
  }, [G, P, v, r]);
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("span", {
    className: "".concat(r, "-selection-search")
  }, /* @__PURE__ */ y.createElement(kr, {
    ref: a,
    prefixCls: r,
    id: o,
    open: s,
    inputElement: n,
    disabled: i,
    autoFocus: l,
    autoComplete: u,
    editable: A,
    activeDescendantId: p,
    value: k,
    onKeyDown: w,
    onMouseDown: S,
    onChange: function(ge) {
      $(!0), C(ge);
    },
    onPaste: I,
    onCompositionStart: O,
    onCompositionEnd: _,
    tabIndex: c,
    attrs: Vn(t, !0),
    maxLength: E ? b : void 0
  })), !E && G ? /* @__PURE__ */ y.createElement("span", {
    className: "".concat(r, "-selection-item"),
    title: z,
    style: P ? {
      visibility: "hidden"
    } : void 0
  }, G.label) : null, B);
}, jl = function(t, n) {
  var r = re(null), o = re(!1), a = t.prefixCls, i = t.open, l = t.mode, u = t.showSearch, p = t.tokenWithEnter, m = t.disabled, s = t.autoClearSearchValue, h = t.onSearch, v = t.onSearchSubmit, c = t.onToggleOpen, f = t.onInputKeyDown, d = t.domRef;
  y.useImperativeHandle(n, function() {
    return {
      focus: function(P) {
        r.current.focus(P);
      },
      blur: function() {
        r.current.blur();
      }
    };
  });
  var g = ba(0), b = oe(g, 2), w = b[0], S = b[1], C = function(P) {
    var z = P.which;
    (z === ee.UP || z === ee.DOWN) && P.preventDefault(), f && f(P), z === ee.ENTER && l === "tags" && !o.current && !i && (v == null || v(P.target.value)), El(z) && c(!0);
  }, I = function() {
    S(!0);
  }, O = re(null), _ = function(P) {
    h(P, !0, o.current) !== !1 && c(!0);
  }, Z = function() {
    o.current = !0;
  }, j = function(P) {
    o.current = !1, l !== "combobox" && _(P.target.value);
  }, F = function(P) {
    var z = P.target.value;
    if (p && O.current && /[\r\n]/.test(O.current)) {
      var B = O.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      z = z.replace(B, O.current);
    }
    O.current = null, _(z);
  }, N = function(P) {
    var z = P.clipboardData, B = z == null ? void 0 : z.getData("text");
    O.current = B || "";
  }, $ = function(P) {
    var z = P.target;
    if (z !== r.current) {
      var B = document.body.style.msTouchAction !== void 0;
      B ? setTimeout(function() {
        r.current.focus();
      }) : r.current.focus();
    }
  }, E = function(P) {
    var z = w();
    P.target !== r.current && !z && !(l === "combobox" && m) && P.preventDefault(), (l !== "combobox" && (!u || !z) || !i) && (i && s !== !1 && h("", !0, !1), c());
  }, A = {
    inputRef: r,
    onInputKeyDown: C,
    onInputMouseDown: I,
    onInputChange: F,
    onInputPaste: N,
    onInputCompositionStart: Z,
    onInputCompositionEnd: j
  }, G = l === "multiple" || l === "tags" ? /* @__PURE__ */ y.createElement(Ll, ht({}, t, A)) : /* @__PURE__ */ y.createElement(Tl, ht({}, t, A));
  return /* @__PURE__ */ y.createElement("div", {
    ref: d,
    className: "".concat(a, "-selector"),
    onClick: $,
    onMouseDown: E
  }, G);
}, Sa = /* @__PURE__ */ y.forwardRef(jl);
process.env.NODE_ENV !== "production" && (Sa.displayName = "Selector");
var Fl = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], kl = function(t) {
  var n = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, Vl = function(t, n) {
  var r = t.prefixCls;
  t.disabled;
  var o = t.visible, a = t.children, i = t.popupElement, l = t.animation, u = t.transitionName, p = t.dropdownStyle, m = t.dropdownClassName, s = t.direction, h = s === void 0 ? "ltr" : s, v = t.placement, c = t.builtinPlacements, f = t.dropdownMatchSelectWidth, d = t.dropdownRender, g = t.dropdownAlign, b = t.getPopupContainer, w = t.empty, S = t.getTriggerDOMNode, C = t.onPopupVisibleChange, I = t.onPopupMouseEnter, O = qt(t, Fl), _ = "".concat(r, "-dropdown"), Z = i;
  d && (Z = d(i));
  var j = y.useMemo(function() {
    return c || kl(f);
  }, [c, f]), F = l ? "".concat(_, "-").concat(l) : u, N = typeof f == "number", $ = y.useMemo(function() {
    return N ? null : f === !1 ? "minWidth" : "width";
  }, [f, N]), E = p;
  N && (E = se(se({}, E), {}, {
    width: f
  }));
  var A = y.useRef(null);
  return y.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        var k;
        return (k = A.current) === null || k === void 0 ? void 0 : k.popupElement;
      }
    };
  }), /* @__PURE__ */ y.createElement(ji, ht({}, O, {
    showAction: C ? ["click"] : [],
    hideAction: C ? ["click"] : [],
    popupPlacement: v || (h === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: j,
    prefixCls: _,
    popupTransitionName: F,
    popup: /* @__PURE__ */ y.createElement("div", {
      onMouseEnter: I
    }, Z),
    ref: A,
    stretch: $,
    popupAlign: g,
    popupVisible: o,
    getPopupContainer: b,
    popupClassName: ut(m, le({}, "".concat(_, "-empty"), w)),
    popupStyle: E,
    getTriggerDOMNode: S,
    onPopupVisibleChange: C
  }), a);
}, wa = /* @__PURE__ */ y.forwardRef(Vl);
process.env.NODE_ENV !== "production" && (wa.displayName = "SelectTrigger");
function yo(e, t) {
  var n = e.key, r;
  return "value" in e && (r = e.value), n ?? (r !== void 0 ? r : "rc-index-key-".concat(t));
}
function Mr(e) {
  return typeof e < "u" && !Number.isNaN(e);
}
function Oa(e, t) {
  var n = e || {}, r = n.label, o = n.value, a = n.options, i = n.groupLabel, l = r || (t ? "children" : "label");
  return {
    label: l,
    value: o || "value",
    options: a || "options",
    groupLabel: i || l
  };
}
function zl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.fieldNames, r = t.childrenAsData, o = [], a = Oa(n, !1), i = a.label, l = a.value, u = a.options, p = a.groupLabel;
  function m(s, h) {
    Array.isArray(s) && s.forEach(function(v) {
      if (h || !(u in v)) {
        var c = v[l];
        o.push({
          key: yo(v, o.length),
          groupOption: h,
          data: v,
          label: v[i],
          value: c
        });
      } else {
        var f = v[p];
        f === void 0 && r && (f = v.label), o.push({
          key: yo(v, o.length),
          group: !0,
          data: v,
          label: f
        }), m(v[u], !0);
      }
    });
  }
  return m(e, !1), o;
}
function Pr(e) {
  var t = se({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return nt(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var Al = function(t, n, r) {
  if (!n || !n.length)
    return null;
  var o = !1, a = function l(u, p) {
    var m = Oi(p), s = m[0], h = m.slice(1);
    if (!s)
      return [u];
    var v = u.split(s);
    return o = o || v.length > 1, v.reduce(function(c, f) {
      return [].concat(ct(c), ct(l(f, h)));
    }, []).filter(Boolean);
  }, i = a(t, n);
  return o ? typeof r < "u" ? i.slice(0, r) : i : null;
}, zr = /* @__PURE__ */ y.createContext(null);
function Bl(e) {
  var t = e.visible, n = e.values;
  if (!t)
    return null;
  var r = 50;
  return /* @__PURE__ */ y.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(n.slice(0, r).map(function(o) {
    var a = o.label, i = o.value;
    return ["number", "string"].includes(Gt(a)) ? a : i;
  }).join(", ")), n.length > r ? ", ..." : null);
}
var Hl = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], Wl = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], zn = function(t) {
  return t === "tags" || t === "multiple";
}, Ar = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n, r = e.id, o = e.prefixCls, a = e.className, i = e.showSearch, l = e.tagRender, u = e.direction, p = e.omitDomProps, m = e.displayValues, s = e.onDisplayValuesChange, h = e.emptyOptions, v = e.notFoundContent, c = v === void 0 ? "Not Found" : v, f = e.onClear, d = e.mode, g = e.disabled, b = e.loading, w = e.getInputElement, S = e.getRawInputElement, C = e.open, I = e.defaultOpen, O = e.onDropdownVisibleChange, _ = e.activeValue, Z = e.onActiveValueChange, j = e.activeDescendantId, F = e.searchValue, N = e.autoClearSearchValue, $ = e.onSearch, E = e.onSearchSplit, A = e.tokenSeparators, G = e.allowClear, k = e.suffixIcon, P = e.clearIcon, z = e.OptionList, B = e.animation, ve = e.transitionName, ge = e.dropdownStyle, te = e.dropdownClassName, ce = e.dropdownMatchSelectWidth, ue = e.dropdownRender, ke = e.dropdownAlign, q = e.placement, he = e.builtinPlacements, ye = e.getPopupContainer, L = e.showAction, R = L === void 0 ? [] : L, M = e.onFocus, H = e.onBlur, T = e.onKeyUp, V = e.onKeyDown, ne = e.onMouseDown, we = qt(e, Hl), fe = zn(d), xe = (i !== void 0 ? i : fe) || d === "combobox", Ne = se({}, we);
  Wl.forEach(function(de) {
    delete Ne[de];
  }), p == null || p.forEach(function(de) {
    delete Ne[de];
  });
  var ze = y.useState(!1), Ae = oe(ze, 2), Be = Ae[0], pe = Ae[1];
  y.useEffect(function() {
    pe(Fi());
  }, []);
  var Ge = y.useRef(null), Me = y.useRef(null), Pe = y.useRef(null), Re = y.useRef(null), ot = y.useRef(null), Ve = y.useRef(!1), Le = Cl(), qe = oe(Le, 3), Qe = qe[0], Ze = qe[1], Rt = qe[2];
  y.useImperativeHandle(t, function() {
    var de, Q;
    return {
      focus: (de = Re.current) === null || de === void 0 ? void 0 : de.focus,
      blur: (Q = Re.current) === null || Q === void 0 ? void 0 : Q.blur,
      scrollTo: function(tt) {
        var Te;
        return (Te = ot.current) === null || Te === void 0 ? void 0 : Te.scrollTo(tt);
      },
      nativeElement: Ge.current || Me.current
    };
  });
  var Xe = y.useMemo(function() {
    var de;
    if (d !== "combobox")
      return F;
    var Q = (de = m[0]) === null || de === void 0 ? void 0 : de.value;
    return typeof Q == "string" || typeof Q == "number" ? String(Q) : "";
  }, [F, d, m]), He = d === "combobox" && typeof w == "function" && w() || null, $e = typeof S == "function" && S(), Xt = Ci(Me, $e == null || (n = $e.props) === null || n === void 0 ? void 0 : n.ref), on = y.useState(!1), Ut = oe(on, 2), an = Ut[0], ln = Ut[1];
  pn(function() {
    ln(!0);
  }, []);
  var $t = _r(!1, {
    defaultValue: I,
    value: C
  }), mt = oe($t, 2), It = mt[0], Dt = mt[1], De = an ? It : !1, Nt = !c && h;
  (g || Nt && De && d === "combobox") && (De = !1);
  var Lt = Nt ? !1 : De, W = y.useCallback(function(de) {
    var Q = de !== void 0 ? de : !De;
    g || (Dt(Q), De !== Q && (O == null || O(Q)));
  }, [g, De, Dt, O]), Y = y.useMemo(function() {
    return (A || []).some(function(de) {
      return [`
`, `\r
`].includes(de);
    });
  }, [A]), X = y.useContext(zr) || {}, J = X.maxCount, ae = X.rawValues, Oe = function(Q, et, tt) {
    if (!(fe && Mr(J) && (ae == null ? void 0 : ae.size) >= J)) {
      var Te = !0, Ue = Q;
      Z == null || Z(null);
      var St = Al(Q, A, Mr(J) ? J - ae.size : void 0), Tt = tt ? null : St;
      return d !== "combobox" && Tt && (Ue = "", E == null || E(Tt), W(!1), Te = !1), $ && Xe !== Ue && $(Ue, {
        source: et ? "typing" : "effect"
      }), Te;
    }
  }, vt = function(Q) {
    !Q || !Q.trim() || $(Q, {
      source: "submit"
    });
  };
  y.useEffect(function() {
    !De && !fe && d !== "combobox" && Oe("", !1, !1);
  }, [De]), y.useEffect(function() {
    It && g && Dt(!1), g && !Ve.current && Ze(!1);
  }, [g]);
  var at = ba(), xt = oe(at, 2), Ie = xt[0], pt = xt[1], K = function(Q) {
    var et = Ie(), tt = Q.which;
    if (tt === ee.ENTER && (d !== "combobox" && Q.preventDefault(), De || W(!0)), pt(!!Xe), tt === ee.BACKSPACE && !et && fe && !Xe && m.length) {
      for (var Te = ct(m), Ue = null, St = Te.length - 1; St >= 0; St -= 1) {
        var Tt = Te[St];
        if (!Tt.disabled) {
          Te.splice(St, 1), Ue = Tt;
          break;
        }
      }
      Ue && s(Te, {
        type: "remove",
        values: [Ue]
      });
    }
    for (var jt = arguments.length, sn = new Array(jt > 1 ? jt - 1 : 0), Ft = 1; Ft < jt; Ft++)
      sn[Ft - 1] = arguments[Ft];
    if (De) {
      var Dn;
      (Dn = ot.current) === null || Dn === void 0 || Dn.onKeyDown.apply(Dn, [Q].concat(sn));
    }
    V == null || V.apply(void 0, [Q].concat(sn));
  }, U = function(Q) {
    for (var et = arguments.length, tt = new Array(et > 1 ? et - 1 : 0), Te = 1; Te < et; Te++)
      tt[Te - 1] = arguments[Te];
    if (De) {
      var Ue;
      (Ue = ot.current) === null || Ue === void 0 || Ue.onKeyUp.apply(Ue, [Q].concat(tt));
    }
    T == null || T.apply(void 0, [Q].concat(tt));
  }, ie = function(Q) {
    var et = m.filter(function(tt) {
      return tt !== Q;
    });
    s(et, {
      type: "remove",
      values: [Q]
    });
  }, Ee = y.useRef(!1), We = function() {
    Ze(!0), g || (M && !Ee.current && M.apply(void 0, arguments), R.includes("focus") && W(!0)), Ee.current = !0;
  }, cr = function() {
    Ve.current = !0, Ze(!1, function() {
      Ee.current = !1, Ve.current = !1, W(!1);
    }), !g && (Xe && (d === "tags" ? $(Xe, {
      source: "submit"
    }) : d === "multiple" && $("", {
      source: "blur"
    })), H && H.apply(void 0, arguments));
  }, it = [];
  y.useEffect(function() {
    return function() {
      it.forEach(function(de) {
        return clearTimeout(de);
      }), it.splice(0, it.length);
    };
  }, []);
  var ur = function(Q) {
    var et, tt = Q.target, Te = (et = Pe.current) === null || et === void 0 ? void 0 : et.getPopupElement();
    if (Te && Te.contains(tt)) {
      var Ue = setTimeout(function() {
        var sn = it.indexOf(Ue);
        if (sn !== -1 && it.splice(sn, 1), Rt(), !Be && !Te.contains(document.activeElement)) {
          var Ft;
          (Ft = Re.current) === null || Ft === void 0 || Ft.focus();
        }
      });
      it.push(Ue);
    }
    for (var St = arguments.length, Tt = new Array(St > 1 ? St - 1 : 0), jt = 1; jt < St; jt++)
      Tt[jt - 1] = arguments[jt];
    ne == null || ne.apply(void 0, [Q].concat(Tt));
  }, dr = y.useState({}), $n = oe(dr, 2), xn = $n[1];
  function vi() {
    xn({});
  }
  var so;
  $e && (so = function(Q) {
    W(Q);
  }), Il(function() {
    var de;
    return [Ge.current, (de = Pe.current) === null || de === void 0 ? void 0 : de.getPopupElement()];
  }, Lt, W, !!$e);
  var pi = y.useMemo(function() {
    return se(se({}, e), {}, {
      notFoundContent: c,
      open: De,
      triggerOpen: Lt,
      id: r,
      showSearch: xe,
      multiple: fe,
      toggleOpen: W
    });
  }, [e, c, Lt, De, r, xe, fe, W]), co = !!k || b, uo;
  co && (uo = /* @__PURE__ */ y.createElement(Zn, {
    className: ut("".concat(o, "-arrow"), le({}, "".concat(o, "-arrow-loading"), b)),
    customizeIcon: k,
    customizeIconProps: {
      loading: b,
      searchValue: Xe,
      open: De,
      focused: Qe,
      showSearch: xe
    }
  }));
  var gi = function() {
    var Q;
    f == null || f(), (Q = Re.current) === null || Q === void 0 || Q.focus(), s([], {
      type: "clear",
      values: m
    }), Oe("", !1, !1);
  }, fo = Ol(o, gi, m, G, P, g, Xe, d), hi = fo.allowClear, yi = fo.clearIcon, bi = /* @__PURE__ */ y.createElement(z, {
    ref: ot
  }), xi = ut(o, a, le(le(le(le(le(le(le(le(le(le({}, "".concat(o, "-focused"), Qe), "".concat(o, "-multiple"), fe), "".concat(o, "-single"), !fe), "".concat(o, "-allow-clear"), G), "".concat(o, "-show-arrow"), co), "".concat(o, "-disabled"), g), "".concat(o, "-loading"), b), "".concat(o, "-open"), De), "".concat(o, "-customize-input"), He), "".concat(o, "-show-search"), xe)), mo = /* @__PURE__ */ y.createElement(wa, {
    ref: Pe,
    disabled: g,
    prefixCls: o,
    visible: Lt,
    popupElement: bi,
    animation: B,
    transitionName: ve,
    dropdownStyle: ge,
    dropdownClassName: te,
    direction: u,
    dropdownMatchSelectWidth: ce,
    dropdownRender: ue,
    dropdownAlign: ke,
    placement: q,
    builtinPlacements: he,
    getPopupContainer: ye,
    empty: h,
    getTriggerDOMNode: function(Q) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        Me.current || Q
      );
    },
    onPopupVisibleChange: so,
    onPopupMouseEnter: vi
  }, $e ? /* @__PURE__ */ y.cloneElement($e, {
    ref: Xt
  }) : /* @__PURE__ */ y.createElement(Sa, ht({}, e, {
    domRef: Me,
    prefixCls: o,
    inputElement: He,
    ref: Re,
    id: r,
    showSearch: xe,
    autoClearSearchValue: N,
    mode: d,
    activeDescendantId: j,
    tagRender: l,
    values: m,
    open: De,
    onToggleOpen: W,
    activeValue: _,
    searchValue: Xe,
    onSearch: Oe,
    onSearchSubmit: vt,
    onRemove: ie,
    tokenWithEnter: Y
  }))), fr;
  return $e ? fr = mo : fr = /* @__PURE__ */ y.createElement("div", ht({
    className: xi
  }, Ne, {
    ref: Ge,
    onMouseDown: ur,
    onKeyDown: K,
    onKeyUp: U,
    onFocus: We,
    onBlur: cr
  }), /* @__PURE__ */ y.createElement(Bl, {
    visible: Qe && !De,
    values: m
  }), mo, uo, hi && yi), /* @__PURE__ */ y.createElement(ha.Provider, {
    value: pi
  }, fr);
});
process.env.NODE_ENV !== "production" && (Ar.displayName = "BaseSelect");
var Br = function() {
  return null;
};
Br.isSelectOptGroup = !0;
var Hr = function() {
  return null;
};
Hr.isSelectOption = !0;
var Ca = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n = e.height, r = e.offsetY, o = e.offsetX, a = e.children, i = e.prefixCls, l = e.onInnerResize, u = e.innerProps, p = e.rtl, m = e.extra, s = {}, h = {
    display: "flex",
    flexDirection: "column"
  };
  return r !== void 0 && (s = {
    height: n,
    position: "relative",
    overflow: "hidden"
  }, h = se(se({}, h), {}, le(le(le(le(le({
    transform: "translateY(".concat(r, "px)")
  }, p ? "marginRight" : "marginLeft", -o), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ y.createElement("div", {
    style: s
  }, /* @__PURE__ */ y.createElement(sa, {
    onResize: function(c) {
      var f = c.offsetHeight;
      f && l && l();
    }
  }, /* @__PURE__ */ y.createElement("div", ht({
    style: h,
    className: ut(le({}, "".concat(i, "-holder-inner"), i)),
    ref: t
  }, u), a, m)));
});
Ca.displayName = "Filler";
function bo(e, t) {
  var n = "touches" in e ? e.touches[0] : e;
  return n[t ? "pageX" : "pageY"];
}
var Rr = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.rtl, o = e.scrollOffset, a = e.scrollRange, i = e.onStartMove, l = e.onStopMove, u = e.onScroll, p = e.horizontal, m = e.spinSize, s = e.containerSize, h = e.style, v = e.thumbStyle, c = y.useState(!1), f = oe(c, 2), d = f[0], g = f[1], b = y.useState(null), w = oe(b, 2), S = w[0], C = w[1], I = y.useState(null), O = oe(I, 2), _ = O[0], Z = O[1], j = !r, F = y.useRef(), N = y.useRef(), $ = y.useState(!1), E = oe($, 2), A = E[0], G = E[1], k = y.useRef(), P = function() {
    clearTimeout(k.current), G(!0), k.current = setTimeout(function() {
      G(!1);
    }, 3e3);
  }, z = a - s || 0, B = s - m || 0, ve = y.useMemo(function() {
    if (o === 0 || z === 0)
      return 0;
    var L = o / z;
    return L * B;
  }, [o, z, B]), ge = function(R) {
    R.stopPropagation(), R.preventDefault();
  }, te = y.useRef({
    top: ve,
    dragging: d,
    pageY: S,
    startTop: _
  });
  te.current = {
    top: ve,
    dragging: d,
    pageY: S,
    startTop: _
  };
  var ce = function(R) {
    g(!0), C(bo(R, p)), Z(te.current.top), i(), R.stopPropagation(), R.preventDefault();
  };
  y.useEffect(function() {
    var L = function(T) {
      T.preventDefault();
    }, R = F.current, M = N.current;
    return R.addEventListener("touchstart", L), M.addEventListener("touchstart", ce), function() {
      R.removeEventListener("touchstart", L), M.removeEventListener("touchstart", ce);
    };
  }, []);
  var ue = y.useRef();
  ue.current = z;
  var ke = y.useRef();
  ke.current = B, y.useEffect(function() {
    if (d) {
      var L, R = function(T) {
        var V = te.current, ne = V.dragging, we = V.pageY, fe = V.startTop;
        if (wt.cancel(L), ne) {
          var xe = bo(T, p) - we, Ne = fe;
          !j && p ? Ne -= xe : Ne += xe;
          var ze = ue.current, Ae = ke.current, Be = Ae ? Ne / Ae : 0, pe = Math.ceil(Be * ze);
          pe = Math.max(pe, 0), pe = Math.min(pe, ze), L = wt(function() {
            u(pe, p);
          });
        }
      }, M = function() {
        g(!1), l();
      };
      return window.addEventListener("mousemove", R), window.addEventListener("touchmove", R), window.addEventListener("mouseup", M), window.addEventListener("touchend", M), function() {
        window.removeEventListener("mousemove", R), window.removeEventListener("touchmove", R), window.removeEventListener("mouseup", M), window.removeEventListener("touchend", M), wt.cancel(L);
      };
    }
  }, [d]), y.useEffect(function() {
    P();
  }, [o]), y.useImperativeHandle(t, function() {
    return {
      delayHidden: P
    };
  });
  var q = "".concat(n, "-scrollbar"), he = {
    position: "absolute",
    visibility: A ? null : "hidden"
  }, ye = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return p ? (he.height = 8, he.left = 0, he.right = 0, he.bottom = 0, ye.height = "100%", ye.width = m, j ? ye.left = ve : ye.right = ve) : (he.width = 8, he.top = 0, he.bottom = 0, j ? he.right = 0 : he.left = 0, ye.width = "100%", ye.height = m, ye.top = ve), /* @__PURE__ */ y.createElement("div", {
    ref: F,
    className: ut(q, le(le(le({}, "".concat(q, "-horizontal"), p), "".concat(q, "-vertical"), !p), "".concat(q, "-visible"), A)),
    style: se(se({}, he), h),
    onMouseDown: ge,
    onMouseMove: P
  }, /* @__PURE__ */ y.createElement("div", {
    ref: N,
    className: ut("".concat(q, "-thumb"), le({}, "".concat(q, "-thumb-moving"), d)),
    style: se(se({}, ye), v),
    onMouseDown: ce
  }));
});
process.env.NODE_ENV !== "production" && (Rr.displayName = "ScrollBar");
function Gl(e) {
  var t = e.children, n = e.setRef, r = y.useCallback(function(o) {
    n(o);
  }, []);
  return /* @__PURE__ */ y.cloneElement(t, {
    ref: r
  });
}
function Kl(e, t, n, r, o, a, i) {
  var l = i.getKey;
  return e.slice(t, n + 1).map(function(u, p) {
    var m = t + p, s = a(u, m, {
      style: {
        width: r
      }
    }), h = l(u);
    return /* @__PURE__ */ y.createElement(Gl, {
      key: h,
      setRef: function(c) {
        return o(u, c);
      }
    }, s);
  });
}
var Zl = /* @__PURE__ */ function() {
  function e() {
    Ei(this, e), le(this, "maps", void 0), le(this, "id", 0), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return Ii(e, [{
    key: "set",
    value: function(n, r) {
      this.maps[n] = r, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
  }]), e;
}();
function Xl(e, t, n) {
  var r = y.useState(0), o = oe(r, 2), a = o[0], i = o[1], l = re(/* @__PURE__ */ new Map()), u = re(new Zl()), p = re();
  function m() {
    wt.cancel(p.current);
  }
  function s() {
    var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    m();
    var c = function() {
      l.current.forEach(function(d, g) {
        if (d && d.offsetParent) {
          var b = _i(d), w = b.offsetHeight;
          u.current.get(g) !== w && u.current.set(g, b.offsetHeight);
        }
      }), i(function(d) {
        return d + 1;
      });
    };
    v ? c() : p.current = wt(c);
  }
  function h(v, c) {
    var f = e(v), d = l.current.get(f);
    c ? (l.current.set(f, c), s()) : l.current.delete(f), !d != !c && (c ? t == null || t(v) : n == null || n(v));
  }
  return Se(function() {
    return m;
  }, []), [h, s, u.current, a];
}
var xo = 10;
function Ul(e, t, n, r, o, a, i, l) {
  var u = y.useRef(), p = y.useState(null), m = oe(p, 2), s = m[0], h = m[1];
  return pn(function() {
    if (s && s.times < xo) {
      if (!e.current) {
        h(function(z) {
          return se({}, z);
        });
        return;
      }
      a();
      var v = s.targetAlign, c = s.originAlign, f = s.index, d = s.offset, g = e.current.clientHeight, b = !1, w = v, S = null;
      if (g) {
        for (var C = v || c, I = 0, O = 0, _ = 0, Z = Math.min(t.length - 1, f), j = 0; j <= Z; j += 1) {
          var F = o(t[j]);
          O = I;
          var N = n.get(F);
          _ = O + (N === void 0 ? r : N), I = _;
        }
        for (var $ = C === "top" ? d : g - d, E = Z; E >= 0; E -= 1) {
          var A = o(t[E]), G = n.get(A);
          if (G === void 0) {
            b = !0;
            break;
          }
          if ($ -= G, $ <= 0)
            break;
        }
        switch (C) {
          case "top":
            S = O - d;
            break;
          case "bottom":
            S = _ - g + d;
            break;
          default: {
            var k = e.current.scrollTop, P = k + g;
            O < k ? w = "top" : _ > P && (w = "bottom");
          }
        }
        S !== null && i(S), S !== s.lastTop && (b = !0);
      }
      b && h(se(se({}, s), {}, {
        times: s.times + 1,
        targetAlign: w,
        lastTop: S
      }));
    } else
      process.env.NODE_ENV !== "production" && (s == null ? void 0 : s.times) === xo && nt(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [s, e.current]), function(v) {
    if (v == null) {
      l();
      return;
    }
    if (wt.cancel(u.current), typeof v == "number")
      i(v);
    else if (v && Gt(v) === "object") {
      var c, f = v.align;
      "index" in v ? c = v.index : c = t.findIndex(function(b) {
        return o(b) === v.key;
      });
      var d = v.offset, g = d === void 0 ? 0 : d;
      h({
        times: 0,
        index: c,
        offset: g,
        originAlign: f
      });
    }
  };
}
function Yl(e, t, n) {
  var r = e.length, o = t.length, a, i;
  if (r === 0 && o === 0)
    return null;
  r < o ? (a = e, i = t) : (a = t, i = e);
  var l = {
    __EMPTY_ITEM__: !0
  };
  function u(c) {
    return c !== void 0 ? n(c) : l;
  }
  for (var p = null, m = Math.abs(r - o) !== 1, s = 0; s < i.length; s += 1) {
    var h = u(a[s]), v = u(i[s]);
    if (h !== v) {
      p = s, m = m || h !== u(i[s + 1]);
      break;
    }
  }
  return p === null ? null : {
    index: p,
    multiple: m
  };
}
function Jl(e, t, n) {
  var r = y.useState(e), o = oe(r, 2), a = o[0], i = o[1], l = y.useState(null), u = oe(l, 2), p = u[0], m = u[1];
  return y.useEffect(function() {
    var s = Yl(a || [], e || [], t);
    (s == null ? void 0 : s.index) !== void 0 && (n == null || n(s.index), m(e[s.index])), i(e);
  }, [e]), [p];
}
var So = (typeof navigator > "u" ? "undefined" : Gt(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const Ia = function(e, t) {
  var n = re(!1), r = re(null);
  function o() {
    clearTimeout(r.current), n.current = !0, r.current = setTimeout(function() {
      n.current = !1;
    }, 50);
  }
  var a = re({
    top: e,
    bottom: t
  });
  return a.current.top = e, a.current.bottom = t, function(i) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, u = (
      // Pass origin wheel when on the top
      i < 0 && a.current.top || // Pass origin wheel when on the bottom
      i > 0 && a.current.bottom
    );
    return l && u ? (clearTimeout(r.current), n.current = !1) : (!u || n.current) && o(), !n.current && u;
  };
};
function ql(e, t, n, r, o) {
  var a = re(0), i = re(null), l = re(null), u = re(!1), p = Ia(t, n);
  function m(d, g) {
    wt.cancel(i.current), a.current += g, l.current = g, !p(g) && (So || d.preventDefault(), i.current = wt(function() {
      var b = u.current ? 10 : 1;
      o(a.current * b), a.current = 0;
    }));
  }
  function s(d, g) {
    o(g, !0), So || d.preventDefault();
  }
  var h = re(null), v = re(null);
  function c(d) {
    if (e) {
      wt.cancel(v.current), v.current = wt(function() {
        h.current = null;
      }, 2);
      var g = d.deltaX, b = d.deltaY, w = d.shiftKey, S = g, C = b;
      (h.current === "sx" || !h.current && w && b && !g) && (S = b, C = 0, h.current = "sx");
      var I = Math.abs(S), O = Math.abs(C);
      h.current === null && (h.current = r && I > O ? "x" : "y"), h.current === "y" ? m(d, C) : s(d, S);
    }
  }
  function f(d) {
    e && (u.current = d.detail === l.current);
  }
  return [c, f];
}
var Ql = 14 / 15;
function es(e, t, n) {
  var r = re(!1), o = re(0), a = re(null), i = re(null), l, u = function(h) {
    if (r.current) {
      var v = Math.ceil(h.touches[0].pageY), c = o.current - v;
      o.current = v, n(c) && h.preventDefault(), clearInterval(i.current), i.current = setInterval(function() {
        c *= Ql, (!n(c, !0) || Math.abs(c) <= 0.1) && clearInterval(i.current);
      }, 16);
    }
  }, p = function() {
    r.current = !1, l();
  }, m = function(h) {
    l(), h.touches.length === 1 && !r.current && (r.current = !0, o.current = Math.ceil(h.touches[0].pageY), a.current = h.target, a.current.addEventListener("touchmove", u), a.current.addEventListener("touchend", p));
  };
  l = function() {
    a.current && (a.current.removeEventListener("touchmove", u), a.current.removeEventListener("touchend", p));
  }, pn(function() {
    return e && t.current.addEventListener("touchstart", m), function() {
      var s;
      (s = t.current) === null || s === void 0 || s.removeEventListener("touchstart", m), l(), clearInterval(i.current);
    };
  }, [e]);
}
var ts = 20;
function wo() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = e / t * e;
  return isNaN(n) && (n = 0), n = Math.max(n, ts), Math.floor(n);
}
function ns(e, t, n, r) {
  var o = y.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, n.id, r]), a = oe(o, 2), i = a[0], l = a[1], u = function(m) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : m, h = i.get(m), v = i.get(s);
    if (h === void 0 || v === void 0)
      for (var c = e.length, f = l.length; f < c; f += 1) {
        var d, g = e[f], b = t(g);
        i.set(b, f);
        var w = (d = n.get(b)) !== null && d !== void 0 ? d : r;
        if (l[f] = (l[f - 1] || 0) + w, b === m && (h = f), b === s && (v = f), h !== void 0 && v !== void 0)
          break;
      }
    return {
      top: l[h - 1] || 0,
      bottom: l[v]
    };
  };
  return u;
}
var rs = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], os = [], as = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function is(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-virtual-list" : n, o = e.className, a = e.height, i = e.itemHeight, l = e.fullHeight, u = l === void 0 ? !0 : l, p = e.style, m = e.data, s = e.children, h = e.itemKey, v = e.virtual, c = e.direction, f = e.scrollWidth, d = e.component, g = d === void 0 ? "div" : d, b = e.onScroll, w = e.onVirtualScroll, S = e.onVisibleChange, C = e.innerProps, I = e.extraRender, O = e.styles, _ = qt(e, rs), Z = !!(v !== !1 && a && i), j = Z && m && (i * m.length > a || !!f), F = c === "rtl", N = ut(r, le({}, "".concat(r, "-rtl"), F), o), $ = m || os, E = re(), A = re(), G = me(0), k = oe(G, 2), P = k[0], z = k[1], B = me(0), ve = oe(B, 2), ge = ve[0], te = ve[1], ce = me(!1), ue = oe(ce, 2), ke = ue[0], q = ue[1], he = function() {
    q(!0);
  }, ye = function() {
    q(!1);
  }, L = y.useCallback(function(K) {
    return typeof h == "function" ? h(K) : K == null ? void 0 : K[h];
  }, [h]), R = {
    getKey: L
  };
  function M(K) {
    z(function(U) {
      var ie;
      typeof K == "function" ? ie = K(U) : ie = K;
      var Ee = on(ie);
      return E.current.scrollTop = Ee, Ee;
    });
  }
  var H = re({
    start: 0,
    end: $.length
  }), T = re(), V = Jl($, L), ne = oe(V, 1), we = ne[0];
  T.current = we;
  var fe = Xl(L, null, null), xe = oe(fe, 4), Ne = xe[0], ze = xe[1], Ae = xe[2], Be = xe[3], pe = y.useMemo(function() {
    if (!Z)
      return {
        scrollHeight: void 0,
        start: 0,
        end: $.length - 1,
        offset: void 0
      };
    if (!j) {
      var K;
      return {
        scrollHeight: ((K = A.current) === null || K === void 0 ? void 0 : K.offsetHeight) || 0,
        start: 0,
        end: $.length - 1,
        offset: void 0
      };
    }
    for (var U = 0, ie, Ee, We, cr = $.length, it = 0; it < cr; it += 1) {
      var ur = $[it], dr = L(ur), $n = Ae.get(dr), xn = U + ($n === void 0 ? i : $n);
      xn >= P && ie === void 0 && (ie = it, Ee = U), xn > P + a && We === void 0 && (We = it), U = xn;
    }
    return ie === void 0 && (ie = 0, Ee = 0, We = Math.ceil(a / i)), We === void 0 && (We = $.length - 1), We = Math.min(We + 1, $.length - 1), {
      scrollHeight: U,
      start: ie,
      end: We,
      offset: Ee
    };
  }, [j, Z, P, $, Be, a]), Ge = pe.scrollHeight, Me = pe.start, Pe = pe.end, Re = pe.offset;
  H.current.start = Me, H.current.end = Pe;
  var ot = y.useState({
    width: 0,
    height: a
  }), Ve = oe(ot, 2), Le = Ve[0], qe = Ve[1], Qe = function(U) {
    qe({
      width: U.width || U.offsetWidth,
      height: U.height || U.offsetHeight
    });
  }, Ze = re(), Rt = re(), Xe = y.useMemo(function() {
    return wo(Le.width, f);
  }, [Le.width, f]), He = y.useMemo(function() {
    return wo(Le.height, Ge);
  }, [Le.height, Ge]), $e = Ge - a, Xt = re($e);
  Xt.current = $e;
  function on(K) {
    var U = K;
    return Number.isNaN(Xt.current) || (U = Math.min(U, Xt.current)), U = Math.max(U, 0), U;
  }
  var Ut = P <= 0, an = P >= $e, ln = Ia(Ut, an), $t = function() {
    return {
      x: F ? -ge : ge,
      y: P
    };
  }, mt = re($t()), It = po(function() {
    if (w) {
      var K = $t();
      (mt.current.x !== K.x || mt.current.y !== K.y) && (w(K), mt.current = K);
    }
  });
  function Dt(K, U) {
    var ie = K;
    U ? (kn.flushSync(function() {
      te(ie);
    }), It()) : M(ie);
  }
  function De(K) {
    var U = K.currentTarget.scrollTop;
    U !== P && M(U), b == null || b(K), It();
  }
  var Nt = function(U) {
    var ie = U, Ee = f - Le.width;
    return ie = Math.max(ie, 0), ie = Math.min(ie, Ee), ie;
  }, Lt = po(function(K, U) {
    U ? (kn.flushSync(function() {
      te(function(ie) {
        var Ee = ie + (F ? -K : K);
        return Nt(Ee);
      });
    }), It()) : M(function(ie) {
      var Ee = ie + K;
      return Ee;
    });
  }), W = ql(Z, Ut, an, !!f, Lt), Y = oe(W, 2), X = Y[0], J = Y[1];
  es(Z, E, function(K, U) {
    return ln(K, U) ? !1 : (X({
      preventDefault: function() {
      },
      deltaY: K
    }), !0);
  }), pn(function() {
    function K(ie) {
      Z && ie.preventDefault();
    }
    var U = E.current;
    return U.addEventListener("wheel", X), U.addEventListener("DOMMouseScroll", J), U.addEventListener("MozMousePixelScroll", K), function() {
      U.removeEventListener("wheel", X), U.removeEventListener("DOMMouseScroll", J), U.removeEventListener("MozMousePixelScroll", K);
    };
  }, [Z]), pn(function() {
    f && te(function(K) {
      return Nt(K);
    });
  }, [Le.width, f]);
  var ae = function() {
    var U, ie;
    (U = Ze.current) === null || U === void 0 || U.delayHidden(), (ie = Rt.current) === null || ie === void 0 || ie.delayHidden();
  }, Oe = Ul(E, $, Ae, i, L, function() {
    return ze(!0);
  }, M, ae);
  y.useImperativeHandle(t, function() {
    return {
      getScrollInfo: $t,
      scrollTo: function(U) {
        function ie(Ee) {
          return Ee && Gt(Ee) === "object" && ("left" in Ee || "top" in Ee);
        }
        ie(U) ? (U.left !== void 0 && te(Nt(U.left)), Oe(U.top)) : Oe(U);
      }
    };
  }), pn(function() {
    if (S) {
      var K = $.slice(Me, Pe + 1);
      S(K, $);
    }
  }, [Me, Pe, $]);
  var vt = ns($, L, Ae, i), at = I == null ? void 0 : I({
    start: Me,
    end: Pe,
    virtual: j,
    offsetX: ge,
    offsetY: Re,
    rtl: F,
    getSize: vt
  }), xt = Kl($, Me, Pe, f, Ne, s, R), Ie = null;
  a && (Ie = se(le({}, u ? "height" : "maxHeight", a), as), Z && (Ie.overflowY = "hidden", f && (Ie.overflowX = "hidden"), ke && (Ie.pointerEvents = "none")));
  var pt = {};
  return F && (pt.dir = "rtl"), /* @__PURE__ */ y.createElement("div", ht({
    style: se(se({}, p), {}, {
      position: "relative"
    }),
    className: N
  }, pt, _), /* @__PURE__ */ y.createElement(sa, {
    onResize: Qe
  }, /* @__PURE__ */ y.createElement(g, {
    className: "".concat(r, "-holder"),
    style: Ie,
    ref: E,
    onScroll: De,
    onMouseEnter: ae
  }, /* @__PURE__ */ y.createElement(Ca, {
    prefixCls: r,
    height: Ge,
    offsetX: ge,
    offsetY: Re,
    scrollWidth: f,
    onInnerResize: ze,
    ref: A,
    innerProps: C,
    rtl: F,
    extra: at
  }, xt))), j && Ge > a && /* @__PURE__ */ y.createElement(Rr, {
    ref: Ze,
    prefixCls: r,
    scrollOffset: P,
    scrollRange: Ge,
    rtl: F,
    onScroll: Dt,
    onStartMove: he,
    onStopMove: ye,
    spinSize: He,
    containerSize: Le.height,
    style: O == null ? void 0 : O.verticalScrollBar,
    thumbStyle: O == null ? void 0 : O.verticalScrollBarThumb
  }), j && f > Le.width && /* @__PURE__ */ y.createElement(Rr, {
    ref: Rt,
    prefixCls: r,
    scrollOffset: ge,
    scrollRange: f,
    rtl: F,
    onScroll: Dt,
    onStartMove: he,
    onStopMove: ye,
    spinSize: Xe,
    containerSize: Le.width,
    horizontal: !0,
    style: O == null ? void 0 : O.horizontalScrollBar,
    thumbStyle: O == null ? void 0 : O.horizontalScrollBarThumb
  }));
}
var Ea = /* @__PURE__ */ y.forwardRef(is);
Ea.displayName = "List";
function ls() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var ss = ["disabled", "title", "children", "style", "className"];
function Oo(e) {
  return typeof e == "string" || typeof e == "number";
}
var cs = function(t, n) {
  var r = ya(), o = r.prefixCls, a = r.id, i = r.open, l = r.multiple, u = r.mode, p = r.searchValue, m = r.toggleOpen, s = r.notFoundContent, h = r.onPopupScroll, v = y.useContext(zr), c = v.maxCount, f = v.flattenOptions, d = v.onActiveValue, g = v.defaultActiveFirstOption, b = v.onSelect, w = v.menuItemSelectedIcon, S = v.rawValues, C = v.fieldNames, I = v.virtual, O = v.direction, _ = v.listHeight, Z = v.listItemHeight, j = v.optionRender, F = "".concat(o, "-item"), N = Mi(function() {
    return f;
  }, [i, f], function(L, R) {
    return R[0] && L[1] !== R[1];
  }), $ = y.useRef(null), E = y.useMemo(function() {
    return l && Mr(c) && (S == null ? void 0 : S.size) >= c;
  }, [l, c, S == null ? void 0 : S.size]), A = function(R) {
    R.preventDefault();
  }, G = function(R) {
    var M;
    (M = $.current) === null || M === void 0 || M.scrollTo(typeof R == "number" ? {
      index: R
    } : R);
  }, k = function(R) {
    for (var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, H = N.length, T = 0; T < H; T += 1) {
      var V = (R + T * M + H) % H, ne = N[V] || {}, we = ne.group, fe = ne.data;
      if (!we && !(fe != null && fe.disabled) && !E)
        return V;
    }
    return -1;
  }, P = y.useState(function() {
    return k(0);
  }), z = oe(P, 2), B = z[0], ve = z[1], ge = function(R) {
    var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    ve(R);
    var H = {
      source: M ? "keyboard" : "mouse"
    }, T = N[R];
    if (!T) {
      d(null, -1, H);
      return;
    }
    d(T.value, R, H);
  };
  Se(function() {
    ge(g !== !1 ? k(0) : -1);
  }, [N.length, p]);
  var te = y.useCallback(function(L) {
    return S.has(L) && u !== "combobox";
  }, [u, ct(S).toString(), S.size]);
  Se(function() {
    var L = setTimeout(function() {
      if (!l && i && S.size === 1) {
        var M = Array.from(S)[0], H = N.findIndex(function(T) {
          var V = T.data;
          return V.value === M;
        });
        H !== -1 && (ge(H), G(H));
      }
    });
    if (i) {
      var R;
      (R = $.current) === null || R === void 0 || R.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(L);
    };
  }, [i, p]);
  var ce = function(R) {
    R !== void 0 && b(R, {
      selected: !S.has(R)
    }), l || m(!1);
  };
  if (y.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(R) {
        var M = R.which, H = R.ctrlKey;
        switch (M) {
          case ee.N:
          case ee.P:
          case ee.UP:
          case ee.DOWN: {
            var T = 0;
            if (M === ee.UP ? T = -1 : M === ee.DOWN ? T = 1 : ls() && H && (M === ee.N ? T = 1 : M === ee.P && (T = -1)), T !== 0) {
              var V = k(B + T, T);
              G(V), ge(V, !0);
            }
            break;
          }
          case ee.ENTER: {
            var ne, we = N[B];
            we && !(we != null && (ne = we.data) !== null && ne !== void 0 && ne.disabled) && !E ? ce(we.value) : ce(void 0), i && R.preventDefault();
            break;
          }
          case ee.ESC:
            m(!1), i && R.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(R) {
        G(R);
      }
    };
  }), N.length === 0)
    return /* @__PURE__ */ y.createElement("div", {
      role: "listbox",
      id: "".concat(a, "_list"),
      className: "".concat(F, "-empty"),
      onMouseDown: A
    }, s);
  var ue = Object.keys(C).map(function(L) {
    return C[L];
  }), ke = function(R) {
    return R.label;
  };
  function q(L, R) {
    var M = L.group;
    return {
      role: M ? "presentation" : "option",
      id: "".concat(a, "_list_").concat(R)
    };
  }
  var he = function(R) {
    var M = N[R];
    if (!M)
      return null;
    var H = M.data || {}, T = H.value, V = M.group, ne = Vn(H, !0), we = ke(M);
    return M ? /* @__PURE__ */ y.createElement("div", ht({
      "aria-label": typeof we == "string" && !V ? we : null
    }, ne, {
      key: R
    }, q(M, R), {
      "aria-selected": te(T)
    }), T) : null;
  }, ye = {
    role: "listbox",
    id: "".concat(a, "_list")
  };
  return /* @__PURE__ */ y.createElement(y.Fragment, null, I && /* @__PURE__ */ y.createElement("div", ht({}, ye, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), he(B - 1), he(B), he(B + 1)), /* @__PURE__ */ y.createElement(Ea, {
    itemKey: "key",
    ref: $,
    data: N,
    height: _,
    itemHeight: Z,
    fullHeight: !1,
    onMouseDown: A,
    onScroll: h,
    virtual: I,
    direction: O,
    innerProps: I ? null : ye
  }, function(L, R) {
    var M = L.group, H = L.groupOption, T = L.data, V = L.label, ne = L.value, we = T.key;
    if (M) {
      var fe, xe = (fe = T.title) !== null && fe !== void 0 ? fe : Oo(V) ? V.toString() : void 0;
      return /* @__PURE__ */ y.createElement("div", {
        className: ut(F, "".concat(F, "-group"), T.className),
        title: xe
      }, V !== void 0 ? V : we);
    }
    var Ne = T.disabled, ze = T.title;
    T.children;
    var Ae = T.style, Be = T.className, pe = qt(T, ss), Ge = ki(pe, ue), Me = te(ne), Pe = Ne || !Me && E, Re = "".concat(F, "-option"), ot = ut(F, Re, Be, le(le(le(le({}, "".concat(Re, "-grouped"), H), "".concat(Re, "-active"), B === R && !Pe), "".concat(Re, "-disabled"), Pe), "".concat(Re, "-selected"), Me)), Ve = ke(L), Le = !w || typeof w == "function" || Me, qe = typeof Ve == "number" ? Ve : Ve || ne, Qe = Oo(qe) ? qe.toString() : void 0;
    return ze !== void 0 && (Qe = ze), /* @__PURE__ */ y.createElement("div", ht({}, Vn(Ge), I ? {} : q(L, R), {
      "aria-selected": Me,
      className: ot,
      title: Qe,
      onMouseMove: function() {
        B === R || Pe || ge(R);
      },
      onClick: function() {
        Pe || ce(ne);
      },
      style: Ae
    }), /* @__PURE__ */ y.createElement("div", {
      className: "".concat(Re, "-content")
    }, typeof j == "function" ? j(L, {
      index: R
    }) : qe), /* @__PURE__ */ y.isValidElement(w) || Me, Le && /* @__PURE__ */ y.createElement(Zn, {
      className: "".concat(F, "-option-state"),
      customizeIcon: w,
      customizeIconProps: {
        value: ne,
        disabled: Pe,
        isSelected: Me
      }
    }, Me ? "✓" : null));
  }));
}, _a = /* @__PURE__ */ y.forwardRef(cs);
process.env.NODE_ENV !== "production" && (_a.displayName = "OptionList");
const us = function(e, t) {
  var n = y.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), r = y.useMemo(function() {
    var a = n.current, i = a.values, l = a.options, u = e.map(function(s) {
      if (s.label === void 0) {
        var h;
        return se(se({}, s), {}, {
          label: (h = i.get(s.value)) === null || h === void 0 ? void 0 : h.label
        });
      }
      return s;
    }), p = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Map();
    return u.forEach(function(s) {
      p.set(s.value, s), m.set(s.value, t.get(s.value) || l.get(s.value));
    }), n.current.values = p, n.current.options = m, u;
  }, [e, t]), o = y.useCallback(function(a) {
    return t.get(a) || n.current.options.get(a);
  }, [t]);
  return [r, o];
};
function vr(e, t) {
  return Vr(e).join("").toUpperCase().includes(t);
}
const ds = function(e, t, n, r, o) {
  return y.useMemo(function() {
    if (!n || r === !1)
      return e;
    var a = t.options, i = t.label, l = t.value, u = [], p = typeof r == "function", m = n.toUpperCase(), s = p ? r : function(v, c) {
      return o ? vr(c[o], m) : c[a] ? vr(c[i !== "children" ? i : "label"], m) : vr(c[l], m);
    }, h = p ? function(v) {
      return Pr(v);
    } : function(v) {
      return v;
    };
    return e.forEach(function(v) {
      if (v[a]) {
        var c = s(n, h(v));
        if (c)
          u.push(v);
        else {
          var f = v[a].filter(function(d) {
            return s(n, h(d));
          });
          f.length && u.push(se(se({}, v), {}, le({}, a, f)));
        }
        return;
      }
      s(n, h(v)) && u.push(v);
    }), u;
  }, [e, r, o, n, t]);
};
var Co = 0, fs = process.env.NODE_ENV !== "test" && Pi();
function ms() {
  var e;
  return fs ? (e = Co, Co += 1) : e = "TEST_OR_SSR", e;
}
function vs(e) {
  var t = y.useState(), n = oe(t, 2), r = n[0], o = n[1];
  return y.useEffect(function() {
    o("rc_select_".concat(ms()));
  }, []), e || r;
}
var ps = ["children", "value"], gs = ["children"];
function hs(e) {
  var t = e, n = t.key, r = t.props, o = r.children, a = r.value, i = qt(r, ps);
  return se({
    key: n,
    value: a !== void 0 ? a : n,
    children: o
  }, i);
}
function Wr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return Ir(e).map(function(n, r) {
    if (!/* @__PURE__ */ y.isValidElement(n) || !n.type)
      return null;
    var o = n, a = o.type.isSelectOptGroup, i = o.key, l = o.props, u = l.children, p = qt(l, gs);
    return t || !a ? hs(n) : se(se({
      key: "__RC_SELECT_GRP__".concat(i === null ? r : i, "__"),
      label: i
    }, p), {}, {
      options: Wr(u)
    });
  }).filter(function(n) {
    return n;
  });
}
var ys = function(t, n, r, o, a) {
  return y.useMemo(function() {
    var i = t, l = !t;
    l && (i = Wr(n));
    var u = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), m = function(v, c, f) {
      f && typeof f == "string" && v.set(c[f], c);
    }, s = function h(v) {
      for (var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, f = 0; f < v.length; f += 1) {
        var d = v[f];
        !d[r.options] || c ? (u.set(d[r.value], d), m(p, d, r.label), m(p, d, o), m(p, d, a)) : h(d[r.options], !0);
      }
    };
    return s(i), {
      options: i,
      valueOptions: u,
      labelOptions: p
    };
  }, [t, n, r, o, a]);
};
function Io(e) {
  var t = y.useRef();
  t.current = e;
  var n = y.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return n;
}
function bs(e) {
  var t = e.mode, n = e.options, r = e.children, o = e.backfill, a = e.allowClear, i = e.placeholder, l = e.getInputElement, u = e.showSearch, p = e.onSearch, m = e.defaultOpen, s = e.autoFocus, h = e.labelInValue, v = e.value, c = e.inputValue, f = e.optionLabelProp, d = zn(t), g = u !== void 0 ? u : d || t === "combobox", b = n || Wr(r);
  if (nt(t !== "tags" || b.every(function(I) {
    return !I.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var w = b.some(function(I) {
      return I.options ? I.options.some(function(O) {
        return typeof ("value" in O ? O.value : O.key) == "number";
      }) : typeof ("value" in I ? I.value : I.key) == "number";
    });
    nt(!w, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (nt(t !== "combobox" || !f, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), nt(t === "combobox" || !o, "`backfill` only works with `combobox` mode."), nt(t === "combobox" || !l, "`getInputElement` only work with `combobox` mode."), vo(t !== "combobox" || !l || !a || !i, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), p && !g && t !== "combobox" && t !== "tags" && nt(!1, "`onSearch` should work with `showSearch` instead of use alone."), vo(!m || s, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), v != null) {
    var S = Vr(v);
    nt(!h || S.every(function(I) {
      return Gt(I) === "object" && ("key" in I || "value" in I);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), nt(!d || Array.isArray(v), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (r) {
    var C = null;
    Ir(r).some(function(I) {
      if (!/* @__PURE__ */ y.isValidElement(I) || !I.type)
        return !1;
      var O = I, _ = O.type;
      if (_.isSelectOption)
        return !1;
      if (_.isSelectOptGroup) {
        var Z = Ir(I.props.children).every(function(j) {
          return !/* @__PURE__ */ y.isValidElement(j) || !I.type || j.type.isSelectOption ? !0 : (C = j.type, !1);
        });
        return !Z;
      }
      return C = _, !0;
    }), C && nt(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(C.displayName || C.name || C, "`.")), nt(c === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function xs(e, t) {
  if (e) {
    var n = function r(o) {
      for (var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = 0; i < o.length; i++) {
        var l = o[i];
        if (l[t == null ? void 0 : t.value] === null)
          return nt(!1, "`value` in Select options should not be `null`."), !0;
        if (!a && Array.isArray(l[t == null ? void 0 : t.options]) && r(l[t == null ? void 0 : t.options], !0))
          break;
      }
    };
    n(e);
  }
}
var Ss = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], ws = ["inputValue"];
function Os(e) {
  return !e || Gt(e) !== "object";
}
var Ma = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n = e.id, r = e.mode, o = e.prefixCls, a = o === void 0 ? "rc-select" : o, i = e.backfill, l = e.fieldNames, u = e.inputValue, p = e.searchValue, m = e.onSearch, s = e.autoClearSearchValue, h = s === void 0 ? !0 : s, v = e.onSelect, c = e.onDeselect, f = e.dropdownMatchSelectWidth, d = f === void 0 ? !0 : f, g = e.filterOption, b = e.filterSort, w = e.optionFilterProp, S = e.optionLabelProp, C = e.options, I = e.optionRender, O = e.children, _ = e.defaultActiveFirstOption, Z = e.menuItemSelectedIcon, j = e.virtual, F = e.direction, N = e.listHeight, $ = N === void 0 ? 200 : N, E = e.listItemHeight, A = E === void 0 ? 20 : E, G = e.labelRender, k = e.value, P = e.defaultValue, z = e.labelInValue, B = e.onChange, ve = e.maxCount, ge = qt(e, Ss), te = vs(n), ce = zn(r), ue = !!(!C && O), ke = y.useMemo(function() {
    return g === void 0 && r === "combobox" ? !1 : g;
  }, [g, r]), q = y.useMemo(
    function() {
      return Oa(l, ue);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(l),
      ue
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), he = _r("", {
    value: p !== void 0 ? p : u,
    postState: function(Y) {
      return Y || "";
    }
  }), ye = oe(he, 2), L = ye[0], R = ye[1], M = ys(C, O, q, w, S), H = M.valueOptions, T = M.labelOptions, V = M.options, ne = y.useCallback(function(W) {
    var Y = Vr(W);
    return Y.map(function(X) {
      var J, ae, Oe, vt, at;
      if (Os(X))
        J = X;
      else {
        var xt;
        Oe = X.key, ae = X.label, J = (xt = X.value) !== null && xt !== void 0 ? xt : Oe;
      }
      var Ie = H.get(J);
      if (Ie) {
        var pt;
        if (ae === void 0 && (ae = Ie == null ? void 0 : Ie[S || q.label]), Oe === void 0 && (Oe = (pt = Ie == null ? void 0 : Ie.key) !== null && pt !== void 0 ? pt : J), vt = Ie == null ? void 0 : Ie.disabled, at = Ie == null ? void 0 : Ie.title, process.env.NODE_ENV !== "production" && !S) {
          var K = Ie == null ? void 0 : Ie[q.label];
          K !== void 0 && !/* @__PURE__ */ y.isValidElement(K) && !/* @__PURE__ */ y.isValidElement(ae) && K !== ae && nt(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: ae,
        value: J,
        key: Oe,
        disabled: vt,
        title: at
      };
    });
  }, [q, S, H]), we = _r(P, {
    value: k
  }), fe = oe(we, 2), xe = fe[0], Ne = fe[1], ze = y.useMemo(function() {
    var W, Y = ce && xe === null ? [] : xe, X = ne(Y);
    return r === "combobox" && $l((W = X[0]) === null || W === void 0 ? void 0 : W.value) ? [] : X;
  }, [xe, ne, r, ce]), Ae = us(ze, H), Be = oe(Ae, 2), pe = Be[0], Ge = Be[1], Me = y.useMemo(function() {
    if (!r && pe.length === 1) {
      var W = pe[0];
      if (W.value === null && (W.label === null || W.label === void 0))
        return [];
    }
    return pe.map(function(Y) {
      var X;
      return se(se({}, Y), {}, {
        label: (X = typeof G == "function" ? G(Y) : Y.label) !== null && X !== void 0 ? X : Y.value
      });
    });
  }, [r, pe, G]), Pe = y.useMemo(function() {
    return new Set(pe.map(function(W) {
      return W.value;
    }));
  }, [pe]);
  y.useEffect(function() {
    if (r === "combobox") {
      var W, Y = (W = pe[0]) === null || W === void 0 ? void 0 : W.value;
      R(Rl(Y) ? String(Y) : "");
    }
  }, [pe]);
  var Re = Io(function(W, Y) {
    var X = Y ?? W;
    return le(le({}, q.value, W), q.label, X);
  }), ot = y.useMemo(function() {
    if (r !== "tags")
      return V;
    var W = ct(V), Y = function(J) {
      return H.has(J);
    };
    return ct(pe).sort(function(X, J) {
      return X.value < J.value ? -1 : 1;
    }).forEach(function(X) {
      var J = X.value;
      Y(J) || W.push(Re(J, X.label));
    }), W;
  }, [Re, V, H, pe, r]), Ve = ds(ot, q, L, ke, w), Le = y.useMemo(function() {
    return r !== "tags" || !L || Ve.some(function(W) {
      return W[w || "value"] === L;
    }) || Ve.some(function(W) {
      return W[q.value] === L;
    }) ? Ve : [Re(L)].concat(ct(Ve));
  }, [Re, w, r, Ve, L, q]), qe = y.useMemo(function() {
    return b ? ct(Le).sort(function(W, Y) {
      return b(W, Y);
    }) : Le;
  }, [Le, b]), Qe = y.useMemo(function() {
    return zl(qe, {
      fieldNames: q,
      childrenAsData: ue
    });
  }, [qe, q, ue]), Ze = function(Y) {
    var X = ne(Y);
    if (Ne(X), B && // Trigger event only when value changed
    (X.length !== pe.length || X.some(function(Oe, vt) {
      var at;
      return ((at = pe[vt]) === null || at === void 0 ? void 0 : at.value) !== (Oe == null ? void 0 : Oe.value);
    }))) {
      var J = z ? X : X.map(function(Oe) {
        return Oe.value;
      }), ae = X.map(function(Oe) {
        return Pr(Ge(Oe.value));
      });
      B(
        // Value
        ce ? J : J[0],
        // Option
        ce ? ae : ae[0]
      );
    }
  }, Rt = y.useState(null), Xe = oe(Rt, 2), He = Xe[0], $e = Xe[1], Xt = y.useState(0), on = oe(Xt, 2), Ut = on[0], an = on[1], ln = _ !== void 0 ? _ : r !== "combobox", $t = y.useCallback(function(W, Y) {
    var X = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, J = X.source, ae = J === void 0 ? "keyboard" : J;
    an(Y), i && r === "combobox" && W !== null && ae === "keyboard" && $e(String(W));
  }, [i, r]), mt = function(Y, X, J) {
    var ae = function() {
      var Ee, We = Ge(Y);
      return [z ? {
        label: We == null ? void 0 : We[q.label],
        value: Y,
        key: (Ee = We == null ? void 0 : We.key) !== null && Ee !== void 0 ? Ee : Y
      } : Y, Pr(We)];
    };
    if (X && v) {
      var Oe = ae(), vt = oe(Oe, 2), at = vt[0], xt = vt[1];
      v(at, xt);
    } else if (!X && c && J !== "clear") {
      var Ie = ae(), pt = oe(Ie, 2), K = pt[0], U = pt[1];
      c(K, U);
    }
  }, It = Io(function(W, Y) {
    var X, J = ce ? Y.selected : !0;
    J ? X = ce ? [].concat(ct(pe), [W]) : [W] : X = pe.filter(function(ae) {
      return ae.value !== W;
    }), Ze(X), mt(W, J), r === "combobox" ? $e("") : (!zn || h) && (R(""), $e(""));
  }), Dt = function(Y, X) {
    Ze(Y);
    var J = X.type, ae = X.values;
    (J === "remove" || J === "clear") && ae.forEach(function(Oe) {
      mt(Oe.value, !1, J);
    });
  }, De = function(Y, X) {
    if (R(Y), $e(null), X.source === "submit") {
      var J = (Y || "").trim();
      if (J) {
        var ae = Array.from(new Set([].concat(ct(Pe), [J])));
        Ze(ae), mt(J, !0), R("");
      }
      return;
    }
    X.source !== "blur" && (r === "combobox" && Ze(Y), m == null || m(Y));
  }, Nt = function(Y) {
    var X = Y;
    r !== "tags" && (X = Y.map(function(ae) {
      var Oe = T.get(ae);
      return Oe == null ? void 0 : Oe.value;
    }).filter(function(ae) {
      return ae !== void 0;
    }));
    var J = Array.from(new Set([].concat(ct(Pe), ct(X))));
    Ze(J), J.forEach(function(ae) {
      mt(ae, !0);
    });
  }, Lt = y.useMemo(function() {
    var W = j !== !1 && d !== !1;
    return se(se({}, M), {}, {
      flattenOptions: Qe,
      onActiveValue: $t,
      defaultActiveFirstOption: ln,
      onSelect: It,
      menuItemSelectedIcon: Z,
      rawValues: Pe,
      fieldNames: q,
      virtual: W,
      direction: F,
      listHeight: $,
      listItemHeight: A,
      childrenAsData: ue,
      maxCount: ve,
      optionRender: I
    });
  }, [ve, M, Qe, $t, ln, It, Z, Pe, q, j, d, F, $, A, ue, I]);
  return process.env.NODE_ENV !== "production" && (bs(e), xs(V, q)), /* @__PURE__ */ y.createElement(zr.Provider, {
    value: Lt
  }, /* @__PURE__ */ y.createElement(Ar, ht({}, ge, {
    // >>> MISC
    id: te,
    prefixCls: a,
    ref: t,
    omitDomProps: ws,
    mode: r,
    displayValues: Me,
    onDisplayValuesChange: Dt,
    direction: F,
    searchValue: L,
    onSearch: De,
    autoClearSearchValue: h,
    onSearchSplit: Nt,
    dropdownMatchSelectWidth: d,
    OptionList: _a,
    emptyOptions: !Qe.length,
    activeValue: He,
    activeDescendantId: "".concat(te, "_list_").concat(Ut)
  })));
});
process.env.NODE_ENV !== "production" && (Ma.displayName = "Select");
var Gr = Ma;
Gr.Option = Hr;
Gr.OptGroup = Br;
const Cs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseSelect: Ar,
  OptGroup: Br,
  Option: Hr,
  default: Gr,
  useBaseProps: ya
}, Symbol.toStringTag, { value: "Module" }));
var Kr = {};
const Is = /* @__PURE__ */ Ri(Cs);
var Mt = {}, Xn = {}, Es = yt.default;
Object.defineProperty(Xn, "__esModule", {
  value: !0
});
Xn.default = void 0;
var _s = Es(Ke);
const Pa = /* @__PURE__ */ _s.default.createContext(void 0);
process.env.NODE_ENV !== "production" && (Pa.displayName = "zIndexContext");
Xn.default = Pa;
var Zr = yt.default;
Object.defineProperty(Mt, "__esModule", {
  value: !0
});
Mt.containerBaseZIndexOffset = Mt.consumerBaseZIndexOffset = Mt.CONTAINER_MAX_OFFSET = void 0;
Mt.useZIndex = Ts;
var Ms = Zr(Ke), Ps = Zr(il), Rs = Zr(Xn);
const Yt = 100, $s = 10, Ds = Mt.CONTAINER_MAX_OFFSET = Yt * $s, Ra = Mt.containerBaseZIndexOffset = {
  Modal: Yt,
  Drawer: Yt,
  Popover: Yt,
  Popconfirm: Yt,
  Tooltip: Yt,
  Tour: Yt
}, Ns = Mt.consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function Ls(e) {
  return e in Ra;
}
function Ts(e, t) {
  const [, n] = (0, Ps.default)(), r = Ms.default.useContext(Rs.default), o = Ls(e);
  if (t !== void 0)
    return [t, t];
  let a = r ?? 0;
  return o ? (a += // Use preset token zIndex by default but not stack when has parent container
  (r ? 0 : n.zIndexPopupBase) + // Container offset
  Ra[e], a = Math.min(a, n.zIndexPopupBase + Ds)) : a += Ns[e], [r === void 0 ? t : a, a];
}
var hn = {};
Object.defineProperty(hn, "__esModule", {
  value: !0
});
hn.getTransitionName = hn.default = void 0;
const pr = () => ({
  height: 0,
  opacity: 0
}), Eo = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, js = (e) => ({
  height: e ? e.offsetHeight : 0
}), gr = (e, t) => (t == null ? void 0 : t.deadline) === !0 || t.propertyName === "height", Fs = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant"}-motion-collapse`,
    onAppearStart: pr,
    onEnterStart: pr,
    onAppearActive: Eo,
    onEnterActive: Eo,
    onLeaveStart: js,
    onLeaveActive: pr,
    onAppearEnd: gr,
    onEnterEnd: gr,
    onLeaveEnd: gr,
    motionDeadline: 500
  };
}, ks = (e, t, n) => n !== void 0 ? n : `${e}-${t}`;
hn.getTransitionName = ks;
hn.default = Fs;
var _n = {}, Xr = {}, $a = { exports: {} }, Da = { exports: {} };
(function(e) {
  function t(n, r) {
    var o = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (o != null) {
      var a, i, l, u, p = [], m = !0, s = !1;
      try {
        if (l = (o = o.call(n)).next, r === 0) {
          if (Object(o) !== o)
            return;
          m = !1;
        } else
          for (; !(m = (a = l.call(o)).done) && (p.push(a.value), p.length !== r); m = !0)
            ;
      } catch (h) {
        s = !0, i = h;
      } finally {
        try {
          if (!m && o.return != null && (u = o.return(), Object(u) !== u))
            return;
        } finally {
          if (s)
            throw i;
        }
      }
      return p;
    }
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Da);
var Vs = Da.exports;
(function(e) {
  var t = ll, n = Vs, r = sl, o = cl;
  function a(i, l) {
    return t(i) || n(i, l) || r(i, l) || o();
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
})($a);
var Na = $a.exports, Ur = {}, zs = Pt.default;
Object.defineProperty(Ur, "__esModule", {
  value: !0
});
Ur.default = As;
var _o = zs(Ke);
function As(e) {
  var t = _o.useRef();
  t.current = e;
  var n = _o.useCallback(function() {
    for (var r, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(a));
  }, []);
  return n;
}
var Yr = {}, Bs = Pt.default, Hs = yt.default;
Object.defineProperty(Yr, "__esModule", {
  value: !0
});
Yr.default = Gs;
var Ws = Hs(Na), hr = Bs(Ke);
function Gs(e) {
  var t = hr.useRef(!1), n = hr.useState(e), r = (0, Ws.default)(n, 2), o = r[0], a = r[1];
  hr.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function i(l, u) {
    u && t.current || a(l);
  }
  return [o, i];
}
var Jr = yt.default;
Object.defineProperty(Xr, "__esModule", {
  value: !0
});
Xr.default = Ks;
var Mo = Jr(Na), Po = Jr(Ur), Ro = Vi, $o = Jr(Yr);
function yr(e) {
  return e !== void 0;
}
function Ks(e, t) {
  var n = t || {}, r = n.defaultValue, o = n.value, a = n.onChange, i = n.postState, l = (0, $o.default)(function() {
    return yr(o) ? o : yr(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), u = (0, Mo.default)(l, 2), p = u[0], m = u[1], s = o !== void 0 ? o : p, h = i ? i(s) : s, v = (0, Po.default)(a), c = (0, $o.default)([s]), f = (0, Mo.default)(c, 2), d = f[0], g = f[1];
  (0, Ro.useLayoutUpdateEffect)(function() {
    var w = d[0];
    p !== w && v(p, w);
  }, [d]), (0, Ro.useLayoutUpdateEffect)(function() {
    yr(o) || m(o);
  }, [o]);
  var b = (0, Po.default)(function(w, S) {
    m(w, S), g([s], S);
  });
  return [h, b];
}
var Zs = yt.default, La = Pt.default;
Object.defineProperty(_n, "__esModule", {
  value: !0
});
_n.default = void 0;
_n.withPureRenderTheme = ja;
var Et = La(Ke), Xs = Zs(Xr), Ta = La(Wn);
function ja(e) {
  return (t) => /* @__PURE__ */ Et.createElement(Ta.default, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ Et.createElement(e, Object.assign({}, t)));
}
const Us = (e, t, n, r) => ja((a) => {
  const {
    prefixCls: i,
    style: l
  } = a, u = Et.useRef(null), [p, m] = Et.useState(0), [s, h] = Et.useState(0), [v, c] = (0, Xs.default)(!1, {
    value: a.open
  }), {
    getPrefixCls: f
  } = Et.useContext(Ta.ConfigContext), d = f(t || "select", i);
  Et.useEffect(() => {
    if (c(!0), typeof ResizeObserver < "u") {
      const w = new ResizeObserver((C) => {
        const I = C[0].target;
        m(I.offsetHeight + 8), h(I.offsetWidth);
      }), S = setInterval(() => {
        var C;
        const I = n ? `.${n(d)}` : `.${d}-dropdown`, O = (C = u.current) === null || C === void 0 ? void 0 : C.querySelector(I);
        O && (clearInterval(S), w.observe(O));
      }, 10);
      return () => {
        clearInterval(S), w.disconnect();
      };
    }
  }, []);
  let g = Object.assign(Object.assign({}, a), {
    style: Object.assign(Object.assign({}, l), {
      margin: 0
    }),
    open: v,
    visible: v,
    getPopupContainer: () => u.current
  });
  r && (g = r(g));
  const b = {
    paddingBottom: p,
    position: "relative",
    minWidth: s
  };
  return /* @__PURE__ */ Et.createElement("div", {
    ref: u,
    style: b
  }, /* @__PURE__ */ Et.createElement(e, Object.assign({}, g)));
});
_n.default = Us;
var Un = {}, Yn = {}, Jn = {}, Ys = Pt.default;
Object.defineProperty(Jn, "__esModule", {
  value: !0
});
Jn.default = void 0;
var lt = Ys(Ke), Js = va, qs = en;
const Fa = () => {
  const [, e] = (0, qs.useToken)(), n = new Js.TinyColor(e.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ lt.createElement("svg", {
    style: n,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ lt.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ lt.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ lt.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ lt.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ lt.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ lt.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ lt.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ lt.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ lt.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ lt.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ lt.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
process.env.NODE_ENV !== "production" && (Fa.displayName = "EmptyImage");
Jn.default = Fa;
var qn = {}, Qs = Pt.default;
Object.defineProperty(qn, "__esModule", {
  value: !0
});
qn.default = void 0;
var ka = Qs(Ke), cn = ka, br = va, ec = en;
const Va = () => {
  const [, e] = (0, ec.useToken)(), {
    colorFill: t,
    colorFillTertiary: n,
    colorFillQuaternary: r,
    colorBgContainer: o
  } = e, {
    borderColor: a,
    shadowColor: i,
    contentColor: l
  } = (0, ka.useMemo)(() => ({
    borderColor: new br.TinyColor(t).onBackground(o).toHexShortString(),
    shadowColor: new br.TinyColor(n).onBackground(o).toHexShortString(),
    contentColor: new br.TinyColor(r).onBackground(o).toHexShortString()
  }), [t, n, r, o]);
  return /* @__PURE__ */ cn.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ cn.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ cn.createElement("ellipse", {
    fill: i,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ cn.createElement("g", {
    fillRule: "nonzero",
    stroke: a
  }, /* @__PURE__ */ cn.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ cn.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: l
  }))));
};
process.env.NODE_ENV !== "production" && (Va.displayName = "SimpleImage");
qn.default = Va;
var Qn = {};
Object.defineProperty(Qn, "__esModule", {
  value: !0
});
Qn.default = void 0;
var Do = en;
const tc = (e) => {
  const {
    componentCls: t,
    margin: n,
    marginXS: r,
    marginXL: o,
    fontSize: a,
    lineHeight: i
  } = e;
  return {
    [t]: {
      marginInline: r,
      fontSize: a,
      lineHeight: i,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: r,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${t}-description`]: {
        color: e.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-footer`]: {
        marginTop: n
      },
      "&-normal": {
        marginBlock: o,
        color: e.colorTextDescription,
        [`${t}-description`]: {
          color: e.colorTextDescription
        },
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: r,
        color: e.colorTextDescription,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
};
Qn.default = (0, Do.genStyleHooks)("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: n,
    calc: r
  } = e, o = (0, Do.mergeToken)(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: r(n).mul(2.5).equal(),
    emptyImgHeightMD: n,
    emptyImgHeightSM: r(n).mul(0.875).equal()
  });
  return [tc(o)];
});
var er = yt.default, nc = Pt.default;
Object.defineProperty(Yn, "__esModule", {
  value: !0
});
Yn.default = void 0;
var Bt = nc(Ke), rc = er(ra), oc = Wn, ac = ul, ic = er(Jn), lc = er(qn), sc = er(Qn), cc = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const za = /* @__PURE__ */ Bt.createElement(ic.default, null), Aa = /* @__PURE__ */ Bt.createElement(lc.default, null), tr = (e) => {
  var {
    className: t,
    rootClassName: n,
    prefixCls: r,
    image: o = za,
    description: a,
    children: i,
    imageStyle: l,
    style: u
  } = e, p = cc(e, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style"]);
  const {
    getPrefixCls: m,
    direction: s,
    empty: h
  } = Bt.useContext(oc.ConfigContext), v = m("empty", r), [c, f, d] = (0, sc.default)(v), [g] = (0, ac.useLocale)("Empty"), b = typeof a < "u" ? a : g == null ? void 0 : g.description, w = typeof b == "string" ? b : "empty";
  let S = null;
  return typeof o == "string" ? S = /* @__PURE__ */ Bt.createElement("img", {
    alt: w,
    src: o
  }) : S = o, c(/* @__PURE__ */ Bt.createElement("div", Object.assign({
    className: (0, rc.default)(f, d, v, h == null ? void 0 : h.className, {
      [`${v}-normal`]: o === Aa,
      [`${v}-rtl`]: s === "rtl"
    }, t, n),
    style: Object.assign(Object.assign({}, h == null ? void 0 : h.style), u)
  }, p), /* @__PURE__ */ Bt.createElement("div", {
    className: `${v}-image`,
    style: l
  }, S), b && /* @__PURE__ */ Bt.createElement("div", {
    className: `${v}-description`
  }, b), i && /* @__PURE__ */ Bt.createElement("div", {
    className: `${v}-footer`
  }, i)));
};
tr.PRESENTED_IMAGE_DEFAULT = za;
tr.PRESENTED_IMAGE_SIMPLE = Aa;
process.env.NODE_ENV !== "production" && (tr.displayName = "Empty");
Yn.default = tr;
var uc = yt.default, dc = Pt.default;
Object.defineProperty(Un, "__esModule", {
  value: !0
});
Un.default = void 0;
var Nn = dc(Ke), fc = Wn, Sn = uc(Yn);
const mc = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: n
  } = (0, Nn.useContext)(fc.ConfigContext), r = n("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ Nn.default.createElement(Sn.default, {
        image: Sn.default.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ Nn.default.createElement(Sn.default, {
        image: Sn.default.PRESENTED_IMAGE_SIMPLE,
        className: `${r}-small`
      });
    default:
      return /* @__PURE__ */ Nn.default.createElement(Sn.default, null);
  }
};
Un.default = mc;
var nr = {};
Object.defineProperty(nr, "__esModule", {
  value: !0
});
nr.default = void 0;
const vc = (e) => {
  const n = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, n), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, n), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, n), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, n), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function pc(e, t) {
  return e || vc(t);
}
nr.default = pc;
var rr = {}, or = {}, Ba = {}, ar = {};
Object.defineProperty(ar, "__esModule", {
  value: !0
});
ar.default = void 0;
const gc = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
});
ar.default = gc;
var Ht = {}, nn = {};
Object.defineProperty(nn, "__esModule", {
  value: !0
});
nn.initMotion = void 0;
const hc = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), yc = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), bc = function(e, t, n, r) {
  const a = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${a}${e}-enter,
      ${a}${e}-appear
    `]: Object.assign(Object.assign({}, hc(r)), {
      animationPlayState: "paused"
    }),
    [`${a}${e}-leave`]: Object.assign(Object.assign({}, yc(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${a}${e}-enter${e}-enter-active,
      ${a}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${a}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
};
nn.initMotion = bc;
Object.defineProperty(Ht, "__esModule", {
  value: !0
});
Ht.initFadeMotion = Ht.fadeOut = Ht.fadeIn = void 0;
var Ha = tn, xc = nn;
const Sc = Ht.fadeIn = new Ha.Keyframes("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), wc = Ht.fadeOut = new Ha.Keyframes("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), Oc = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: n
  } = e, r = `${n}-fade`, o = t ? "&" : "";
  return [(0, xc.initMotion)(r, Sc, wc, e.motionDurationMid, t), {
    [`
        ${o}${r}-enter,
        ${o}${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${o}${r}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
};
Ht.initFadeMotion = Oc;
var je = {};
Object.defineProperty(je, "__esModule", {
  value: !0
});
je.moveUpOut = je.moveUpIn = je.moveRightOut = je.moveRightIn = je.moveLeftOut = je.moveLeftIn = je.moveDownOut = je.moveDownIn = je.initMoveMotion = void 0;
var Kt = tn, Cc = nn;
const Ic = je.moveDownIn = new Kt.Keyframes("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Ec = je.moveDownOut = new Kt.Keyframes("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), _c = je.moveLeftIn = new Kt.Keyframes("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Mc = je.moveLeftOut = new Kt.Keyframes("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Pc = je.moveRightIn = new Kt.Keyframes("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Rc = je.moveRightOut = new Kt.Keyframes("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), $c = je.moveUpIn = new Kt.Keyframes("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Dc = je.moveUpOut = new Kt.Keyframes("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Nc = {
  "move-up": {
    inKeyframes: $c,
    outKeyframes: Dc
  },
  "move-down": {
    inKeyframes: Ic,
    outKeyframes: Ec
  },
  "move-left": {
    inKeyframes: _c,
    outKeyframes: Mc
  },
  "move-right": {
    inKeyframes: Pc,
    outKeyframes: Rc
  }
}, Lc = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = Nc[t];
  return [(0, Cc.initMotion)(r, o, a, e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
};
je.initMoveMotion = Lc;
var Fe = {};
Object.defineProperty(Fe, "__esModule", {
  value: !0
});
Fe.slideUpOut = Fe.slideUpIn = Fe.slideRightOut = Fe.slideRightIn = Fe.slideLeftOut = Fe.slideLeftIn = Fe.slideDownOut = Fe.slideDownIn = Fe.initSlideMotion = void 0;
var Zt = tn, Tc = nn;
const jc = Fe.slideUpIn = new Zt.Keyframes("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), Fc = Fe.slideUpOut = new Zt.Keyframes("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), kc = Fe.slideDownIn = new Zt.Keyframes("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), Vc = Fe.slideDownOut = new Zt.Keyframes("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), zc = Fe.slideLeftIn = new Zt.Keyframes("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), Ac = Fe.slideLeftOut = new Zt.Keyframes("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), Bc = Fe.slideRightIn = new Zt.Keyframes("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), Hc = Fe.slideRightOut = new Zt.Keyframes("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), Wc = {
  "slide-up": {
    inKeyframes: jc,
    outKeyframes: Fc
  },
  "slide-down": {
    inKeyframes: kc,
    outKeyframes: Vc
  },
  "slide-left": {
    inKeyframes: zc,
    outKeyframes: Ac
  },
  "slide-right": {
    inKeyframes: Bc,
    outKeyframes: Hc
  }
}, Gc = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = Wc[t];
  return [(0, Tc.initMotion)(r, o, a, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
};
Fe.initSlideMotion = Gc;
var Ce = {};
Object.defineProperty(Ce, "__esModule", {
  value: !0
});
Ce.zoomUpOut = Ce.zoomUpIn = Ce.zoomRightOut = Ce.zoomRightIn = Ce.zoomOut = Ce.zoomLeftOut = Ce.zoomLeftIn = Ce.zoomIn = Ce.zoomDownOut = Ce.zoomDownIn = Ce.zoomBigOut = Ce.zoomBigIn = Ce.initZoomMotion = void 0;
var dt = tn, Kc = nn;
const Zc = Ce.zoomIn = new dt.Keyframes("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), Xc = Ce.zoomOut = new dt.Keyframes("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), No = Ce.zoomBigIn = new dt.Keyframes("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), Lo = Ce.zoomBigOut = new dt.Keyframes("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), Uc = Ce.zoomUpIn = new dt.Keyframes("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), Yc = Ce.zoomUpOut = new dt.Keyframes("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), Jc = Ce.zoomLeftIn = new dt.Keyframes("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), qc = Ce.zoomLeftOut = new dt.Keyframes("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), Qc = Ce.zoomRightIn = new dt.Keyframes("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), eu = Ce.zoomRightOut = new dt.Keyframes("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), tu = Ce.zoomDownIn = new dt.Keyframes("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), nu = Ce.zoomDownOut = new dt.Keyframes("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), ru = {
  zoom: {
    inKeyframes: Zc,
    outKeyframes: Xc
  },
  "zoom-big": {
    inKeyframes: No,
    outKeyframes: Lo
  },
  "zoom-big-fast": {
    inKeyframes: No,
    outKeyframes: Lo
  },
  "zoom-left": {
    inKeyframes: Jc,
    outKeyframes: qc
  },
  "zoom-right": {
    inKeyframes: Qc,
    outKeyframes: eu
  },
  "zoom-up": {
    inKeyframes: Uc,
    outKeyframes: Yc
  },
  "zoom-down": {
    inKeyframes: tu,
    outKeyframes: nu
  }
}, ou = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = ru[t];
  return [(0, Kc.initMotion)(r, o, a, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
};
Ce.initZoomMotion = ou;
(function(e) {
  var t = yt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "fadeIn", {
    enumerable: !0,
    get: function() {
      return r.fadeIn;
    }
  }), Object.defineProperty(e, "fadeOut", {
    enumerable: !0,
    get: function() {
      return r.fadeOut;
    }
  }), Object.defineProperty(e, "genCollapseMotion", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "initFadeMotion", {
    enumerable: !0,
    get: function() {
      return r.initFadeMotion;
    }
  }), Object.defineProperty(e, "initMoveMotion", {
    enumerable: !0,
    get: function() {
      return o.initMoveMotion;
    }
  }), Object.defineProperty(e, "initSlideMotion", {
    enumerable: !0,
    get: function() {
      return a.initSlideMotion;
    }
  }), Object.defineProperty(e, "initZoomMotion", {
    enumerable: !0,
    get: function() {
      return i.initZoomMotion;
    }
  }), Object.defineProperty(e, "moveDownIn", {
    enumerable: !0,
    get: function() {
      return o.moveDownIn;
    }
  }), Object.defineProperty(e, "moveDownOut", {
    enumerable: !0,
    get: function() {
      return o.moveDownOut;
    }
  }), Object.defineProperty(e, "moveLeftIn", {
    enumerable: !0,
    get: function() {
      return o.moveLeftIn;
    }
  }), Object.defineProperty(e, "moveLeftOut", {
    enumerable: !0,
    get: function() {
      return o.moveLeftOut;
    }
  }), Object.defineProperty(e, "moveRightIn", {
    enumerable: !0,
    get: function() {
      return o.moveRightIn;
    }
  }), Object.defineProperty(e, "moveRightOut", {
    enumerable: !0,
    get: function() {
      return o.moveRightOut;
    }
  }), Object.defineProperty(e, "moveUpIn", {
    enumerable: !0,
    get: function() {
      return o.moveUpIn;
    }
  }), Object.defineProperty(e, "moveUpOut", {
    enumerable: !0,
    get: function() {
      return o.moveUpOut;
    }
  }), Object.defineProperty(e, "slideDownIn", {
    enumerable: !0,
    get: function() {
      return a.slideDownIn;
    }
  }), Object.defineProperty(e, "slideDownOut", {
    enumerable: !0,
    get: function() {
      return a.slideDownOut;
    }
  }), Object.defineProperty(e, "slideLeftIn", {
    enumerable: !0,
    get: function() {
      return a.slideLeftIn;
    }
  }), Object.defineProperty(e, "slideLeftOut", {
    enumerable: !0,
    get: function() {
      return a.slideLeftOut;
    }
  }), Object.defineProperty(e, "slideRightIn", {
    enumerable: !0,
    get: function() {
      return a.slideRightIn;
    }
  }), Object.defineProperty(e, "slideRightOut", {
    enumerable: !0,
    get: function() {
      return a.slideRightOut;
    }
  }), Object.defineProperty(e, "slideUpIn", {
    enumerable: !0,
    get: function() {
      return a.slideUpIn;
    }
  }), Object.defineProperty(e, "slideUpOut", {
    enumerable: !0,
    get: function() {
      return a.slideUpOut;
    }
  }), Object.defineProperty(e, "zoomBigIn", {
    enumerable: !0,
    get: function() {
      return i.zoomBigIn;
    }
  }), Object.defineProperty(e, "zoomBigOut", {
    enumerable: !0,
    get: function() {
      return i.zoomBigOut;
    }
  }), Object.defineProperty(e, "zoomDownIn", {
    enumerable: !0,
    get: function() {
      return i.zoomDownIn;
    }
  }), Object.defineProperty(e, "zoomDownOut", {
    enumerable: !0,
    get: function() {
      return i.zoomDownOut;
    }
  }), Object.defineProperty(e, "zoomIn", {
    enumerable: !0,
    get: function() {
      return i.zoomIn;
    }
  }), Object.defineProperty(e, "zoomLeftIn", {
    enumerable: !0,
    get: function() {
      return i.zoomLeftIn;
    }
  }), Object.defineProperty(e, "zoomLeftOut", {
    enumerable: !0,
    get: function() {
      return i.zoomLeftOut;
    }
  }), Object.defineProperty(e, "zoomOut", {
    enumerable: !0,
    get: function() {
      return i.zoomOut;
    }
  }), Object.defineProperty(e, "zoomRightIn", {
    enumerable: !0,
    get: function() {
      return i.zoomRightIn;
    }
  }), Object.defineProperty(e, "zoomRightOut", {
    enumerable: !0,
    get: function() {
      return i.zoomRightOut;
    }
  }), Object.defineProperty(e, "zoomUpIn", {
    enumerable: !0,
    get: function() {
      return i.zoomUpIn;
    }
  }), Object.defineProperty(e, "zoomUpOut", {
    enumerable: !0,
    get: function() {
      return i.zoomUpOut;
    }
  });
  var n = t(ar), r = Ht, o = je, a = Fe, i = Ce;
})(Ba);
Object.defineProperty(or, "__esModule", {
  value: !0
});
or.default = void 0;
var To = Gn, kt = Ba;
const jo = (e) => {
  const {
    optionHeight: t,
    optionFontSize: n,
    optionLineHeight: r,
    optionPadding: o
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: o,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: n,
    lineHeight: r,
    boxSizing: "border-box"
  };
}, au = (e) => {
  const {
    antCls: t,
    componentCls: n
  } = e, r = `${n}-item`, o = `&${t}-slide-up-enter${t}-slide-up-enter-active`, a = `&${t}-slide-up-appear${t}-slide-up-appear-active`, i = `&${t}-slide-up-leave${t}-slide-up-leave-active`, l = `${n}-dropdown-placement-`;
  return [
    {
      [`${n}-dropdown`]: Object.assign(Object.assign({}, (0, To.resetComponent)(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${o}${l}bottomLeft,
          ${a}${l}bottomLeft
        `]: {
          animationName: kt.slideUpIn
        },
        [`
          ${o}${l}topLeft,
          ${a}${l}topLeft,
          ${o}${l}topRight,
          ${a}${l}topRight
        `]: {
          animationName: kt.slideDownIn
        },
        [`${i}${l}bottomLeft`]: {
          animationName: kt.slideUpOut
        },
        [`
          ${i}${l}topLeft,
          ${i}${l}topRight
        `]: {
          animationName: kt.slideDownOut
        },
        "&-hidden": {
          display: "none"
        },
        [`${r}`]: Object.assign(Object.assign({}, jo(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, To.textEllipsis),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${r}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${r}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${r}-option-state`]: {
                color: e.colorPrimary
              },
              [`&:has(+ ${r}-option-selected:not(${r}-option-disabled))`]: {
                borderEndStartRadius: 0,
                borderEndEndRadius: 0,
                [`& + ${r}-option-selected:not(${r}-option-disabled)`]: {
                  borderStartStartRadius: 0,
                  borderStartEndRadius: 0
                }
              }
            },
            "&-disabled": {
              [`&${r}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, jo(e)), {
            color: e.colorTextDisabled
          })
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    (0, kt.initSlideMotion)(e, "slide-up"),
    (0, kt.initSlideMotion)(e, "slide-down"),
    (0, kt.initMoveMotion)(e, "move-up"),
    (0, kt.initMoveMotion)(e, "move-down")
  ];
};
or.default = au;
var Wt = {};
Object.defineProperty(Wt, "__esModule", {
  value: !0
});
Wt.getMultipleSelectorUnit = Wt.genOverflowStyle = Wt.default = void 0;
var vn = tn, iu = Gn, Fo = en;
const Wa = (e) => {
  const {
    multipleSelectItemHeight: t,
    paddingXXS: n,
    lineWidth: r,
    INTERNAL_FIXED_ITEM_MARGIN: o
  } = e, a = e.max(e.calc(n).sub(r).equal(), 0), i = e.max(e.calc(a).sub(o).equal(), 0);
  return {
    basePadding: a,
    containerPadding: i,
    itemHeight: (0, vn.unit)(t),
    itemLineHeight: (0, vn.unit)(e.calc(t).sub(e.calc(e.lineWidth).mul(2)).equal())
  };
};
Wt.getMultipleSelectorUnit = Wa;
const lu = (e) => {
  const {
    multipleSelectItemHeight: t,
    selectHeight: n,
    lineWidth: r
  } = e;
  return e.calc(n).sub(t).div(2).sub(r).equal();
}, Ga = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    borderRadiusSM: r,
    motionDurationSlow: o,
    paddingXS: a,
    multipleItemColorDisabled: i,
    multipleItemBorderColorDisabled: l,
    colorIcon: u,
    colorIconHover: p,
    INTERNAL_FIXED_ITEM_MARGIN: m
  } = e;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [`${t}-selection-overflow`]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        maxWidth: "100%",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${t}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: m,
        borderRadius: r,
        cursor: "default",
        transition: `font-size ${o}, line-height ${o}, height ${o}`,
        marginInlineEnd: e.calc(m).mul(2).equal(),
        paddingInlineStart: a,
        paddingInlineEnd: e.calc(a).div(2).equal(),
        [`${t}-disabled&`]: {
          color: i,
          borderColor: l,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(a).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, (0, iu.resetIcon)()), {
          display: "inline-flex",
          alignItems: "center",
          color: u,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${n}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: p
          }
        })
      }
    }
  };
};
Wt.genOverflowStyle = Ga;
const su = (e, t) => {
  const {
    componentCls: n,
    INTERNAL_FIXED_ITEM_MARGIN: r
  } = e, o = `${n}-selection-overflow`, a = e.multipleSelectItemHeight, i = lu(e), l = t ? `${n}-${t}` : "", u = Wa(e);
  return {
    [`${n}-multiple${l}`]: Object.assign(Object.assign({}, Ga(e)), {
      // ========================= Selector =========================
      [`${n}-selector`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: u.basePadding,
        paddingBlock: u.containerPadding,
        borderRadius: e.borderRadius,
        [`${n}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${(0, vn.unit)(r)} 0`,
          lineHeight: (0, vn.unit)(a),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${n}-selection-item`]: {
        height: u.itemHeight,
        lineHeight: (0, vn.unit)(u.itemLineHeight)
      },
      // ========================== Input ==========================
      [`${o}-item + ${o}-item`]: {
        [`${n}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${o}-item-suffix`]: {
        height: "100%"
      },
      [`${n}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(i).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: a,
          fontFamily: e.fontFamily,
          lineHeight: (0, vn.unit)(a),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.inputPaddingHorizontalBase,
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      }
    })
  };
};
function xr(e, t) {
  const {
    componentCls: n
  } = e, r = t ? `${n}-${t}` : "", o = {
    [`${n}-multiple${r}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${n}-selector`]: {
        [`${n}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${n}-show-arrow ${n}-selector,
        &${n}-allow-clear ${n}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      }
    }
  };
  return [su(e, t), o];
}
const cu = (e) => {
  const {
    componentCls: t
  } = e, n = (0, Fo.mergeToken)(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), r = (0, Fo.mergeToken)(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    xr(e),
    // ======================== Small ========================
    xr(n, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    xr(r, "lg")
  ];
};
Wt.default = cu;
var qr = {};
Object.defineProperty(qr, "__esModule", {
  value: !0
});
qr.default = du;
var wn = tn, uu = Gn, ko = en;
function Sr(e, t) {
  const {
    componentCls: n,
    inputPaddingHorizontalBase: r,
    borderRadius: o
  } = e, a = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), i = t ? `${n}-${t}` : "";
  return {
    [`${n}-single${i}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${n}-selector`]: Object.assign(Object.assign({}, (0, uu.resetComponent)(e, !0)), {
        display: "flex",
        borderRadius: o,
        [`${n}-selection-search`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: r,
          insetInlineEnd: r,
          bottom: 0,
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${n}-selection-item,
          ${n}-selection-placeholder
        `]: {
          padding: 0,
          lineHeight: (0, wn.unit)(a),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${n}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${n}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${n}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${n}-show-arrow ${n}-selection-item,
        &${n}-show-arrow ${n}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${n}-open ${n}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${n}-customize-input)`]: {
        [`${n}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${(0, wn.unit)(r)}`,
          [`${n}-selection-search-input`]: {
            height: a
          },
          "&:after": {
            lineHeight: (0, wn.unit)(a)
          }
        }
      },
      [`&${n}-customize-input`]: {
        [`${n}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${n}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${n}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${(0, wn.unit)(r)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function du(e) {
  const {
    componentCls: t
  } = e, n = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    Sr(e),
    // ======================== Small ========================
    // Shared
    Sr((0, ko.mergeToken)(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selection-search`]: {
            insetInlineStart: n,
            insetInlineEnd: n
          },
          [`${t}-selector`]: {
            padding: `0 ${(0, wn.unit)(n)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(n).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    Sr((0, ko.mergeToken)(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
var ir = {};
Object.defineProperty(ir, "__esModule", {
  value: !0
});
ir.prepareComponentToken = void 0;
const fu = (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    lineWidth: r,
    controlHeight: o,
    controlHeightSM: a,
    controlHeightLG: i,
    paddingXXS: l,
    controlPaddingHorizontal: u,
    zIndexPopupBase: p,
    colorText: m,
    fontWeightStrong: s,
    controlItemBgActive: h,
    controlItemBgHover: v,
    colorBgContainer: c,
    colorFillSecondary: f,
    colorBgContainerDisabled: d,
    colorTextDisabled: g
  } = e, b = l * 2, w = r * 2, S = Math.min(o - b, o - w), C = Math.min(a - b, a - w), I = Math.min(i - b, i - w);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(l / 2),
    zIndexPopup: p + 50,
    optionSelectedColor: m,
    optionSelectedFontWeight: s,
    optionSelectedBg: h,
    optionActiveBg: v,
    optionPadding: `${(o - t * n) / 2}px ${u}px`,
    optionFontSize: t,
    optionLineHeight: n,
    optionHeight: o,
    selectorBg: c,
    clearBg: c,
    singleItemHeightLG: i,
    multipleItemBg: f,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: S,
    multipleItemHeightSM: C,
    multipleItemHeightLG: I,
    multipleSelectorBgDisabled: d,
    multipleItemColorDisabled: g,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25)
  };
};
ir.prepareComponentToken = fu;
var lr = {};
Object.defineProperty(lr, "__esModule", {
  value: !0
});
lr.default = void 0;
var yn = tn;
const Ka = (e, t) => {
  const {
    componentCls: n,
    antCls: r,
    controlOutlineWidth: o
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      border: `${(0, yn.unit)(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${n}-focused& ${n}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${(0, yn.unit)(o)} ${t.activeShadowColor}`,
        outline: 0
      }
    }
  };
}, Vo = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, Ka(e, t))
}), mu = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, Ka(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.colorPrimaryHover,
    activeBorderColor: e.colorPrimary,
    activeShadowColor: e.controlOutline
  })), Vo(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeShadowColor: e.colorErrorOutline
  })), Vo(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeShadowColor: e.colorWarningOutline
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${(0, yn.unit)(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), Za = (e, t) => {
  const {
    componentCls: n,
    antCls: r
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      background: t.bg,
      border: `${(0, yn.unit)(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        background: t.hoverBg
      },
      [`${n}-focused& ${n}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, zo = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, Za(e, t))
}), vu = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, Za(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary,
    color: e.colorText
  })), zo(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), zo(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${(0, yn.unit)(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), pu = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      borderColor: "transparent"
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${(0, yn.unit)(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  }
}), gu = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign({}, mu(e)), vu(e)), pu(e))
});
lr.default = gu;
var sr = yt.default;
Object.defineProperty(rr, "__esModule", {
  value: !0
});
rr.default = void 0;
var Ln = Gn, hu = pl, Ao = en, yu = sr(or), bu = sr(Wt), xu = sr(qr), Su = ir, wu = sr(lr);
const Ou = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, Cu = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, Iu = (e) => {
  const {
    antCls: t,
    componentCls: n,
    inputPaddingHorizontalBase: r,
    iconCls: o
  } = e;
  return {
    [n]: Object.assign(Object.assign({}, (0, Ln.resetComponent)(e)), {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      [`&:not(${n}-customize-input) ${n}-selector`]: Object.assign(Object.assign({}, Ou(e)), Cu(e)),
      // ======================== Selection ========================
      [`${n}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, Ln.textEllipsis), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: Object.assign(Object.assign({}, Ln.textEllipsis), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${n}-arrow`]: Object.assign(Object.assign({}, (0, Ln.resetIcon)()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [o]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${n}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${n}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${n}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorTextTertiary
        }
      },
      "&:hover": {
        [`${n}-clear`]: {
          opacity: 1
        },
        // Should use the following selector, but since `:has` has poor compatibility,
        // we use `:not(:last-child)` instead, which may cause some problems in some cases.
        // [`${componentCls}-arrow:has(+ ${componentCls}-clear)`]: {
        [`${n}-arrow:not(:last-child)`]: {
          opacity: 0
        }
      }
    }),
    // ========================= Feedback ==========================
    [`${n}-has-feedback`]: {
      [`${n}-clear`]: {
        insetInlineEnd: e.calc(r).add(e.fontSize).add(e.paddingXS).equal()
      }
    }
  };
}, Eu = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    Iu(e),
    // Single
    (0, xu.default)(e),
    // Multiple
    (0, bu.default)(e),
    // Dropdown
    (0, yu.default)(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    (0, hu.genCompactItemStyle)(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
};
rr.default = (0, Ao.genStyleHooks)("Select", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = (0, Ao.mergeToken)(e, {
    rootPrefixCls: n,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [Eu(r), (0, wu.default)(r)];
}, Su.prepareComponentToken, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var Qr = {}, $r = { exports: {} }, Xa = {}, eo = {};
Object.defineProperty(eo, "__esModule", { value: !0 });
var _u = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
eo.default = _u;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return v;
    }
  });
  var t = /* @__PURE__ */ l(Ke), n = /* @__PURE__ */ a(eo), r = /* @__PURE__ */ a(Fr);
  function o(c, f, d) {
    return f in c ? Object.defineProperty(c, f, {
      value: d,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[f] = d, c;
  }
  function a(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
  function i(c) {
    if (typeof WeakMap != "function")
      return null;
    var f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap();
    return (i = function(g) {
      return g ? d : f;
    })(c);
  }
  function l(c, f) {
    if (!f && c && c.__esModule)
      return c;
    if (c === null || typeof c != "object" && typeof c != "function")
      return {
        default: c
      };
    var d = i(f);
    if (d && d.has(c))
      return d.get(c);
    var g = {
      __proto__: null
    }, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in c)
      if (w !== "default" && Object.prototype.hasOwnProperty.call(c, w)) {
        var S = b ? Object.getOwnPropertyDescriptor(c, w) : null;
        S && (S.get || S.set) ? Object.defineProperty(g, w, S) : g[w] = c[w];
      }
    return g.default = c, d && d.set(c, g), g;
  }
  function u(c) {
    for (var f = 1; f < arguments.length; f++) {
      var d = arguments[f] != null ? arguments[f] : {}, g = Object.keys(d);
      typeof Object.getOwnPropertySymbols == "function" && (g = g.concat(Object.getOwnPropertySymbols(d).filter(function(b) {
        return Object.getOwnPropertyDescriptor(d, b).enumerable;
      }))), g.forEach(function(b) {
        o(c, b, d[b]);
      });
    }
    return c;
  }
  function p(c, f) {
    var d = Object.keys(c);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(c);
      f && (g = g.filter(function(b) {
        return Object.getOwnPropertyDescriptor(c, b).enumerable;
      })), d.push.apply(d, g);
    }
    return d;
  }
  function m(c, f) {
    return f = f ?? {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(f)) : p(Object(f)).forEach(function(d) {
      Object.defineProperty(c, d, Object.getOwnPropertyDescriptor(f, d));
    }), c;
  }
  var s = function(c, f) {
    return /* @__PURE__ */ t.createElement(r.default, m(u({}, c), {
      ref: f,
      icon: n.default
    }));
  }, h = /* @__PURE__ */ t.forwardRef(s);
  process.env.NODE_ENV !== "production" && (h.displayName = "CheckOutlined");
  var v = h;
})(Xa);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  const n = r(Xa);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  const o = n;
  t.default = o, e.exports = o;
})($r, $r.exports);
var Mu = $r.exports, Dr = { exports: {} }, Ua = {}, to = {};
Object.defineProperty(to, "__esModule", { value: !0 });
var Pu = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
to.default = Pu;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return v;
    }
  });
  var t = /* @__PURE__ */ l(Ke), n = /* @__PURE__ */ a(to), r = /* @__PURE__ */ a(Fr);
  function o(c, f, d) {
    return f in c ? Object.defineProperty(c, f, {
      value: d,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[f] = d, c;
  }
  function a(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
  function i(c) {
    if (typeof WeakMap != "function")
      return null;
    var f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap();
    return (i = function(g) {
      return g ? d : f;
    })(c);
  }
  function l(c, f) {
    if (!f && c && c.__esModule)
      return c;
    if (c === null || typeof c != "object" && typeof c != "function")
      return {
        default: c
      };
    var d = i(f);
    if (d && d.has(c))
      return d.get(c);
    var g = {
      __proto__: null
    }, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in c)
      if (w !== "default" && Object.prototype.hasOwnProperty.call(c, w)) {
        var S = b ? Object.getOwnPropertyDescriptor(c, w) : null;
        S && (S.get || S.set) ? Object.defineProperty(g, w, S) : g[w] = c[w];
      }
    return g.default = c, d && d.set(c, g), g;
  }
  function u(c) {
    for (var f = 1; f < arguments.length; f++) {
      var d = arguments[f] != null ? arguments[f] : {}, g = Object.keys(d);
      typeof Object.getOwnPropertySymbols == "function" && (g = g.concat(Object.getOwnPropertySymbols(d).filter(function(b) {
        return Object.getOwnPropertyDescriptor(d, b).enumerable;
      }))), g.forEach(function(b) {
        o(c, b, d[b]);
      });
    }
    return c;
  }
  function p(c, f) {
    var d = Object.keys(c);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(c);
      f && (g = g.filter(function(b) {
        return Object.getOwnPropertyDescriptor(c, b).enumerable;
      })), d.push.apply(d, g);
    }
    return d;
  }
  function m(c, f) {
    return f = f ?? {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(f)) : p(Object(f)).forEach(function(d) {
      Object.defineProperty(c, d, Object.getOwnPropertyDescriptor(f, d));
    }), c;
  }
  var s = function(c, f) {
    return /* @__PURE__ */ t.createElement(r.default, m(u({}, c), {
      ref: f,
      icon: n.default
    }));
  }, h = /* @__PURE__ */ t.forwardRef(s);
  process.env.NODE_ENV !== "production" && (h.displayName = "CloseOutlined");
  var v = h;
})(Ua);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  const n = r(Ua);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  const o = n;
  t.default = o, e.exports = o;
})(Dr, Dr.exports);
var Ru = Dr.exports, Nr = { exports: {} }, Ya = {}, no = {};
Object.defineProperty(no, "__esModule", { value: !0 });
var $u = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
no.default = $u;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return v;
    }
  });
  var t = /* @__PURE__ */ l(Ke), n = /* @__PURE__ */ a(no), r = /* @__PURE__ */ a(Fr);
  function o(c, f, d) {
    return f in c ? Object.defineProperty(c, f, {
      value: d,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[f] = d, c;
  }
  function a(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
  function i(c) {
    if (typeof WeakMap != "function")
      return null;
    var f = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap();
    return (i = function(g) {
      return g ? d : f;
    })(c);
  }
  function l(c, f) {
    if (!f && c && c.__esModule)
      return c;
    if (c === null || typeof c != "object" && typeof c != "function")
      return {
        default: c
      };
    var d = i(f);
    if (d && d.has(c))
      return d.get(c);
    var g = {
      __proto__: null
    }, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in c)
      if (w !== "default" && Object.prototype.hasOwnProperty.call(c, w)) {
        var S = b ? Object.getOwnPropertyDescriptor(c, w) : null;
        S && (S.get || S.set) ? Object.defineProperty(g, w, S) : g[w] = c[w];
      }
    return g.default = c, d && d.set(c, g), g;
  }
  function u(c) {
    for (var f = 1; f < arguments.length; f++) {
      var d = arguments[f] != null ? arguments[f] : {}, g = Object.keys(d);
      typeof Object.getOwnPropertySymbols == "function" && (g = g.concat(Object.getOwnPropertySymbols(d).filter(function(b) {
        return Object.getOwnPropertyDescriptor(d, b).enumerable;
      }))), g.forEach(function(b) {
        o(c, b, d[b]);
      });
    }
    return c;
  }
  function p(c, f) {
    var d = Object.keys(c);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(c);
      f && (g = g.filter(function(b) {
        return Object.getOwnPropertyDescriptor(c, b).enumerable;
      })), d.push.apply(d, g);
    }
    return d;
  }
  function m(c, f) {
    return f = f ?? {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(f)) : p(Object(f)).forEach(function(d) {
      Object.defineProperty(c, d, Object.getOwnPropertyDescriptor(f, d));
    }), c;
  }
  var s = function(c, f) {
    return /* @__PURE__ */ t.createElement(r.default, m(u({}, c), {
      ref: f,
      icon: n.default
    }));
  }, h = /* @__PURE__ */ t.forwardRef(s);
  process.env.NODE_ENV !== "production" && (h.displayName = "DownOutlined");
  var v = h;
})(Ya);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  const n = r(Ya);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  const o = n;
  t.default = o, e.exports = o;
})(Nr, Nr.exports);
var Du = Nr.exports, bn = yt.default, Nu = Pt.default;
Object.defineProperty(Qr, "__esModule", {
  value: !0
});
Qr.default = Au;
var Vt = Nu(Ke), Lu = bn(Mu), Tu = bn(Ji), ju = bn(Ru), Fu = bn(Du), ku = bn(dl), Vu = bn(qi), zu = pa;
function Au(e) {
  let {
    suffixIcon: t,
    clearIcon: n,
    menuItemSelectedIcon: r,
    removeIcon: o,
    loading: a,
    multiple: i,
    hasFeedback: l,
    prefixCls: u,
    showSuffixIcon: p,
    feedbackIcon: m,
    showArrow: s,
    componentName: h
  } = e;
  process.env.NODE_ENV !== "production" && (0, zu.devUseWarning)(h).deprecated(!n, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const v = n ?? /* @__PURE__ */ Vt.createElement(Tu.default, null), c = (b) => t === null && !l && !s ? null : /* @__PURE__ */ Vt.createElement(Vt.Fragment, null, p !== !1 && b, l && m);
  let f = null;
  if (t !== void 0)
    f = c(t);
  else if (a)
    f = c(/* @__PURE__ */ Vt.createElement(ku.default, {
      spin: !0
    }));
  else {
    const b = `${u}-suffix`;
    f = (w) => {
      let {
        open: S,
        showSearch: C
      } = w;
      return c(S && C ? /* @__PURE__ */ Vt.createElement(Vu.default, {
        className: b
      }) : /* @__PURE__ */ Vt.createElement(Fu.default, {
        className: b
      }));
    };
  }
  let d = null;
  r !== void 0 ? d = r : i ? d = /* @__PURE__ */ Vt.createElement(Lu.default, null) : d = null;
  let g = null;
  return o !== void 0 ? g = o : g = /* @__PURE__ */ Vt.createElement(ju.default, null), {
    clearIcon: v,
    suffixIcon: f,
    itemIcon: d,
    removeIcon: g
  };
}
var ro = {};
Object.defineProperty(ro, "__esModule", {
  value: !0
});
ro.default = Bu;
function Bu(e, t) {
  return t !== void 0 ? t : e !== null;
}
var ft = yt.default, Ja = Pt.default;
Object.defineProperty(Kr, "__esModule", {
  value: !0
});
var Lr = Kr.default = void 0, At = Ja(Ke), Bo = ft(ra), oo = Ja(Is), Hu = ft(gl), Wu = Mt, Gu = hn, Ku = ft(_n), Ho = tl, Zu = pa, Xu = Wn, Uu = ft(Un), Yu = ft(fl), Ju = ft(Qi), qu = ft(hl), Qu = nl, ed = ft(el), td = yl, nd = en, rd = ft(nr), od = ft(rr), ad = ft(Qr), id = ft(ro), ld = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const qa = "SECRET_COMBOBOX_MODE_DO_NOT_USE", Qa = (e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: o,
    className: a,
    rootClassName: i,
    getPopupContainer: l,
    popupClassName: u,
    dropdownClassName: p,
    listHeight: m = 256,
    placement: s,
    listItemHeight: h,
    size: v,
    disabled: c,
    notFoundContent: f,
    status: d,
    builtinPlacements: g,
    dropdownMatchSelectWidth: b,
    popupMatchSelectWidth: w,
    direction: S,
    style: C,
    allowClear: I,
    variant: O,
    dropdownStyle: _,
    transitionName: Z,
    tagRender: j,
    maxCount: F
  } = e, N = ld(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount"]), {
    getPopupContainer: $,
    getPrefixCls: E,
    renderEmpty: A,
    direction: G,
    virtual: k,
    popupMatchSelectWidth: P,
    popupOverflow: z,
    select: B
  } = At.useContext(Xu.ConfigContext), [, ve] = (0, nd.useToken)(), ge = h ?? (ve == null ? void 0 : ve.controlHeight), te = E("select", r), ce = E(), ue = S ?? G, {
    compactSize: ke,
    compactItemClassnames: q
  } = (0, td.useCompactItemContext)(te, ue), [he, ye] = (0, ed.default)(O, o), L = (0, Ju.default)(te), [R, M, H] = (0, od.default)(te, L), T = At.useMemo(() => {
    const {
      mode: He
    } = e;
    if (He !== "combobox")
      return He === qa ? "combobox" : He;
  }, [e.mode]), V = T === "multiple" || T === "tags", ne = (0, id.default)(e.suffixIcon, e.showArrow), we = (n = w ?? b) !== null && n !== void 0 ? n : P, {
    status: fe,
    hasFeedback: xe,
    isFormItemInput: Ne,
    feedbackIcon: ze
  } = At.useContext(Qu.FormItemInputContext), Ae = (0, Ho.getMergedStatus)(fe, d);
  let Be;
  f !== void 0 ? Be = f : T === "combobox" ? Be = null : Be = (A == null ? void 0 : A("Select")) || /* @__PURE__ */ At.createElement(Uu.default, {
    componentName: "Select"
  });
  const {
    suffixIcon: pe,
    itemIcon: Ge,
    removeIcon: Me,
    clearIcon: Pe
  } = (0, ad.default)(Object.assign(Object.assign({}, N), {
    multiple: V,
    hasFeedback: xe,
    feedbackIcon: ze,
    showSuffixIcon: ne,
    prefixCls: te,
    componentName: "Select"
  })), Re = I === !0 ? {
    clearIcon: Pe
  } : I, ot = (0, Hu.default)(N, ["suffixIcon", "itemIcon"]), Ve = (0, Bo.default)(u || p, {
    [`${te}-dropdown-${ue}`]: ue === "rtl"
  }, i, H, L, M), Le = (0, qu.default)((He) => {
    var $e;
    return ($e = v ?? ke) !== null && $e !== void 0 ? $e : He;
  }), qe = At.useContext(Yu.default), Qe = c ?? qe, Ze = (0, Bo.default)({
    [`${te}-lg`]: Le === "large",
    [`${te}-sm`]: Le === "small",
    [`${te}-rtl`]: ue === "rtl",
    [`${te}-${he}`]: ye,
    [`${te}-in-form-item`]: Ne
  }, (0, Ho.getStatusClassNames)(te, Ae, xe), q, B == null ? void 0 : B.className, a, i, H, L, M), Rt = At.useMemo(() => s !== void 0 ? s : ue === "rtl" ? "bottomRight" : "bottomLeft", [s, ue]);
  if (process.env.NODE_ENV !== "production") {
    const He = (0, Zu.devUseWarning)("Select");
    He.deprecated(!p, "dropdownClassName", "popupClassName"), He.deprecated(b === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), process.env.NODE_ENV !== "production" && He(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), He.deprecated(!("bordered" in e), "bordered", "variant"), process.env.NODE_ENV !== "production" && He(!(typeof F < "u" && !V), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [Xe] = (0, Wu.useZIndex)("SelectLike", _ == null ? void 0 : _.zIndex);
  return R(/* @__PURE__ */ At.createElement(oo.default, Object.assign({
    ref: t,
    virtual: k,
    showSearch: B == null ? void 0 : B.showSearch
  }, ot, {
    style: Object.assign(Object.assign({}, B == null ? void 0 : B.style), C),
    dropdownMatchSelectWidth: we,
    transitionName: (0, Gu.getTransitionName)(ce, "slide-up", Z),
    builtinPlacements: (0, rd.default)(g, z),
    listHeight: m,
    listItemHeight: ge,
    mode: T,
    prefixCls: te,
    placement: Rt,
    direction: ue,
    suffixIcon: pe,
    menuItemSelectedIcon: Ge,
    removeIcon: Me,
    allowClear: Re,
    notFoundContent: Be,
    className: Ze,
    getPopupContainer: l || $,
    dropdownClassName: Ve,
    disabled: Qe,
    dropdownStyle: Object.assign(Object.assign({}, _), {
      zIndex: Xe
    }),
    maxCount: V ? F : void 0,
    tagRender: V ? j : void 0
  })));
};
process.env.NODE_ENV !== "production" && (Qa.displayName = "Select");
const rn = /* @__PURE__ */ At.forwardRef(Qa), sd = (0, Ku.default)(rn);
rn.SECRET_COMBOBOX_MODE_DO_NOT_USE = qa;
rn.Option = oo.Option;
rn.OptGroup = oo.OptGroup;
rn._InternalPanelDoNotUseOrYouWillBeFired = sd;
process.env.NODE_ENV !== "production" && (rn.displayName = "Select");
Lr = Kr.default = rn;
const cd = () => /* @__PURE__ */ x.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "8", height: "6", viewBox: "0 0 8 6", fill: "none", children: /* @__PURE__ */ x.jsx("path", { d: "M4.53333 4.95564C4.26667 5.31119 3.73333 5.31119 3.46667 4.95564L0.799999 1.40008C0.470381 0.960591 0.783969 0.333416 1.33333 0.333416L6.66667 0.333415C7.21603 0.333415 7.52962 0.960591 7.2 1.40008L4.53333 4.95564Z", fill: "#7D7D7D" }) }), ud = ({
  setPhoneNumber: e,
  phone: t,
  setDisable: n,
  phoneError: r,
  isShowFlag: o = !0,
  countryId: a,
  onChange: i,
  placeholder: l
}) => {
  const u = fa(), p = re(!1), [, m] = Ti(), { config: s } = Er();
  Se(() => {
    u || n(!!r);
  }, [r]);
  const h = (d) => {
    d.type === "compositionend" ? (p.current = !1, v(d)) : p.current = !0;
  }, v = (d) => {
    if (p.current)
      return;
    const g = d.target.value;
    m(() => e(g));
  }, c = la(() => ua(s), [s]), { Option: f } = Lr;
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      rl,
      {
        addonBefore: /* @__PURE__ */ x.jsx(
          Lr,
          {
            style: {
              border: "none",
              background: "#fff"
            },
            className: D.select,
            size: "middle",
            value: a,
            onChange: (d) => {
              i(d);
            },
            suffixIcon: /* @__PURE__ */ x.jsx(cd, {}),
            popupClassName: D.loginForPhoneSelect,
            dropdownStyle: { zIndex: 99999 },
            getPopupContainer: () => document.getElementById("label_phone"),
            children: c.map((d) => /* @__PURE__ */ x.jsx(f, { value: d.id, children: o ? /* @__PURE__ */ x.jsxs("div", { className: D.flagField, children: [
              /* @__PURE__ */ x.jsx(
                "img",
                {
                  width: 24,
                  height: 24,
                  src: d.flag,
                  alt: `${d.country} flag`
                }
              ),
              /* @__PURE__ */ x.jsx("span", { children: d.value })
            ] }) : d.label }, d.id))
          }
        ),
        style: {
          // border: '1.2px solid #EBEEF0',
          boxShadow: "0px 4px 6px 0px rgba(162, 183, 203, 0.10)",
          overflow: "auto"
        },
        className: `
          ${D.phone} 
          ${D.overrideAutoFill} 
          `,
        size: "middle",
        name: "phone",
        value: t,
        autoComplete: "true",
        autoFocus: !0,
        onCompositionStart: h,
        onCompositionEnd: h,
        onChange: (d) => v(d),
        placeholder: l,
        type: "number"
      }
    ),
    /* @__PURE__ */ x.jsx("span", { className: D.errorTip, children: r && ol(r) })
  ] });
}, dd = (e, t) => {
  var n;
  return (n = e.filter((r) => r.value === t)[0]) == null ? void 0 : n.id;
}, fd = (e, t) => {
  var n;
  return (n = e.filter((r) => r.id === t)[0]) == null ? void 0 : n.value;
}, md = (e) => ua(e), vd = /* @__PURE__ */ x.jsx(ga, { style: { fontSize: 24, color: "#fff" }, spin: !0 }), pd = (e) => {
  const [t, n] = me(""), [r, o] = me(""), [a, i] = me(!0), [l, u] = me(""), [p] = me(""), [m, s] = me(!1), { config: h } = Er(), {
    lang: { getStarted: v = {}, errorcode: c = {} },
    isModal: f = !1,
    handleEmailClick: d,
    setLoginData: g
  } = e, { blogAddressUrl: b } = Er(), w = $i(), S = Di[w] || "+63", C = Cn(), I = Bn(), O = re(null), [_, Z] = me(""), j = re(_);
  Se(() => {
    j.current = _;
  }, [_]);
  const F = re(null), { openNotification: N } = In(), $ = Qt();
  Se(() => {
    F.current = a;
  }, [a]), Se(() => {
    l && (O.current = l);
  }, [l]);
  const E = (z) => {
    z.key === "Enter" && z.keyCode === 13 && !F.current && j.current && G();
  };
  Se(() => (window.addEventListener("keydown", E), () => {
    window.removeEventListener("keydown", E);
  }), [E]);
  const A = la(() => md(h), [h]);
  Se(() => {
    S && (n(S), o(dd(A, S)));
  }, [S, A]), Se(() => {
    const z = /^\d+$/;
    (l == null ? void 0 : l.length) > 6 && z.test(l) ? i(!1) : i(!0);
  }, [l]);
  const G = () => {
    if (m)
      return;
    const z = t + O.current;
    s(!0), da({ phone_num: z, cf_token: j.current }).then((B) => {
      const {
        user_id: ve,
        avatar: ge,
        first_name: te,
        browser_serial_number: ce,
        email: ue,
        is_multiple_phones_num: ke,
        is_two_factor_enabled: q,
        vip: he
      } = (B == null ? void 0 : B.data) ?? {}, ye = t.slice(1);
      if (f)
        g(
          { ...B == null ? void 0 : B.data, phoneNum: z, countryCode: ye }
        );
      else {
        let L = `/${C}/get-started/phone?step=2&phone=${z}&countryCode=${ye}&${$.toString()}`;
        if (ve) {
          const { is_vip: R } = he;
          L = `/${C}/get-started/phone?step=2&phone=${z}&countryCode=${ye}&email=${ue}&userId=${ve}&avatar=${ge}&name=${te}&browserId=${ce}&isMultiplePhonesNum=${ke}&isTwoFactorEnabled=${q}&vip=${R}&${$.toString()}`;
        }
        I.push(L);
      }
    }).catch((B) => {
      var te;
      const ve = B == null ? void 0 : B.code;
      let ge = c[ve];
      ve === 40006 && (ge = Jt(ge, {
        retry_after: (te = B == null ? void 0 : B.errors) == null ? void 0 : te.retry_after
      })), N({
        type: "error",
        message: null,
        description: ge ?? v.optError
      });
    }).finally(() => s(!1));
  }, k = Jt(v.agreement, {
    value1: `<a
      target='_blank'
      href=${b.PrivacyPolicy} rel="noreferrer"
    >
        ${v.termsOfUse}
    </a>`,
    value2: `<a
      target='_blank'
      href=${b.PrivacyPolicy} rel="noreferrer"
    >
      ${v.privacyPolicy}
    </a>`
  }), P = (z) => {
    o(z);
    const B = fd(A, z);
    n(B);
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx("div", { style: { marginTop: 50 }, className: D.emailTitle, children: v == null ? void 0 : v.enterYourPhone }),
    /* @__PURE__ */ x.jsx("div", { className: D.emailTip, children: v == null ? void 0 : v.verificationPhoneCode }),
    /* @__PURE__ */ x.jsxs("div", { className: D.phoneNumber, children: [
      /* @__PURE__ */ x.jsx("div", { className: D.item, children: /* @__PURE__ */ x.jsx(
        ud,
        {
          lang: e.lang,
          phoneError: p,
          setPhoneNumber: u,
          setDisable: i,
          onChange: P,
          countryId: r,
          placeholder: v == null ? void 0 : v.enterYourPhone
        }
      ) }),
      /* @__PURE__ */ x.jsx(
        ma,
        {
          value: _,
          setTurnstileValue: (z) => {
            Z(z);
          },
          children: /* @__PURE__ */ x.jsx("button", { className: D.btn, disabled: a, onClick: G, children: m ? /* @__PURE__ */ x.jsx(ca, { indicator: vd }) : v.continue })
        }
      )
    ] }),
    /* @__PURE__ */ x.jsx(
      vl,
      {
        isPhone: !0,
        secondMax: 3,
        listItem: 0,
        lang: e.lang,
        handleEmailClick: d,
        isModal: f
      }
    ),
    /* @__PURE__ */ x.jsx("div", { className: D.agreement, children: /* @__PURE__ */ x.jsx(
      "p",
      {
        className: D.msg,
        dangerouslySetInnerHTML: { __html: k }
      }
    ) })
  ] });
};
var ei = "4.5.1";
function An(e, t) {
  return new Promise(function(n) {
    return setTimeout(n, e, t);
  });
}
function gd() {
  return new Promise(function(e) {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(null);
  });
}
function hd(e, t) {
  t === void 0 && (t = 1 / 0);
  var n = window.requestIdleCallback;
  return n ? new Promise(function(r) {
    return n.call(window, function() {
      return r();
    }, { timeout: t });
  }) : An(Math.min(e, t));
}
function ti(e) {
  return !!e && typeof e.then == "function";
}
function Wo(e, t) {
  try {
    var n = e();
    ti(n) ? n.then(function(r) {
      return t(!0, r);
    }, function(r) {
      return t(!1, r);
    }) : t(!0, n);
  } catch (r) {
    t(!1, r);
  }
}
function Go(e, t, n) {
  return n === void 0 && (n = 16), Ot(this, void 0, void 0, function() {
    var r, o, a, i;
    return Ct(this, function(l) {
      switch (l.label) {
        case 0:
          r = Array(e.length), o = Date.now(), a = 0, l.label = 1;
        case 1:
          return a < e.length ? (r[a] = t(e[a], a), i = Date.now(), i >= o + n ? (o = i, [4, gd()]) : [3, 3]) : [3, 4];
        case 2:
          l.sent(), l.label = 3;
        case 3:
          return ++a, [3, 1];
        case 4:
          return [2, r];
      }
    });
  });
}
function On(e) {
  return e.then(void 0, function() {
  }), e;
}
function yd(e, t) {
  for (var n = 0, r = e.length; n < r; ++n)
    if (e[n] === t)
      return !0;
  return !1;
}
function bd(e, t) {
  return !yd(e, t);
}
function ao(e) {
  return parseInt(e);
}
function gt(e) {
  return parseFloat(e);
}
function _t(e, t) {
  return typeof e == "number" && isNaN(e) ? t : e;
}
function Je(e) {
  return e.reduce(function(t, n) {
    return t + (n ? 1 : 0);
  }, 0);
}
function ni(e, t) {
  if (t === void 0 && (t = 1), Math.abs(t) >= 1)
    return Math.round(e / t) * t;
  var n = 1 / t;
  return Math.round(e * n) / n;
}
function xd(e) {
  for (var t, n, r = "Unexpected syntax '".concat(e, "'"), o = /^\s*([a-z-]*)(.*)$/i.exec(e), a = o[1] || void 0, i = {}, l = /([.:#][\w-]+|\[.+?\])/gi, u = function(h, v) {
    i[h] = i[h] || [], i[h].push(v);
  }; ; ) {
    var p = l.exec(o[2]);
    if (!p)
      break;
    var m = p[0];
    switch (m[0]) {
      case ".":
        u("class", m.slice(1));
        break;
      case "#":
        u("id", m.slice(1));
        break;
      case "[": {
        var s = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(m);
        if (s)
          u(s[1], (n = (t = s[4]) !== null && t !== void 0 ? t : s[5]) !== null && n !== void 0 ? n : "");
        else
          throw new Error(r);
        break;
      }
      default:
        throw new Error(r);
    }
  }
  return [a, i];
}
function Sd(e) {
  for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) {
    var r = e.charCodeAt(n);
    if (r > 127)
      return new TextEncoder().encode(e);
    t[n] = r;
  }
  return t;
}
function zt(e, t) {
  var n = e[0] >>> 16, r = e[0] & 65535, o = e[1] >>> 16, a = e[1] & 65535, i = t[0] >>> 16, l = t[0] & 65535, u = t[1] >>> 16, p = t[1] & 65535, m = 0, s = 0, h = 0, v = 0;
  v += a + p, h += v >>> 16, v &= 65535, h += o + u, s += h >>> 16, h &= 65535, s += r + l, m += s >>> 16, s &= 65535, m += n + i, m &= 65535, e[0] = m << 16 | s, e[1] = h << 16 | v;
}
function st(e, t) {
  var n = e[0] >>> 16, r = e[0] & 65535, o = e[1] >>> 16, a = e[1] & 65535, i = t[0] >>> 16, l = t[0] & 65535, u = t[1] >>> 16, p = t[1] & 65535, m = 0, s = 0, h = 0, v = 0;
  v += a * p, h += v >>> 16, v &= 65535, h += o * p, s += h >>> 16, h &= 65535, h += a * u, s += h >>> 16, h &= 65535, s += r * p, m += s >>> 16, s &= 65535, s += o * u, m += s >>> 16, s &= 65535, s += a * l, m += s >>> 16, s &= 65535, m += n * p + r * u + o * l + a * i, m &= 65535, e[0] = m << 16 | s, e[1] = h << 16 | v;
}
function un(e, t) {
  var n = e[0];
  t %= 64, t === 32 ? (e[0] = e[1], e[1] = n) : t < 32 ? (e[0] = n << t | e[1] >>> 32 - t, e[1] = e[1] << t | n >>> 32 - t) : (t -= 32, e[0] = e[1] << t | n >>> 32 - t, e[1] = n << t | e[1] >>> 32 - t);
}
function rt(e, t) {
  t %= 64, t !== 0 && (t < 32 ? (e[0] = e[1] >>> 32 - t, e[1] = e[1] << t) : (e[0] = e[1] << t - 32, e[1] = 0));
}
function _e(e, t) {
  e[0] ^= t[0], e[1] ^= t[1];
}
var wd = [4283543511, 3981806797], Od = [3301882366, 444984403];
function Ko(e) {
  var t = [0, e[0] >>> 1];
  _e(e, t), st(e, wd), t[1] = e[0] >>> 1, _e(e, t), st(e, Od), t[1] = e[0] >>> 1, _e(e, t);
}
var Tn = [2277735313, 289559509], jn = [1291169091, 658871167], Zo = [0, 5], Cd = [0, 1390208809], Id = [0, 944331445];
function Ed(e, t) {
  var n = Sd(e);
  t = t || 0;
  var r = [0, n.length], o = r[1] % 16, a = r[1] - o, i = [0, t], l = [0, t], u = [0, 0], p = [0, 0], m;
  for (m = 0; m < a; m = m + 16)
    u[0] = n[m + 4] | n[m + 5] << 8 | n[m + 6] << 16 | n[m + 7] << 24, u[1] = n[m] | n[m + 1] << 8 | n[m + 2] << 16 | n[m + 3] << 24, p[0] = n[m + 12] | n[m + 13] << 8 | n[m + 14] << 16 | n[m + 15] << 24, p[1] = n[m + 8] | n[m + 9] << 8 | n[m + 10] << 16 | n[m + 11] << 24, st(u, Tn), un(u, 31), st(u, jn), _e(i, u), un(i, 27), zt(i, l), st(i, Zo), zt(i, Cd), st(p, jn), un(p, 33), st(p, Tn), _e(l, p), un(l, 31), zt(l, i), st(l, Zo), zt(l, Id);
  u[0] = 0, u[1] = 0, p[0] = 0, p[1] = 0;
  var s = [0, 0];
  switch (o) {
    case 15:
      s[1] = n[m + 14], rt(s, 48), _e(p, s);
    case 14:
      s[1] = n[m + 13], rt(s, 40), _e(p, s);
    case 13:
      s[1] = n[m + 12], rt(s, 32), _e(p, s);
    case 12:
      s[1] = n[m + 11], rt(s, 24), _e(p, s);
    case 11:
      s[1] = n[m + 10], rt(s, 16), _e(p, s);
    case 10:
      s[1] = n[m + 9], rt(s, 8), _e(p, s);
    case 9:
      s[1] = n[m + 8], _e(p, s), st(p, jn), un(p, 33), st(p, Tn), _e(l, p);
    case 8:
      s[1] = n[m + 7], rt(s, 56), _e(u, s);
    case 7:
      s[1] = n[m + 6], rt(s, 48), _e(u, s);
    case 6:
      s[1] = n[m + 5], rt(s, 40), _e(u, s);
    case 5:
      s[1] = n[m + 4], rt(s, 32), _e(u, s);
    case 4:
      s[1] = n[m + 3], rt(s, 24), _e(u, s);
    case 3:
      s[1] = n[m + 2], rt(s, 16), _e(u, s);
    case 2:
      s[1] = n[m + 1], rt(s, 8), _e(u, s);
    case 1:
      s[1] = n[m], _e(u, s), st(u, Tn), un(u, 31), st(u, jn), _e(i, u);
  }
  return _e(i, r), _e(l, r), zt(i, l), zt(l, i), Ko(i), Ko(l), zt(i, l), zt(l, i), ("00000000" + (i[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (i[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (l[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (l[1] >>> 0).toString(16)).slice(-8);
}
function _d(e) {
  var t;
  return Ni({ name: e.name, message: e.message, stack: (t = e.stack) === null || t === void 0 ? void 0 : t.split(`
`) }, e);
}
function Md(e) {
  return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(e));
}
function Pd(e) {
  return typeof e != "function";
}
function Rd(e, t) {
  var n = On(new Promise(function(r) {
    var o = Date.now();
    Wo(e.bind(null, t), function() {
      for (var a = [], i = 0; i < arguments.length; i++)
        a[i] = arguments[i];
      var l = Date.now() - o;
      if (!a[0])
        return r(function() {
          return { error: a[1], duration: l };
        });
      var u = a[1];
      if (Pd(u))
        return r(function() {
          return { value: u, duration: l };
        });
      r(function() {
        return new Promise(function(p) {
          var m = Date.now();
          Wo(u, function() {
            for (var s = [], h = 0; h < arguments.length; h++)
              s[h] = arguments[h];
            var v = l + Date.now() - m;
            if (!s[0])
              return p({ error: s[1], duration: v });
            p({ value: s[1], duration: v });
          });
        });
      });
    });
  }));
  return function() {
    return n.then(function(o) {
      return o();
    });
  };
}
function $d(e, t, n, r) {
  var o = Object.keys(e).filter(function(i) {
    return bd(n, i);
  }), a = On(Go(o, function(i) {
    return Rd(e[i], t);
  }, r));
  return function() {
    return Ot(this, void 0, void 0, function() {
      var l, u, p, m, s;
      return Ct(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a];
          case 1:
            return l = h.sent(), [4, Go(l, function(v) {
              return On(v());
            }, r)];
          case 2:
            return u = h.sent(), [
              4,
              Promise.all(u)
              // Keeping the component keys order the same as the source keys order
            ];
          case 3:
            for (p = h.sent(), m = {}, s = 0; s < o.length; ++s)
              m[o[s]] = p[s];
            return [2, m];
        }
      });
    });
  };
}
function ri() {
  var e = window, t = navigator;
  return Je([
    "MSCSSMatrix" in e,
    "msSetImmediate" in e,
    "msIndexedDB" in e,
    "msMaxTouchPoints" in t,
    "msPointerEnabled" in t
  ]) >= 4;
}
function Dd() {
  var e = window, t = navigator;
  return Je(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in t, "msSaveBlob" in t]) >= 3 && !ri();
}
function Mn() {
  var e = window, t = navigator;
  return Je([
    "webkitPersistentStorage" in t,
    "webkitTemporaryStorage" in t,
    t.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function bt() {
  var e = window, t = navigator;
  return Je([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    t.vendor.indexOf("Apple") === 0,
    "RGBColor" in e,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function io() {
  var e = window, t = e.HTMLElement, n = e.Document;
  return Je([
    "safari" in e,
    !("ongestureend" in e),
    !("TouchEvent" in e),
    !("orientation" in e),
    t && !("autocapitalize" in t.prototype),
    n && "pointerLockElement" in n.prototype
  ]) >= 4;
}
function Pn() {
  var e = window;
  return (
    // Filters-out Chrome, Yandex, DuckDuckGo (macOS and iOS), Edge
    Md(e.print) && // Doesn't work in Safari < 15.4
    String(e.browser) === "[object WebPageNamespace]"
  );
}
function oi() {
  var e, t, n = window;
  return Je([
    "buildID" in navigator,
    "MozAppearance" in ((t = (e = document.documentElement) === null || e === void 0 ? void 0 : e.style) !== null && t !== void 0 ? t : {}),
    "onmozfullscreenchange" in n,
    "mozInnerScreenX" in n,
    "CSSMozDocumentRule" in n,
    "CanvasCaptureMediaStream" in n
  ]) >= 4;
}
function Nd() {
  var e = window;
  return Je([
    !("MediaSettingsRange" in e),
    "RTCEncodedAudioFrame" in e,
    "" + e.Intl == "[object Intl]",
    "" + e.Reflect == "[object Reflect]"
  ]) >= 3;
}
function Ld() {
  var e = window, t = e.URLPattern;
  return Je([
    "union" in Set.prototype,
    "Iterator" in e,
    t && "hasRegExpGroups" in t.prototype,
    "RGB8" in WebGLRenderingContext.prototype
  ]) >= 3;
}
function Td() {
  var e = window;
  return Je([
    "DOMRectList" in e,
    "RTCPeerConnectionIceEvent" in e,
    "SVGGeometryElement" in e,
    "ontransitioncancel" in e
  ]) >= 3;
}
function Rn() {
  var e = window, t = navigator, n = e.CSS, r = e.HTMLButtonElement;
  return Je([
    !("getStorageUpdates" in t),
    r && "popover" in r.prototype,
    "CSSCounterStyleRule" in e,
    n.supports("font-size-adjust: ex-height 0.5"),
    n.supports("text-transform: full-width")
  ]) >= 4;
}
function jd() {
  if (navigator.platform === "iPad")
    return !0;
  var e = screen, t = e.width / e.height;
  return Je([
    // Since iOS 13. Doesn't work in Chrome on iPadOS <15, but works in desktop mode.
    "MediaSource" in window,
    // Since iOS 12. Doesn't work in Chrome on iPadOS.
    !!Element.prototype.webkitRequestFullscreen,
    // iPhone 4S that runs iOS 9 matches this, but it is not supported
    // Doesn't work in incognito mode of Safari ≥17 with split screen because of tracking prevention
    t > 0.65 && t < 1.53
  ]) >= 2;
}
function Fd() {
  var e = document;
  return e.fullscreenElement || e.msFullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement || null;
}
function kd() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function lo() {
  var e = Mn(), t = oi(), n = window, r = navigator, o = "connection";
  return e ? Je([
    !("SharedWorker" in n),
    // `typechange` is deprecated, but it's still present on Android (tested on Chrome Mobile 117)
    // Removal proposal https://bugs.chromium.org/p/chromium/issues/detail?id=699892
    // Note: this expression returns true on ChromeOS, so additional detectors are required to avoid false-positives
    r[o] && "ontypechange" in r[o],
    !("sinkId" in new Audio())
  ]) >= 2 : t ? Je(["onorientationchange" in n, "orientation" in n, /android/i.test(r.appVersion)]) >= 2 : !1;
}
function Vd() {
  var e = navigator, t = window, n = Audio.prototype, r = t.visualViewport;
  return Je([
    "srLatency" in n,
    "srChannelCount" in n,
    "devicePosture" in e,
    r && "segments" in r,
    "getTextInformation" in Image.prototype
    // Not available in Samsung Internet 21
  ]) >= 3;
}
function zd() {
  return Hd() ? -4 : Ad();
}
function Ad() {
  var e = window, t = e.OfflineAudioContext || e.webkitOfflineAudioContext;
  if (!t)
    return -2;
  if (Bd())
    return -1;
  var n = 4500, r = 5e3, o = new t(1, r, 44100), a = o.createOscillator();
  a.type = "triangle", a.frequency.value = 1e4;
  var i = o.createDynamicsCompressor();
  i.threshold.value = -50, i.knee.value = 40, i.ratio.value = 12, i.attack.value = 0, i.release.value = 0.25, a.connect(i), i.connect(o.destination), a.start(0);
  var l = Wd(o), u = l[0], p = l[1], m = On(u.then(function(s) {
    return Gd(s.getChannelData(0).subarray(n));
  }, function(s) {
    if (s.name === "timeout" || s.name === "suspended")
      return -3;
    throw s;
  }));
  return function() {
    return p(), m;
  };
}
function Bd() {
  return bt() && !io() && !Td();
}
function Hd() {
  return (
    // Safari ≥17
    bt() && Rn() && Pn() || // Samsung Internet ≥26
    Mn() && Vd() && Ld()
  );
}
function Wd(e) {
  var t = 3, n = 500, r = 500, o = 5e3, a = function() {
  }, i = new Promise(function(l, u) {
    var p = !1, m = 0, s = 0;
    e.oncomplete = function(c) {
      return l(c.renderedBuffer);
    };
    var h = function() {
      setTimeout(function() {
        return u(Xo(
          "timeout"
          /* InnerErrorName.Timeout */
        ));
      }, Math.min(r, s + o - Date.now()));
    }, v = function() {
      try {
        var c = e.startRendering();
        switch (ti(c) && On(c), e.state) {
          case "running":
            s = Date.now(), p && h();
            break;
          case "suspended":
            document.hidden || m++, p && m >= t ? u(Xo(
              "suspended"
              /* InnerErrorName.Suspended */
            )) : setTimeout(v, n);
            break;
        }
      } catch (f) {
        u(f);
      }
    };
    v(), a = function() {
      p || (p = !0, s > 0 && h());
    };
  });
  return [i, a];
}
function Gd(e) {
  for (var t = 0, n = 0; n < e.length; ++n)
    t += Math.abs(e[n]);
  return t;
}
function Xo(e) {
  var t = new Error(e);
  return t.name = e, t;
}
function ai(e, t, n) {
  var r, o, a;
  return n === void 0 && (n = 50), Ot(this, void 0, void 0, function() {
    var i, l;
    return Ct(this, function(u) {
      switch (u.label) {
        case 0:
          i = document, u.label = 1;
        case 1:
          return i.body ? [3, 3] : [4, An(n)];
        case 2:
          return u.sent(), [3, 1];
        case 3:
          l = i.createElement("iframe"), u.label = 4;
        case 4:
          return u.trys.push([4, , 10, 11]), [4, new Promise(function(p, m) {
            var s = !1, h = function() {
              s = !0, p();
            }, v = function(d) {
              s = !0, m(d);
            };
            l.onload = h, l.onerror = v;
            var c = l.style;
            c.setProperty("display", "block", "important"), c.position = "absolute", c.top = "0", c.left = "0", c.visibility = "hidden", t && "srcdoc" in l ? l.srcdoc = t : l.src = "about:blank", i.body.appendChild(l);
            var f = function() {
              var d, g;
              s || (((g = (d = l.contentWindow) === null || d === void 0 ? void 0 : d.document) === null || g === void 0 ? void 0 : g.readyState) === "complete" ? h() : setTimeout(f, 10));
            };
            f();
          })];
        case 5:
          u.sent(), u.label = 6;
        case 6:
          return !((o = (r = l.contentWindow) === null || r === void 0 ? void 0 : r.document) === null || o === void 0) && o.body ? [3, 8] : [4, An(n)];
        case 7:
          return u.sent(), [3, 6];
        case 8:
          return [4, e(l, l.contentWindow)];
        case 9:
          return [2, u.sent()];
        case 10:
          return (a = l.parentNode) === null || a === void 0 || a.removeChild(l), [
            7
            /*endfinally*/
          ];
        case 11:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Kd(e) {
  for (var t = xd(e), n = t[0], r = t[1], o = document.createElement(n ?? "div"), a = 0, i = Object.keys(r); a < i.length; a++) {
    var l = i[a], u = r[l].join(" ");
    l === "style" ? Zd(o.style, u) : o.setAttribute(l, u);
  }
  return o;
}
function Zd(e, t) {
  for (var n = 0, r = t.split(";"); n < r.length; n++) {
    var o = r[n], a = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(o);
    if (a) {
      var i = a[1], l = a[2], u = a[4];
      e.setProperty(i, l, u || "");
    }
  }
}
function Xd() {
  for (var e = window; ; ) {
    var t = e.parent;
    if (!t || t === e)
      return !1;
    try {
      if (t.location.origin !== e.location.origin)
        return !0;
    } catch (n) {
      if (n instanceof Error && n.name === "SecurityError")
        return !0;
      throw n;
    }
    e = t;
  }
}
var Ud = "mmMwWLliI0O&1", Yd = "48px", dn = ["monospace", "sans-serif", "serif"], Uo = [
  // This is android-specific font from "Roboto" family
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function Jd() {
  var e = this;
  return ai(function(t, n) {
    var r = n.document;
    return Ot(e, void 0, void 0, function() {
      var o, a, i, l, u, p, m, s, h, v, c, f;
      return Ct(this, function(d) {
        for (o = r.body, o.style.fontSize = Yd, a = r.createElement("div"), a.style.setProperty("visibility", "hidden", "important"), i = {}, l = {}, u = function(g) {
          var b = r.createElement("span"), w = b.style;
          return w.position = "absolute", w.top = "0", w.left = "0", w.fontFamily = g, b.textContent = Ud, a.appendChild(b), b;
        }, p = function(g, b) {
          return u("'".concat(g, "',").concat(b));
        }, m = function() {
          return dn.map(u);
        }, s = function() {
          for (var g = {}, b = function(I) {
            g[I] = dn.map(function(O) {
              return p(I, O);
            });
          }, w = 0, S = Uo; w < S.length; w++) {
            var C = S[w];
            b(C);
          }
          return g;
        }, h = function(g) {
          return dn.some(function(b, w) {
            return g[w].offsetWidth !== i[b] || g[w].offsetHeight !== l[b];
          });
        }, v = m(), c = s(), o.appendChild(a), f = 0; f < dn.length; f++)
          i[dn[f]] = v[f].offsetWidth, l[dn[f]] = v[f].offsetHeight;
        return [2, Uo.filter(function(g) {
          return h(c[g]);
        })];
      });
    });
  });
}
function qd() {
  var e = navigator.plugins;
  if (e) {
    for (var t = [], n = 0; n < e.length; ++n) {
      var r = e[n];
      if (r) {
        for (var o = [], a = 0; a < r.length; ++a) {
          var i = r[a];
          o.push({
            type: i.type,
            suffixes: i.suffixes
          });
        }
        t.push({
          name: r.name,
          description: r.description,
          mimeTypes: o
        });
      }
    }
    return t;
  }
}
function Qd() {
  return ef(sf());
}
function ef(e) {
  var t, n = !1, r, o, a = tf(), i = a[0], l = a[1];
  return nf(i, l) ? (n = rf(l), e ? r = o = "skipped" : (t = of(i, l), r = t[0], o = t[1])) : r = o = "unsupported", { winding: n, geometry: r, text: o };
}
function tf() {
  var e = document.createElement("canvas");
  return e.width = 1, e.height = 1, [e, e.getContext("2d")];
}
function nf(e, t) {
  return !!(t && e.toDataURL);
}
function rf(e) {
  return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
}
function of(e, t) {
  af(e, t);
  var n = wr(e), r = wr(e);
  if (n !== r)
    return [
      "unstable",
      "unstable"
      /* ImageStatus.Unstable */
    ];
  lf(e, t);
  var o = wr(e);
  return [o, n];
}
function af(e, t) {
  e.width = 240, e.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
  var n = "Cwm fjordbank gly ".concat(
    String.fromCharCode(55357, 56835)
    /* 😃 */
  );
  t.fillText(n, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(n, 4, 45);
}
function lf(e, t) {
  e.width = 122, e.height = 110, t.globalCompositeOperation = "multiply";
  for (var n = 0, r = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; n < r.length; n++) {
    var o = r[n], a = o[0], i = o[1], l = o[2];
    t.fillStyle = a, t.beginPath(), t.arc(i, l, 40, 0, Math.PI * 2, !0), t.closePath(), t.fill();
  }
  t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, Math.PI * 2, !0), t.arc(60, 60, 20, 0, Math.PI * 2, !0), t.fill("evenodd");
}
function wr(e) {
  return e.toDataURL();
}
function sf() {
  return bt() && Rn() && Pn();
}
function cf() {
  var e = navigator, t = 0, n;
  e.maxTouchPoints !== void 0 ? t = ao(e.maxTouchPoints) : e.msMaxTouchPoints !== void 0 && (t = e.msMaxTouchPoints);
  try {
    document.createEvent("TouchEvent"), n = !0;
  } catch {
    n = !1;
  }
  var r = "ontouchstart" in window;
  return {
    maxTouchPoints: t,
    touchEvent: n,
    touchStart: r
  };
}
function uf() {
  return navigator.oscpu;
}
function df() {
  var e = navigator, t = [], n = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
  if (n !== void 0 && t.push([n]), Array.isArray(e.languages))
    Mn() && Nd() || t.push(e.languages);
  else if (typeof e.languages == "string") {
    var r = e.languages;
    r && t.push(r.split(","));
  }
  return t;
}
function ff() {
  return window.screen.colorDepth;
}
function mf() {
  return _t(gt(navigator.deviceMemory), void 0);
}
function vf() {
  if (!(bt() && Rn() && Pn()))
    return pf();
}
function pf() {
  var e = screen, t = function(r) {
    return _t(ao(r), null);
  }, n = [t(e.width), t(e.height)];
  return n.sort().reverse(), n;
}
var gf = 2500, hf = 10, Fn, Or;
function yf() {
  if (Or === void 0) {
    var e = function() {
      var t = Tr();
      jr(t) ? Or = setTimeout(e, gf) : (Fn = t, Or = void 0);
    };
    e();
  }
}
function bf() {
  var e = this;
  return yf(), function() {
    return Ot(e, void 0, void 0, function() {
      var t;
      return Ct(this, function(n) {
        switch (n.label) {
          case 0:
            return t = Tr(), jr(t) ? Fn ? [2, oa([], Fn, !0)] : Fd() ? [4, kd()] : [3, 2] : [3, 2];
          case 1:
            n.sent(), t = Tr(), n.label = 2;
          case 2:
            return jr(t) || (Fn = t), [2, t];
        }
      });
    });
  };
}
function xf() {
  var e = this;
  if (bt() && Rn() && Pn())
    return function() {
      return Promise.resolve(void 0);
    };
  var t = bf();
  return function() {
    return Ot(e, void 0, void 0, function() {
      var n, r;
      return Ct(this, function(o) {
        switch (o.label) {
          case 0:
            return [4, t()];
          case 1:
            return n = o.sent(), r = function(a) {
              return a === null ? null : ni(a, hf);
            }, [2, [r(n[0]), r(n[1]), r(n[2]), r(n[3])]];
        }
      });
    });
  };
}
function Tr() {
  var e = screen;
  return [
    _t(gt(e.availTop), null),
    _t(gt(e.width) - gt(e.availWidth) - _t(gt(e.availLeft), 0), null),
    _t(gt(e.height) - gt(e.availHeight) - _t(gt(e.availTop), 0), null),
    _t(gt(e.availLeft), null)
  ];
}
function jr(e) {
  for (var t = 0; t < 4; ++t)
    if (e[t])
      return !1;
  return !0;
}
function Sf() {
  return _t(ao(navigator.hardwareConcurrency), void 0);
}
function wf() {
  var e, t = (e = window.Intl) === null || e === void 0 ? void 0 : e.DateTimeFormat;
  if (t) {
    var n = new t().resolvedOptions().timeZone;
    if (n)
      return n;
  }
  var r = -Of();
  return "UTC".concat(r >= 0 ? "+" : "").concat(r);
}
function Of() {
  var e = (/* @__PURE__ */ new Date()).getFullYear();
  return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    gt(new Date(e, 0, 1).getTimezoneOffset()),
    gt(new Date(e, 6, 1).getTimezoneOffset())
  );
}
function Cf() {
  try {
    return !!window.sessionStorage;
  } catch {
    return !0;
  }
}
function If() {
  try {
    return !!window.localStorage;
  } catch {
    return !0;
  }
}
function Ef() {
  if (!(ri() || Dd()))
    try {
      return !!window.indexedDB;
    } catch {
      return !0;
    }
}
function _f() {
  return !!window.openDatabase;
}
function Mf() {
  return navigator.cpuClass;
}
function Pf() {
  var e = navigator.platform;
  return e === "MacIntel" && bt() && !io() ? jd() ? "iPad" : "iPhone" : e;
}
function Rf() {
  return navigator.vendor || "";
}
function $f() {
  for (var e = [], t = 0, n = [
    // Blink and some browsers on iOS
    "chrome",
    // Safari on macOS
    "safari",
    // Chrome on iOS (checked in 85 on 13 and 87 on 14)
    "__crWeb",
    "__gCrWeb",
    // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
    "yandex",
    // Yandex Browser on iOS (checked in 21.2 on 14)
    "__yb",
    "__ybro",
    // Firefox on iOS (checked in 32 on 14)
    "__firefox__",
    // Edge on iOS (checked in 46 on 14)
    "__edgeTrackingPreventionStatistics",
    "webkit",
    // Opera Touch on iOS (checked in 2.6 on 14)
    "oprt",
    // Samsung Internet on Android (checked in 11.1)
    "samsungAr",
    // UC Browser on Android (checked in 12.10 and 13.0)
    "ucweb",
    "UCShellJava",
    // Puffin on Android (checked in 9.0)
    "puffinDevice"
    // UC on iOS and Opera on Android have no specific global variables
    // Edge for Android isn't checked
  ]; t < n.length; t++) {
    var r = n[t], o = window[r];
    o && typeof o == "object" && e.push(r);
  }
  return e.sort();
}
function Df() {
  var e = document;
  try {
    e.cookie = "cookietest=1; SameSite=Strict;";
    var t = e.cookie.indexOf("cookietest=") !== -1;
    return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
  } catch {
    return !1;
  }
}
function Nf() {
  var e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function Lf(e) {
  var t = e === void 0 ? {} : e, n = t.debug;
  return Ot(this, void 0, void 0, function() {
    var r, o, a, i, l, u;
    return Ct(this, function(p) {
      switch (p.label) {
        case 0:
          return Tf() ? (r = Nf(), o = Object.keys(r), a = (u = []).concat.apply(u, o.map(function(m) {
            return r[m];
          })), [4, jf(a)]) : [2, void 0];
        case 1:
          return i = p.sent(), n && Ff(r, i), l = o.filter(function(m) {
            var s = r[m], h = Je(s.map(function(v) {
              return i[v];
            }));
            return h > s.length * 0.6;
          }), l.sort(), [2, l];
      }
    });
  });
}
function Tf() {
  return bt() || lo();
}
function jf(e) {
  var t;
  return Ot(this, void 0, void 0, function() {
    var n, r, o, a, u, i, l, u;
    return Ct(this, function(p) {
      switch (p.label) {
        case 0:
          for (n = document, r = n.createElement("div"), o = new Array(e.length), a = {}, Yo(r), u = 0; u < e.length; ++u)
            i = Kd(e[u]), i.tagName === "DIALOG" && i.show(), l = n.createElement("div"), Yo(l), l.appendChild(i), r.appendChild(l), o[u] = i;
          p.label = 1;
        case 1:
          return n.body ? [3, 3] : [4, An(50)];
        case 2:
          return p.sent(), [3, 1];
        case 3:
          n.body.appendChild(r);
          try {
            for (u = 0; u < e.length; ++u)
              o[u].offsetParent || (a[e[u]] = !0);
          } finally {
            (t = r.parentNode) === null || t === void 0 || t.removeChild(r);
          }
          return [2, a];
      }
    });
  });
}
function Yo(e) {
  e.style.setProperty("visibility", "hidden", "important"), e.style.setProperty("display", "block", "important");
}
function Ff(e, t) {
  for (var n = "DOM blockers debug:\n```", r = 0, o = Object.keys(e); r < o.length; r++) {
    var a = o[r];
    n += `
`.concat(a, ":");
    for (var i = 0, l = e[a]; i < l.length; i++) {
      var u = l[i];
      n += `
  `.concat(t[u] ? "🚫" : "➡️", " ").concat(u);
    }
  }
}
function kf() {
  for (var e = 0, t = ["rec2020", "p3", "srgb"]; e < t.length; e++) {
    var n = t[e];
    if (matchMedia("(color-gamut: ".concat(n, ")")).matches)
      return n;
  }
}
function Vf() {
  if (Jo("inverted"))
    return !0;
  if (Jo("none"))
    return !1;
}
function Jo(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function zf() {
  if (qo("active"))
    return !0;
  if (qo("none"))
    return !1;
}
function qo(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
var Af = 100;
function Bf() {
  if (matchMedia("(min-monochrome: 0)").matches) {
    for (var e = 0; e <= Af; ++e)
      if (matchMedia("(max-monochrome: ".concat(e, ")")).matches)
        return e;
    throw new Error("Too high value");
  }
}
function Hf() {
  if (fn("no-preference"))
    return 0;
  if (fn("high") || fn("more"))
    return 1;
  if (fn("low") || fn("less"))
    return -1;
  if (fn("forced"))
    return 10;
}
function fn(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function Wf() {
  if (Qo("reduce"))
    return !0;
  if (Qo("no-preference"))
    return !1;
}
function Qo(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function Gf() {
  if (ea("reduce"))
    return !0;
  if (ea("no-preference"))
    return !1;
}
function ea(e) {
  return matchMedia("(prefers-reduced-transparency: ".concat(e, ")")).matches;
}
function Kf() {
  if (ta("high"))
    return !0;
  if (ta("standard"))
    return !1;
}
function ta(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var be = Math, Ye = function() {
  return 0;
};
function Zf() {
  var e = be.acos || Ye, t = be.acosh || Ye, n = be.asin || Ye, r = be.asinh || Ye, o = be.atanh || Ye, a = be.atan || Ye, i = be.sin || Ye, l = be.sinh || Ye, u = be.cos || Ye, p = be.cosh || Ye, m = be.tan || Ye, s = be.tanh || Ye, h = be.exp || Ye, v = be.expm1 || Ye, c = be.log1p || Ye, f = function(_) {
    return be.pow(be.PI, _);
  }, d = function(_) {
    return be.log(_ + be.sqrt(_ * _ - 1));
  }, g = function(_) {
    return be.log(_ + be.sqrt(_ * _ + 1));
  }, b = function(_) {
    return be.log((1 + _) / (1 - _)) / 2;
  }, w = function(_) {
    return be.exp(_) - 1 / be.exp(_) / 2;
  }, S = function(_) {
    return (be.exp(_) + 1 / be.exp(_)) / 2;
  }, C = function(_) {
    return be.exp(_) - 1;
  }, I = function(_) {
    return (be.exp(2 * _) - 1) / (be.exp(2 * _) + 1);
  }, O = function(_) {
    return be.log(1 + _);
  };
  return {
    acos: e(0.12312423423423424),
    acosh: t(1e308),
    acoshPf: d(1e154),
    asin: n(0.12312423423423424),
    asinh: r(1),
    asinhPf: g(1),
    atanh: o(0.5),
    atanhPf: b(0.5),
    atan: a(0.5),
    sin: i(-1e300),
    sinh: l(1),
    sinhPf: w(1),
    cos: u(10.000000000123),
    cosh: p(1),
    coshPf: S(1),
    tan: m(-1e300),
    tanh: s(1),
    tanhPf: I(1),
    exp: h(1),
    expm1: v(1),
    expm1Pf: C(1),
    log1p: c(10),
    log1pPf: O(10),
    powPI: f(-100)
  };
}
var Xf = "mmMwWLliI0fiflO&1", Cr = {
  /**
   * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
   * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
   */
  default: [],
  /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
  apple: [{ font: "-apple-system-body" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  serif: [{ fontFamily: "serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  sans: [{ fontFamily: "sans-serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  mono: [{ fontFamily: "monospace" }],
  /**
   * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
   * The height can be 0 in Chrome on a retina display.
   */
  min: [{ fontSize: "1px" }],
  /** Tells one OS from another in desktop Chrome. */
  system: [{ fontFamily: "system-ui" }]
};
function Uf() {
  return Yf(function(e, t) {
    for (var n = {}, r = {}, o = 0, a = Object.keys(Cr); o < a.length; o++) {
      var i = a[o], l = Cr[i], u = l[0], p = u === void 0 ? {} : u, m = l[1], s = m === void 0 ? Xf : m, h = e.createElement("span");
      h.textContent = s, h.style.whiteSpace = "nowrap";
      for (var v = 0, c = Object.keys(p); v < c.length; v++) {
        var f = c[v], d = p[f];
        d !== void 0 && (h.style[f] = d);
      }
      n[i] = h, t.append(e.createElement("br"), h);
    }
    for (var g = 0, b = Object.keys(Cr); g < b.length; g++) {
      var i = b[g];
      r[i] = n[i].getBoundingClientRect().width;
    }
    return r;
  });
}
function Yf(e, t) {
  return t === void 0 && (t = 4e3), ai(function(n, r) {
    var o = r.document, a = o.body, i = a.style;
    i.width = "".concat(t, "px"), i.webkitTextSizeAdjust = i.textSizeAdjust = "none", Mn() ? a.style.zoom = "".concat(1 / r.devicePixelRatio) : bt() && (a.style.zoom = "reset");
    var l = o.createElement("div");
    return l.textContent = oa([], Array(t / 20 << 0), !0).map(function() {
      return "word";
    }).join(" "), a.appendChild(l), e(o, a);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function Jf() {
  return navigator.pdfViewerEnabled;
}
function qf() {
  var e = new Float32Array(1), t = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], t[3];
}
function Qf() {
  var e = window.ApplePaySession;
  if (typeof (e == null ? void 0 : e.canMakePayments) != "function")
    return -1;
  if (e0())
    return -3;
  try {
    return e.canMakePayments() ? 1 : 0;
  } catch (t) {
    return t0(t);
  }
}
var e0 = Xd;
function t0(e) {
  if (e instanceof Error && e.name === "InvalidAccessError" && /\bfrom\b.*\binsecure\b/i.test(e.message))
    return -2;
  throw e;
}
function n0() {
  var e, t = document.createElement("a"), n = (e = t.attributionSourceId) !== null && e !== void 0 ? e : t.attributionsourceid;
  return n === void 0 ? void 0 : String(n);
}
var ii = -1, li = -2, r0 = /* @__PURE__ */ new Set([
  10752,
  2849,
  2884,
  2885,
  2886,
  2928,
  2929,
  2930,
  2931,
  2932,
  2960,
  2961,
  2962,
  2963,
  2964,
  2965,
  2966,
  2967,
  2968,
  2978,
  3024,
  3042,
  3088,
  3089,
  3106,
  3107,
  32773,
  32777,
  32777,
  32823,
  32824,
  32936,
  32937,
  32938,
  32939,
  32968,
  32969,
  32970,
  32971,
  3317,
  33170,
  3333,
  3379,
  3386,
  33901,
  33902,
  34016,
  34024,
  34076,
  3408,
  3410,
  3411,
  3412,
  3413,
  3414,
  3415,
  34467,
  34816,
  34817,
  34818,
  34819,
  34877,
  34921,
  34930,
  35660,
  35661,
  35724,
  35738,
  35739,
  36003,
  36004,
  36005,
  36347,
  36348,
  36349,
  37440,
  37441,
  37443,
  7936,
  7937,
  7938
  // SAMPLE_ALPHA_TO_COVERAGE (32926) and SAMPLE_COVERAGE (32928) are excluded because they trigger a console warning
  // in IE, Chrome ≤ 59 and Safari ≤ 13 and give no entropy.
]), o0 = /* @__PURE__ */ new Set([
  34047,
  35723,
  36063,
  34852,
  34853,
  34854,
  34229,
  36392,
  36795,
  38449
  // MAX_VIEWS_OVR
]), a0 = ["FRAGMENT_SHADER", "VERTEX_SHADER"], i0 = ["LOW_FLOAT", "MEDIUM_FLOAT", "HIGH_FLOAT", "LOW_INT", "MEDIUM_INT", "HIGH_INT"], si = "WEBGL_debug_renderer_info", l0 = "WEBGL_polygon_mode";
function s0(e) {
  var t, n, r, o, a, i, l = e.cache, u = ci(l);
  if (!u)
    return ii;
  if (!di(u))
    return li;
  var p = ui() ? null : u.getExtension(si);
  return {
    version: ((t = u.getParameter(u.VERSION)) === null || t === void 0 ? void 0 : t.toString()) || "",
    vendor: ((n = u.getParameter(u.VENDOR)) === null || n === void 0 ? void 0 : n.toString()) || "",
    vendorUnmasked: p ? (r = u.getParameter(p.UNMASKED_VENDOR_WEBGL)) === null || r === void 0 ? void 0 : r.toString() : "",
    renderer: ((o = u.getParameter(u.RENDERER)) === null || o === void 0 ? void 0 : o.toString()) || "",
    rendererUnmasked: p ? (a = u.getParameter(p.UNMASKED_RENDERER_WEBGL)) === null || a === void 0 ? void 0 : a.toString() : "",
    shadingLanguageVersion: ((i = u.getParameter(u.SHADING_LANGUAGE_VERSION)) === null || i === void 0 ? void 0 : i.toString()) || ""
  };
}
function c0(e) {
  var t = e.cache, n = ci(t);
  if (!n)
    return ii;
  if (!di(n))
    return li;
  var r = n.getSupportedExtensions(), o = n.getContextAttributes(), a = [], i = [], l = [], u = [], p = [];
  if (o)
    for (var m = 0, s = Object.keys(o); m < s.length; m++) {
      var h = s[m];
      i.push("".concat(h, "=").concat(o[h]));
    }
  for (var v = na(n), c = 0, f = v; c < f.length; c++) {
    var d = f[c], g = n[d];
    l.push("".concat(d, "=").concat(g).concat(r0.has(g) ? "=".concat(n.getParameter(g)) : ""));
  }
  if (r)
    for (var b = 0, w = r; b < w.length; b++) {
      var S = w[b];
      if (!(S === si && ui() || S === l0 && f0())) {
        var C = n.getExtension(S);
        if (!C) {
          a.push(S);
          continue;
        }
        for (var I = 0, O = na(C); I < O.length; I++) {
          var d = O[I], g = C[d];
          u.push("".concat(d, "=").concat(g).concat(o0.has(g) ? "=".concat(n.getParameter(g)) : ""));
        }
      }
    }
  for (var _ = 0, Z = a0; _ < Z.length; _++)
    for (var j = Z[_], F = 0, N = i0; F < N.length; F++) {
      var $ = N[F], E = u0(n, j, $);
      p.push("".concat(j, ".").concat($, "=").concat(E.join(",")));
    }
  return u.sort(), l.sort(), {
    contextAttributes: i,
    parameters: l,
    shaderPrecisions: p,
    extensions: r,
    extensionParameters: u,
    unsupportedExtensions: a
  };
}
function ci(e) {
  if (e.webgl)
    return e.webgl.context;
  var t = document.createElement("canvas"), n;
  t.addEventListener("webglCreateContextError", function() {
    return n = void 0;
  });
  for (var r = 0, o = ["webgl", "experimental-webgl"]; r < o.length; r++) {
    var a = o[r];
    try {
      n = t.getContext(a);
    } catch {
    }
    if (n)
      break;
  }
  return e.webgl = { context: n }, n;
}
function u0(e, t, n) {
  var r = e.getShaderPrecisionFormat(e[t], e[n]);
  return r ? [r.rangeMin, r.rangeMax, r.precision] : [];
}
function na(e) {
  var t = Object.keys(e.__proto__);
  return t.filter(d0);
}
function d0(e) {
  return typeof e == "string" && !e.match(/[^A-Z0-9_x]/);
}
function ui() {
  return oi();
}
function f0() {
  return Mn() || bt();
}
function di(e) {
  return typeof e.getParameter == "function";
}
function m0() {
  var e, t = lo() || bt();
  return t ? window.AudioContext && (e = new AudioContext().baseLatency) !== null && e !== void 0 ? e : -1 : -2;
}
var v0 = {
  // READ FIRST:
  // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
  // to learn how entropy source works and how to make your own.
  // The sources run in this exact order.
  // The asynchronous sources are at the start to run in parallel with other sources.
  fonts: Jd,
  domBlockers: Lf,
  fontPreferences: Uf,
  audio: zd,
  screenFrame: xf,
  canvas: Qd,
  osCpu: uf,
  languages: df,
  colorDepth: ff,
  deviceMemory: mf,
  screenResolution: vf,
  hardwareConcurrency: Sf,
  timezone: wf,
  sessionStorage: Cf,
  localStorage: If,
  indexedDB: Ef,
  openDatabase: _f,
  cpuClass: Mf,
  platform: Pf,
  plugins: qd,
  touchSupport: cf,
  vendor: Rf,
  vendorFlavors: $f,
  cookiesEnabled: Df,
  colorGamut: kf,
  invertedColors: Vf,
  forcedColors: zf,
  monochrome: Bf,
  contrast: Hf,
  reducedMotion: Wf,
  reducedTransparency: Gf,
  hdr: Kf,
  math: Zf,
  pdfViewerEnabled: Jf,
  architecture: qf,
  applePay: Qf,
  privateClickMeasurement: n0,
  audioBaseLatency: m0,
  // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
  // after other sources.
  webGlBasics: s0,
  webGlExtensions: c0
};
function p0(e) {
  return $d(v0, e, []);
}
var g0 = "$ if upgrade to Pro: https://fpjs.dev/pro";
function h0(e) {
  var t = y0(e), n = b0(t);
  return { score: t, comment: g0.replace(/\$/g, "".concat(n)) };
}
function y0(e) {
  if (lo())
    return 0.4;
  if (bt())
    return io() && !(Rn() && Pn()) ? 0.5 : 0.3;
  var t = "value" in e.platform ? e.platform.value : "";
  return /^Win/.test(t) ? 0.6 : /^Mac/.test(t) ? 0.5 : 0.7;
}
function b0(e) {
  return ni(0.99 + 0.01 * e, 1e-4);
}
function x0(e) {
  for (var t = "", n = 0, r = Object.keys(e).sort(); n < r.length; n++) {
    var o = r[n], a = e[o], i = "error" in a ? "error" : JSON.stringify(a.value);
    t += "".concat(t ? "|" : "").concat(o.replace(/([:|\\])/g, "\\$1"), ":").concat(i);
  }
  return t;
}
function S0(e) {
  return JSON.stringify(e, function(t, n) {
    return n instanceof Error ? _d(n) : n;
  }, 2);
}
function fi(e) {
  return Ed(x0(e));
}
function w0(e) {
  var t, n = h0(e);
  return {
    get visitorId() {
      return t === void 0 && (t = fi(this.components)), t;
    },
    set visitorId(r) {
      t = r;
    },
    confidence: n,
    components: e,
    version: ei
  };
}
function O0(e) {
  return e === void 0 && (e = 50), hd(e, e * 2);
}
function C0(e, t) {
  var n = Date.now();
  return {
    get: function(r) {
      return Ot(this, void 0, void 0, function() {
        var o, a, i;
        return Ct(this, function(l) {
          switch (l.label) {
            case 0:
              return o = Date.now(), [4, e()];
            case 1:
              return a = l.sent(), i = w0(a), t || r != null && r.debug, [2, i];
          }
        });
      });
    }
  };
}
function I0() {
  if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
    try {
      var e = new XMLHttpRequest();
      e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat(ei, "/npm-monitoring"), !0), e.send();
    } catch {
    }
}
function E0(e) {
  var t;
  return e === void 0 && (e = {}), Ot(this, void 0, void 0, function() {
    var n, r, o;
    return Ct(this, function(a) {
      switch (a.label) {
        case 0:
          return (!((t = e.monitoring) !== null && t !== void 0) || t) && I0(), n = e.delayFallback, r = e.debug, [4, O0(n)];
        case 1:
          return a.sent(), o = p0({ cache: {}, debug: r }), [2, C0(o, r)];
      }
    });
  });
}
var _0 = { load: E0, hashComponents: fi, componentsToDebugString: S0 };
function M0(e) {
  var ye, L, R;
  const {
    lang: { getStarted: t, errorcode: n },
    isModal: r = !1,
    loginData: o,
    setStep: a,
    handleBackClick: i
  } = e, { setUserId: l, defaultLoginCallBack: u, handleAuthLoginForPhone: p, userInfo: m, error: s, setError: h } = En(), v = Qt(), [c, f] = me(""), [d, g] = me(0), b = Cn(), { openNotification: w } = In(), [S, C] = me(!1);
  let I, O, _, Z, j, F, N = null, $ = null, E = null, A, G;
  if (r) {
    const { user_id: M, browser_serial_number: H, is_multiple_phones_num: T, is_two_factor_enabled: V } = o;
    I = M, O = o.phoneNum, _ = o.avatar, Z = o.email, j = H, F = String(T), N = (ye = o == null ? void 0 : o.vip) == null ? void 0 : ye.is_vip, A = V, G = (o == null ? void 0 : o.countryCode) || "";
  } else
    I = v.get("userId"), O = "+" + ((R = (L = v.get("phone")) == null ? void 0 : L.trim) == null ? void 0 : R.call(L)), _ = v.get("avatar"), Z = v.get("email"), j = v.get("browserId"), F = v.get("isMultiplePhonesNum"), N = v.get("vip") != "0", $ = v.get("invited_source"), E = v.get("referral_code"), A = v.get("isTwoFactorEnabled") === "true", G = v.get("countryCode") || "";
  let k = localStorage.getItem("uuid");
  const P = Bn();
  Se(() => {
    if (!k) {
      const M = _0.load();
      (async () => (k = (await (await M).get()).visitorId, localStorage.setItem("uuid", k)))();
    }
  }, []), Se(() => {
    l(I);
  }, [I]);
  const z = (M) => {
    if (h(""), (M == null ? void 0 : M.length) === 6) {
      if (F === "true") {
        $ && E ? P.push(`/${b}/get-started/phone?step=7&phone=${O}&referral_code=${E}&invited_source=${$}`) : P.push(`/${b}/get-started/phone?step=7&phone=${O}`);
        return;
      }
      k != j && j && Z && A ? B(M) : p(M, O);
    }
  };
  Se(() => {
    const M = s == null ? void 0 : s.code, H = M ? n[M] : (s == null ? void 0 : s.message) ?? "";
    f(H);
  }, [s]);
  const B = (M) => {
    Gi({
      otp: M,
      phone_num: O
    }).then((H) => {
      const { data: T } = H ?? {};
      T ? te(Z) : f(t.invalidOtp);
    }).catch(() => f(t.invalidOtp));
  }, ve = () => {
    const M = sessionStorage.getItem(aa);
    return da({ phone_num: O, cf_token: M }).then(() => {
      w({
        type: "success",
        message: null,
        description: t.resendPhoneCode
      }), g((/* @__PURE__ */ new Date()).getTime());
    });
  }, ge = (M) => {
    var V;
    const H = M == null ? void 0 : M.code;
    let T = n[H];
    return H === 40006 && (T = Jt(T, {
      retry_after: (V = M == null ? void 0 : M.errors) == null ? void 0 : V.retry_after
    })), { transErr: T };
  }, te = (M) => new Promise((H, T) => {
    gn({ email: M }).then((V) => {
      $ && E ? P.push(
        `/${b}/get-started/phone?step=6&email=${encodeURIComponent(
          M
        )}&userId=${I}&referral_code=${E}&invited_source=${$}`
      ) : P.push(
        `/${b}/get-started/phone?step=6&email=${encodeURIComponent(
          M
        )}&userId=${I}`
      ), H(V);
    }).catch((V) => {
      if (V.message.indexOf("41260") > -1) {
        T(V);
        return;
      }
      const { transErr: ne } = ge(V);
      w({
        type: "error",
        message: null,
        description: ne ?? V.message ?? t.optError
      });
    });
  });
  Se(() => {
    m && Object.keys(m).length && (I ? u(m) : (Li("HIDE_LOGIN_MODAL"), $ && E ? P.push(`/${b}/get-started/phone?step=3&phone=${O}&&referral_code=${E}&invited_source=${$}`) : P.push(`/${b}/get-started/phone?step=3&phone=${O}`)));
  }, [m]);
  const ce = new RegExp(`^${G}`), ue = O.slice(1).replace(ce, ""), ke = G ? `(+${G.trim()}) ${ue.trim()}` : O, [q, he] = me(null);
  return Se(() => {
    const M = document.getElementById("right-container");
    he(M);
  }, []), /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs("div", { className: D.phoneNumber, children: [
      /* @__PURE__ */ x.jsxs("div", { className: D.optBox, children: [
        _ && _ != "null" ? /* @__PURE__ */ x.jsx("div", { className: D.avatar, children: /* @__PURE__ */ x.jsxs("div", { className: D.avatar_content, children: [
          /* @__PURE__ */ x.jsx(
            "img",
            {
              className: D.avatar_img + " " + (N ? D.avatar_vip : ""),
              src: _,
              alt: "avatar"
            }
          ),
          N ? /* @__PURE__ */ x.jsx(bl, { className: D.avatar_icon }) : null
        ] }) }) : null,
        /* @__PURE__ */ x.jsxs("div", { className: D.newUser, style: { marginTop: I ? 5 : 40 }, children: [
          /* @__PURE__ */ x.jsxs("div", { className: D.newUser_title, children: [
            I ? t == null ? void 0 : t.welcomeBack : t == null ? void 0 : t.signUpAnAccount,
            " 🎉"
          ] }),
          /* @__PURE__ */ x.jsxs("div", { className: D.newUser_tip, children: [
            /* @__PURE__ */ x.jsx("div", { children: t == null ? void 0 : t.enterOTP }),
            /* @__PURE__ */ x.jsx("div", { className: D.newUser_email, children: ke })
          ] })
        ] }),
        /* @__PURE__ */ x.jsx(
          Hn,
          {
            lang: e.lang,
            onChange: z,
            sendOpt: ve,
            autoFocus: !0,
            error: c,
            number: d
          }
        ),
        mn ? /* @__PURE__ */ x.jsx(
          "span",
          {
            className: D.needHelpTextMobile,
            onClick: () => C(!0),
            children: (t == null ? void 0 : t.needHelpText) || "Need help?"
          }
        ) : /* @__PURE__ */ x.jsx(
          Kn,
          {
            isModal: r,
            render: () => /* @__PURE__ */ x.jsx(x.Fragment, { children: /* @__PURE__ */ x.jsxs("p", { className: D.trouble, children: [
              t.checkSpamSMS,
              " ",
              /* @__PURE__ */ x.jsx(
                "span",
                {
                  className: D.link,
                  onClick: () => r ? a() : $ && E ? P.push(`/${b}/get-started?referral_code=${E}&invited_source=${$}`) : P.push(`/${b}/get-started`),
                  children: t.otherOptions
                }
              )
            ] }) }),
            children: /* @__PURE__ */ x.jsx("span", { className: D.needHelpText, children: (t == null ? void 0 : t.needHelpText) || "Need help?" })
          }
        )
      ] }),
      q && kn.createPortal(/* @__PURE__ */ x.jsxs(
        "div",
        {
          className: D.backBox,
          style: { marginTop: 60, paddingTop: 0 },
          onClick: () => r ? i == null ? void 0 : i() : $ && E ? P.push(`/${b}/get-started/phone?referral_code=${E}&invited_source=${$}`) : P.push(`/${b}/get-started/phone`),
          children: [
            /* @__PURE__ */ x.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ x.jsx(
              "path",
              {
                fill: "#707070",
                d: "m13.484 14.557-3.556-3.556 3.556-3.557a.913.913 0 1 0-1.292-1.293L7.984 10.36a.913.913 0 0 0 0 1.292l4.208 4.208a.913.913 0 0 0 1.292 0 .932.932 0 0 0 0-1.302Z"
              }
            ) }),
            /* @__PURE__ */ x.jsx("span", { children: t.back })
          ]
        }
      ), q)
    ] }),
    /* @__PURE__ */ x.jsx(
      xl,
      {
        open: S,
        onClose: () => C(!1),
        render: () => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx("div", { className: D.havingTroubleMobileTitle, children: (t == null ? void 0 : t.needHelpTitle) || "Need help" }),
          /* @__PURE__ */ x.jsxs("div", { className: D.havingTroubleMobileDesc, children: [
            t == null ? void 0 : t.checkSpamSMS,
            " ",
            /* @__PURE__ */ x.jsx("span", { onClick: () => r ? a() : E && $ ? P.push(`/${b}/get-started?referral_code=${E}&invited_source=${$}`) : P.push(`/${b}/get-started`), children: (t == null ? void 0 : t.otherOptions) || "Other options" })
          ] })
        ] })
      }
    )
  ] });
}
const mi = (e) => {
  const { defaultLoginCallBack: t } = En(), { getStarted: n } = e.lang, r = (e == null ? void 0 : e.className) || "", o = () => {
    const a = ia("user");
    t(a);
  };
  return /* @__PURE__ */ x.jsx("div", { className: `${D.upLater} ${r}`, children: /* @__PURE__ */ x.jsx(
    "span",
    {
      className: D.upLaterText,
      onClick: () => o(),
      children: n.setUpLater
    }
  ) });
}, P0 = /* @__PURE__ */ x.jsx(ga, { style: { fontSize: 24, color: "#fff" }, spin: !0 });
function R0(e) {
  var j, F;
  const [t, n] = me(!0), [r, o] = me(""), [a, i] = me(""), [l, u] = me(!1), p = Qt(), m = "+" + ((F = (j = p.get("phone")) == null ? void 0 : j.trim) == null ? void 0 : F.call(j)), { openNotification: s } = In(), h = Bn(), v = Cn(), { getStarted: c, errorcode: f } = e.lang, d = re(null), g = re(null), [b, w] = me(""), S = p.get("referral_code"), C = p.get("invited_source");
  Se(() => {
    g.current = t;
  }, [t]);
  const I = (N) => {
    N.key === "Enter" && N.keyCode === 13 && !g.current && b && O();
  };
  Se(() => (window.addEventListener("keydown", I), () => window.removeEventListener("keydown", I)), [I]), Se(() => {
    a && i(""), r && (d.current = r);
  }, [r]);
  const O = () => {
    u(!0), Ki({ email: d.current }).then((N) => {
      N != null && N.data ? (u(!1), i(c.validateErr)) : Z();
    });
  }, _ = (N) => {
    var A;
    const $ = N == null ? void 0 : N.code;
    let E = f[$];
    return $ === 40006 && (E = Jt(E, {
      retry_after: (A = N == null ? void 0 : N.errors) == null ? void 0 : A.retry_after
    })), { transErr: E };
  }, Z = () => {
    gn({ email: d.current }).then((N) => {
      S && C ? h.push(
        `/${v}/get-started/phone?step=4&phone=${m}&email=${d.current}&referral_code=${S}&invited_source=${C}`
      ) : h.push(
        `/${v}/get-started/phone?step=4&phone=${m}&email=${d.current}`
      );
    }).catch((N) => {
      const { transErr: $ } = _(N);
      s({
        type: "error",
        message: null,
        description: $ ?? N.message ?? c.optError
      });
    }).finally(() => u(!1));
  };
  return /* @__PURE__ */ x.jsxs("div", { className: D.emailFactor, children: [
    /* @__PURE__ */ x.jsxs("div", { className: D.emailFactorTitle, children: [
      c.twoFactor,
      " ",
      /* @__PURE__ */ x.jsx("br", {})
    ] }),
    /* @__PURE__ */ x.jsx("div", { className: D.emailTips, children: c.emailTips }),
    /* @__PURE__ */ x.jsxs("div", { className: D.phoneNumber, children: [
      /* @__PURE__ */ x.jsx("div", { className: D.item, children: /* @__PURE__ */ x.jsx(
        al,
        {
          setEmail: o,
          setDisable: n,
          email: r,
          lang: e.lang,
          validateErr: a,
          placeholder: c.emailLabel
        }
      ) }),
      /* @__PURE__ */ x.jsx(
        ma,
        {
          value: b,
          setTurnstileValue: (N) => {
            w(N);
          },
          children: /* @__PURE__ */ x.jsx("button", { className: D.btn, disabled: t, onClick: () => O(), children: l ? /* @__PURE__ */ x.jsx(ca, { indicator: P0 }) : c.continue })
        }
      ),
      /* @__PURE__ */ x.jsx(mi, { lang: e.lang })
    ] })
  ] });
}
const $0 = (e) => {
  var b, w;
  const { getStarted: t, errorcode: n } = e.lang, r = Cn(), o = Qt(), a = "+" + ((w = (b = o.get("phone")) == null ? void 0 : b.trim) == null ? void 0 : w.call(b)), i = o.get("email"), [l, u] = me(""), p = Bn(), [m, s] = me(0), h = o.get("referral_code"), v = o.get("invited_source"), c = (S) => {
    u(""), (S == null ? void 0 : S.length) === 6 && Zi({
      otp: S,
      email: i
    }).then((C) => {
      C.data ? g() : u(t.invalidOtp);
    }).catch((C) => {
      const I = C == null ? void 0 : C.code, O = n[I];
      u(O || (C == null ? void 0 : C.message) || "error");
    });
  }, f = (S) => {
    var O;
    const C = S == null ? void 0 : S.code;
    let I = n[C];
    return C === 40006 && (I = Jt(I, {
      retry_after: (O = S == null ? void 0 : S.errors) == null ? void 0 : O.retry_after
    })), { transErr: I };
  }, d = () => {
    u("");
    const S = sessionStorage.getItem(aa);
    return new Promise((C, I) => {
      gn({
        email: i,
        cf_token: window.location.href.includes("localhost") ? void 0 : S
      }).then(() => {
        s((/* @__PURE__ */ new Date()).getTime()), u(t.resendEmailCode), C();
      }).catch((O) => {
        if (O.message.indexOf("41260") > -1) {
          I(O);
          return;
        }
        const { transErr: _ } = f(O);
        u(_ ?? O.message ?? t.optError);
      });
    });
  }, g = () => {
    Xi({
      phone_num: a,
      email: i,
      is_two_factor_enabled: 1
    }).then((S) => {
      S.data && (h && v ? p.push(
        `/${r}/get-started/phone?step=5&referral_code=${h}&invited_source=${v}`
      ) : p.push(`/${r}/get-started/phone?step=5`));
    }).catch((S) => {
      u(S == null ? void 0 : S.message);
      const C = S == null ? void 0 : S.code, I = n[C];
      u(I || (S == null ? void 0 : S.message) || "error");
    });
  };
  return /* @__PURE__ */ x.jsx("div", { className: D.phoneNumber, children: /* @__PURE__ */ x.jsxs("div", { className: D.optBox, children: [
    /* @__PURE__ */ x.jsx("div", { className: D.verifyEmailTitle, children: t.verifyEmail }),
    /* @__PURE__ */ x.jsxs("div", { className: D.verifyEmailTips, children: [
      /* @__PURE__ */ x.jsx("div", { children: t.sendCodeDigit }),
      /* @__PURE__ */ x.jsx("div", { children: i })
    ] }),
    /* @__PURE__ */ x.jsx(
      Hn,
      {
        lang: e.lang,
        autoFocus: !0,
        onChange: c,
        sendOpt: d,
        error: l,
        number: m
      }
    ),
    /* @__PURE__ */ x.jsx(
      Kn,
      {
        render: () => /* @__PURE__ */ x.jsx("p", { className: D.checkYourSpam, children: t.checkYourSpam }),
        children: /* @__PURE__ */ x.jsx("span", { className: D.havingTroubleText, children: t.havingTrouble })
      }
    ),
    /* @__PURE__ */ x.jsx(mi, { className: D.verifyEmailLater, lang: e.lang })
  ] }) });
}, D0 = (e) => {
  const { getStarted: t, errorcode: n } = e.lang, [r, o] = me(""), a = Qt(), i = a.get("userId"), l = decodeURIComponent(a.get("email")), [u, p] = me(0), { openNotification: m } = In(), { setUserId: s, setEmail: h, handleAuthLoginForEmail: v, defaultLoginCallBack: c, userInfo: f, setError: d, error: g } = En();
  Se(() => {
    l && h(l);
  }, [l]), Se(() => {
    const C = (g == null ? void 0 : g.message) ?? "";
    o(C);
  }, [JSON.stringify(g)]), Se(() => {
    s(i);
  }, [i]), Se(() => {
    f && !Object.keys(f).length || c(f);
  }, [f]);
  const b = (C) => {
    d(""), (C == null ? void 0 : C.length) === 6 && v(C);
  }, w = (C) => {
    var _;
    const I = C == null ? void 0 : C.code;
    let O = n[I];
    return I === 40006 && (O = Jt(O, {
      retry_after: (_ = C == null ? void 0 : C.errors) == null ? void 0 : _.retry_after
    })), { transErr: O };
  }, S = () => new Promise((C, I) => {
    gn({ email: l }).then(() => {
      p((/* @__PURE__ */ new Date()).getTime()), C(), m({
        type: "success",
        message: null,
        description: t.resendEmailCode
      });
    }).catch((O) => {
      if (O.message.indexOf("41260") > -1) {
        I(O);
        return;
      }
      const { transErr: _ } = w(O);
      m({
        type: "error",
        message: null,
        description: _ ?? O.message ?? t.optError
      });
    });
  });
  return /* @__PURE__ */ x.jsx(x.Fragment, { children: /* @__PURE__ */ x.jsx("div", { className: D.phoneNumber, children: /* @__PURE__ */ x.jsxs("div", { className: D.optBox, children: [
    /* @__PURE__ */ x.jsx("div", { className: D.verifyEmailTitle, children: t.verifyText }),
    /* @__PURE__ */ x.jsxs("div", { className: D.verifyEmailTips, children: [
      /* @__PURE__ */ x.jsx("div", { children: t.sendCodeDigit }),
      /* @__PURE__ */ x.jsx("div", { children: l })
    ] }),
    /* @__PURE__ */ x.jsx(
      Hn,
      {
        lang: e.lang,
        autoFocus: !0,
        sendOpt: S,
        onChange: b,
        error: r,
        number: u
      }
    ),
    /* @__PURE__ */ x.jsx(
      Kn,
      {
        render: () => /* @__PURE__ */ x.jsx("p", { children: t.verifyExtra }),
        children: /* @__PURE__ */ x.jsx("span", { className: D.havingTroubleText, children: t.havingTrouble })
      }
    )
  ] }) }) });
}, N0 = "5.9.6", L0 = 60, T0 = 0, j0 = 300, F0 = 181, k0 = 183, V0 = "Frame 14", z0 = 0, A0 = [
  {
    id: "comp_0",
    nm: "Frame 5",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Frame 5",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              3.5,
              3.5,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    7,
                    7
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                nm: "矩形路径 1",
                mn: "ADBE Vector Shape - Rect",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.482352942228,
                    0.647058844566,
                    1,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Frame 5",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  },
  {
    id: "comp_1",
    nm: "Frame 12",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Frame 12",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              1,
              1,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    2,
                    2
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                nm: "矩形路径 1",
                mn: "ADBE Vector Shape - Rect",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.482352942228,
                    0.647058844566,
                    1,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Frame 12",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  },
  {
    id: "comp_2",
    nm: "Frame 11",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Frame 11",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              2.5,
              2.5,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    5,
                    5
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                nm: "矩形路径 1",
                mn: "ADBE Vector Shape - Rect",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.482352942228,
                    0.647058844566,
                    1,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Frame 11",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  },
  {
    id: "comp_3",
    nm: "Frame 9",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Frame 9",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              2.5,
              2.5,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    5,
                    5
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                nm: "矩形路径 1",
                mn: "ADBE Vector Shape - Rect",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.482352942228,
                    0.647058844566,
                    1,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Frame 9",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  },
  {
    id: "comp_4",
    nm: "Frame 8",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Frame 8",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              3,
              3,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    6,
                    6
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                nm: "矩形路径 1",
                mn: "ADBE Vector Shape - Rect",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.482352942228,
                    0.647058844566,
                    1,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Frame 8",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  },
  {
    id: "comp_5",
    nm: "Frame 13",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Frame 13",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              7,
              7,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    14,
                    14
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                nm: "矩形路径 1",
                mn: "ADBE Vector Shape - Rect",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.482352942228,
                    0.647058844566,
                    1,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Frame 13",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  },
  {
    id: "comp_6",
    nm: "Frame 3",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Subtract 2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              56.5,
              56.5,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        -0.774,
                        -0.788
                      ],
                      [
                        0.788,
                        -0.774
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.18,
                        1.043
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.732,
                        0.828
                      ],
                      [
                        -0.828,
                        -0.732
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0.774,
                        0.788
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.124,
                        1.103
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.828,
                        -0.732
                      ],
                      [
                        0.732,
                        -0.828
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.788,
                        -0.774
                      ]
                    ],
                    v: [
                      [
                        8.461,
                        -6.343
                      ],
                      [
                        8.435,
                        -3.515
                      ],
                      [
                        -0.12,
                        4.88
                      ],
                      [
                        -4.208,
                        4.987
                      ],
                      [
                        -8.358,
                        1.318
                      ],
                      [
                        -8.532,
                        -1.505
                      ],
                      [
                        -5.709,
                        -1.679
                      ],
                      [
                        -2.257,
                        1.373
                      ],
                      [
                        5.633,
                        -6.37
                      ]
                    ],
                    c: !0
                  },
                  ix: 2
                },
                nm: "路径 2",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "mm",
                mm: 3,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.137254908681,
                    0.474509835243,
                    0.917647123337,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Subtract",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Subtract",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              56.5,
              56.5,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -1.126,
                        -0.42
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.088
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        13.084,
                        -5.356
                      ],
                      [
                        0,
                        11.069
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.956,
                        0.729
                      ]
                    ],
                    o: [
                      [
                        1.126,
                        -0.42
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.956,
                        0.729
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        10.09
                      ],
                      [
                        -11.514,
                        -4.585
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.088
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        -1.746,
                        -24.668
                      ],
                      [
                        1.746,
                        -24.668
                      ],
                      [
                        17.455,
                        -18.813
                      ],
                      [
                        20.709,
                        -14.128
                      ],
                      [
                        20.709,
                        4.952
                      ],
                      [
                        0,
                        24.982
                      ],
                      [
                        -20.709,
                        4.952
                      ],
                      [
                        -20.709,
                        -14.128
                      ],
                      [
                        -17.455,
                        -18.813
                      ]
                    ],
                    c: !0
                  },
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "mm",
                mm: 3,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Subtract",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Frame 3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              56.5,
              56.5,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    113,
                    113
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                nm: "矩形路径 1",
                mn: "ADBE Vector Shape - Rect",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.137254908681,
                    0.474509805441,
                    0.917647063732,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Frame 3",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 300,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  }
], B0 = [
  {
    ddd: 0,
    ind: 2,
    ty: 0,
    nm: "Frame 5",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 197,
            s: [
              100
            ]
          },
          {
            t: 227,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.562,
              y: 0.562
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 77,
            s: [
              91.686,
              22,
              0
            ],
            to: [
              39.039,
              0,
              0
            ],
            ti: [
              0,
              -39.039,
              0
            ]
          },
          {
            i: {
              x: 0.656,
              y: 0.656
            },
            o: {
              x: 0.311,
              y: 0.311
            },
            t: 107,
            s: [
              162.371,
              92.686,
              0
            ],
            to: [
              0,
              39.039,
              0
            ],
            ti: [
              39.039,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.689,
              y: 0.689
            },
            o: {
              x: 0.343,
              y: 0.343
            },
            t: 137,
            s: [
              91.686,
              163.371,
              0
            ],
            to: [
              -39.039,
              0,
              0
            ],
            ti: [
              0,
              39.039,
              0
            ]
          },
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.437,
              y: 0.437
            },
            t: 167,
            s: [
              21,
              92.686,
              0
            ],
            to: [
              0,
              -39.039,
              0
            ],
            ti: [
              -39.039,
              0,
              0
            ]
          },
          {
            t: 197,
            s: [
              91.686,
              22,
              0
            ]
          }
        ],
        ix: 2,
        l: 2,
        x: `var $bm_rt;
$bm_rt = loopOut('cycle', 0);`
      },
      a: {
        a: 0,
        k: [
          3.5,
          3.5,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          50,
          50,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 7,
    h: 7,
    ip: 77,
    op: 377,
    st: 77,
    ct: 1,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 0,
    nm: "Frame 12",
    refId: "comp_1",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.562,
              y: 0.562
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 2,
            s: [
              92.122,
              12.688,
              0
            ],
            to: [
              44.414,
              0,
              0
            ],
            ti: [
              0,
              -44.414,
              0
            ]
          },
          {
            i: {
              x: 0.656,
              y: 0.656
            },
            o: {
              x: 0.311,
              y: 0.311
            },
            t: 32,
            s: [
              172.541,
              93.106,
              0
            ],
            to: [
              0,
              44.414,
              0
            ],
            ti: [
              44.414,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.689,
              y: 0.689
            },
            o: {
              x: 0.343,
              y: 0.343
            },
            t: 62,
            s: [
              92.122,
              173.525,
              0
            ],
            to: [
              -44.414,
              0,
              0
            ],
            ti: [
              0,
              44.414,
              0
            ]
          },
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.437,
              y: 0.437
            },
            t: 92,
            s: [
              11.703,
              93.106,
              0
            ],
            to: [
              0,
              -44.414,
              0
            ],
            ti: [
              -44.414,
              0,
              0
            ]
          },
          {
            t: 122,
            s: [
              92.122,
              12.688,
              0
            ]
          }
        ],
        ix: 2,
        l: 2,
        x: `var $bm_rt;
$bm_rt = loopOut('cycle', 0);`
      },
      a: {
        a: 0,
        k: [
          2,
          2,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          50,
          50,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 4,
    h: 4,
    ip: 2,
    op: 302,
    st: 2,
    ct: 1,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 0,
    nm: "Frame 11",
    refId: "comp_2",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.562,
              y: 0.562
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 109,
            s: [
              92.122,
              12.688,
              0
            ],
            to: [
              44.414,
              0,
              0
            ],
            ti: [
              0,
              -44.414,
              0
            ]
          },
          {
            i: {
              x: 0.656,
              y: 0.656
            },
            o: {
              x: 0.311,
              y: 0.311
            },
            t: 139,
            s: [
              172.541,
              93.106,
              0
            ],
            to: [
              0,
              44.414,
              0
            ],
            ti: [
              44.414,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.689,
              y: 0.689
            },
            o: {
              x: 0.343,
              y: 0.343
            },
            t: 169,
            s: [
              92.122,
              173.525,
              0
            ],
            to: [
              -44.414,
              0,
              0
            ],
            ti: [
              0,
              44.414,
              0
            ]
          },
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.437,
              y: 0.437
            },
            t: 199,
            s: [
              11.703,
              93.106,
              0
            ],
            to: [
              0,
              -44.414,
              0
            ],
            ti: [
              -44.414,
              0,
              0
            ]
          },
          {
            t: 229,
            s: [
              92.122,
              12.688,
              0
            ]
          }
        ],
        ix: 2,
        l: 2,
        x: `var $bm_rt;
$bm_rt = loopOut('cycle', 0);`
      },
      a: {
        a: 0,
        k: [
          2.5,
          2.5,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          50,
          50,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 5,
    h: 5,
    ip: 109,
    op: 409,
    st: 109,
    ct: 1,
    bm: 0
  },
  {
    ddd: 0,
    ind: 5,
    ty: 0,
    nm: "Frame 9",
    refId: "comp_3",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.562,
              y: 0.562
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 177,
            s: [
              92.122,
              12.688,
              0
            ],
            to: [
              44.414,
              0,
              0
            ],
            ti: [
              0,
              -44.414,
              0
            ]
          },
          {
            i: {
              x: 0.656,
              y: 0.656
            },
            o: {
              x: 0.311,
              y: 0.311
            },
            t: 207,
            s: [
              172.541,
              93.106,
              0
            ],
            to: [
              0,
              44.414,
              0
            ],
            ti: [
              44.414,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.689,
              y: 0.689
            },
            o: {
              x: 0.343,
              y: 0.343
            },
            t: 237,
            s: [
              92.122,
              173.525,
              0
            ],
            to: [
              -44.414,
              0,
              0
            ],
            ti: [
              0,
              44.414,
              0
            ]
          },
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.437,
              y: 0.437
            },
            t: 267,
            s: [
              11.703,
              93.106,
              0
            ],
            to: [
              0,
              -44.414,
              0
            ],
            ti: [
              -44.414,
              0,
              0
            ]
          },
          {
            t: 297,
            s: [
              92.122,
              12.688,
              0
            ]
          }
        ],
        ix: 2,
        l: 2,
        x: `var $bm_rt;
$bm_rt = loopOut('cycle', 0);`
      },
      a: {
        a: 0,
        k: [
          2.5,
          2.5,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 5,
    h: 5,
    ip: 177,
    op: 477,
    st: 177,
    ct: 1,
    bm: 0
  },
  {
    ddd: 0,
    ind: 6,
    ty: 0,
    nm: "Frame 8",
    refId: "comp_4",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.562,
              y: 0.562
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: -1,
            s: [
              92.122,
              12.688,
              0
            ],
            to: [
              44.414,
              0,
              0
            ],
            ti: [
              0,
              -44.414,
              0
            ]
          },
          {
            i: {
              x: 0.656,
              y: 0.656
            },
            o: {
              x: 0.311,
              y: 0.311
            },
            t: 29,
            s: [
              172.541,
              93.106,
              0
            ],
            to: [
              0,
              44.414,
              0
            ],
            ti: [
              44.414,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.689,
              y: 0.689
            },
            o: {
              x: 0.343,
              y: 0.343
            },
            t: 59,
            s: [
              92.122,
              173.525,
              0
            ],
            to: [
              -44.414,
              0,
              0
            ],
            ti: [
              0,
              44.414,
              0
            ]
          },
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.437,
              y: 0.437
            },
            t: 89,
            s: [
              11.703,
              93.106,
              0
            ],
            to: [
              0,
              -44.414,
              0
            ],
            ti: [
              -44.414,
              0,
              0
            ]
          },
          {
            t: 119,
            s: [
              92.122,
              12.688,
              0
            ]
          }
        ],
        ix: 2,
        l: 2,
        x: `var $bm_rt;
$bm_rt = loopOut('cycle', 0);`
      },
      a: {
        a: 0,
        k: [
          3,
          3,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          50,
          50,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 6,
    h: 6,
    ip: -1,
    op: 299,
    st: -1,
    ct: 1,
    bm: 0
  },
  {
    ddd: 0,
    ind: 7,
    ty: 0,
    nm: "Frame 13",
    refId: "comp_5",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.562,
              y: 0.562
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 30,
            s: [
              92.122,
              12.688,
              0
            ],
            to: [
              44.414,
              0,
              0
            ],
            ti: [
              0,
              -44.414,
              0
            ]
          },
          {
            i: {
              x: 0.656,
              y: 0.656
            },
            o: {
              x: 0.311,
              y: 0.311
            },
            t: 60,
            s: [
              172.541,
              93.106,
              0
            ],
            to: [
              0,
              44.414,
              0
            ],
            ti: [
              44.414,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.689,
              y: 0.689
            },
            o: {
              x: 0.343,
              y: 0.343
            },
            t: 90,
            s: [
              92.122,
              173.525,
              0
            ],
            to: [
              -44.414,
              0,
              0
            ],
            ti: [
              0,
              44.414,
              0
            ]
          },
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.437,
              y: 0.437
            },
            t: 120,
            s: [
              11.703,
              93.106,
              0
            ],
            to: [
              0,
              -44.414,
              0
            ],
            ti: [
              -44.414,
              0,
              0
            ]
          },
          {
            t: 150,
            s: [
              92.122,
              12.688,
              0
            ]
          }
        ],
        ix: 2,
        l: 2,
        x: `var $bm_rt;
$bm_rt = loopOut('cycle', 0);`
      },
      a: {
        a: 0,
        k: [
          7,
          7,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          50,
          50,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 14,
    h: 14,
    ip: 30,
    op: 330,
    st: 30,
    ct: 1,
    bm: 0
  },
  {
    ddd: 0,
    ind: 10,
    ty: 0,
    nm: "Frame 3",
    refId: "comp_6",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 0,
            s: [
              90.5,
              94.176,
              0
            ],
            to: [
              0,
              0,
              0
            ],
            ti: [
              0,
              0,
              0
            ]
          },
          {
            t: 299,
            s: [
              90.5,
              94.176,
              0
            ]
          }
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          56.5,
          56.5,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 0,
            s: [
              20,
              20,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 43.578,
            s: [
              117.663,
              117.663,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 61,
            s: [
              96.992,
              96.992,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 75,
            s: [
              107.433,
              107.433,
              100
            ]
          },
          {
            t: 105.84375,
            s: [
              101.278,
              101.278,
              100
            ]
          }
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 113,
    h: 113,
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }
], H0 = [], W0 = {
  v: N0,
  fr: L0,
  ip: T0,
  op: j0,
  w: F0,
  h: k0,
  nm: V0,
  ddd: z0,
  assets: A0,
  layers: B0,
  markers: H0
};
function G0(e) {
  const { getStarted: t } = e.lang, { defaultLoginCallBack: n } = En(), r = re(null), o = ia("user");
  return Se(() => {
    setTimeout(() => {
      n(o);
    }, 3e3);
  }, []), Se(() => (mr.loadAnimation({
    name: "factorEnableAnimation",
    container: r.current,
    renderer: "svg",
    loop: !1,
    autoplay: !1,
    animationData: W0
  }), mr.play("factorEnableAnimation"), () => {
    mr.destroy("factorEnableAnimation");
  }), []), /* @__PURE__ */ x.jsxs("div", { className: D.enabled, children: [
    /* @__PURE__ */ x.jsx("div", { ref: r, className: D.imgContainer }),
    /* @__PURE__ */ x.jsx("h3", { children: t.authenticationSuccessful })
  ] });
}
function K0(e) {
  var N, $;
  const t = fa(), [n, r] = me([]), { setEmail: o, defaultLoginCallBack: a, handleAuthLoginForEmail: i, userInfo: l } = En(), [u, p] = me(1), [m, s] = me(""), [h, v] = me(0), f = "+" + (($ = (N = Qt().get("phone")) == null ? void 0 : N.trim) == null ? void 0 : $.call(N)), d = Cn(), { getStarted: g, errorcode: b } = e.lang, w = re(null), { openNotification: S } = In();
  Se(() => {
    f && Ui({
      phone_number: f
    }).then((E) => {
      const A = E == null ? void 0 : E.data;
      r(A);
    });
  }, [f]), Se(() => {
    w.current && o(w.current);
  }, [w.current]), Se(() => {
    t || !Object.keys(l).length || Yi({
      email: w.current,
      phone_number: f
    }).then(() => {
      a(l);
    });
  }, [l]);
  const C = (E) => {
    s(""), (E == null ? void 0 : E.length) === 6 && i(E);
  }, I = (E) => {
    var k;
    const A = E == null ? void 0 : E.code;
    let G = b[A];
    return A === 40006 && (G = Jt(G, {
      retry_after: (k = E == null ? void 0 : E.errors) == null ? void 0 : k.retry_after
    })), { transErr: G };
  }, O = (E) => {
    w.current = E, gn({ email: E }).then(() => {
      p(2);
    }).catch((A) => {
      const { transErr: G } = I(A);
      S({
        type: "error",
        message: null,
        description: G ?? A.message ?? g.optError
      });
    });
  }, _ = () => new Promise((E, A) => {
    gn({ email: w.current }).then(() => {
      v((/* @__PURE__ */ new Date()).getTime()), E(), S({
        type: "success",
        message: null,
        description: g.resendEmailCode
      });
    }).catch((G) => {
      if (G.message.indexOf("41260") > -1) {
        A(G);
        return;
      }
      const { transErr: k } = I(G);
      S({
        type: "error",
        message: null,
        description: k ?? G.message ?? g.optError
      });
    });
  }), Z = () => {
    if (u == 1) {
      history.back();
      return;
    } else
      p(1);
  }, [j, F] = me(null);
  return Se(() => {
    const E = document.getElementById("right-container");
    F(E);
  }, []), /* @__PURE__ */ x.jsxs("div", { className: D.emailFactor, style: { display: "flex", flexDirection: "column", height: "100%" }, children: [
    u === 1 ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx("div", { className: D.PhoneChooseEmailTitle, children: g.thisPhoneNumberAssociated }),
      /* @__PURE__ */ x.jsxs("div", { className: D.PhoneChooseEmailTips, children: [
        g.thisPhoneNumber,
        " ",
        /* @__PURE__ */ x.jsx("span", { children: n == null ? void 0 : n.length }),
        " ",
        g.accounts,
        " ",
        g.youNeedToChooseVerified
      ] }),
      /* @__PURE__ */ x.jsx("div", { className: D.phoneNumber, style: { height: 266 }, children: /* @__PURE__ */ x.jsx("ul", { className: D.account, children: n.map((E) => /* @__PURE__ */ x.jsxs("li", { onClick: () => O(E.email), children: [
        /* @__PURE__ */ x.jsx("img", { src: E.avatar || wl }),
        /* @__PURE__ */ x.jsxs("div", { children: [
          /* @__PURE__ */ x.jsxs("p", { className: D.name, children: [
            E.first_name,
            " ",
            E.last_name
          ] }),
          /* @__PURE__ */ x.jsx("p", { className: D.email, children: E.email })
        ] })
      ] }, E.id)) }) })
    ] }) : /* @__PURE__ */ x.jsx("div", { className: D.phoneNumber, children: /* @__PURE__ */ x.jsxs("div", { className: D.optBox, children: [
      /* @__PURE__ */ x.jsx("div", { className: D.PhoneChooseEmailTitle, style: { marginTop: "40px" }, children: g.verifyEmail }),
      /* @__PURE__ */ x.jsxs("div", { className: D.PhoneChooseEmailTips, style: { marginTop: "48px", marginBottom: "16px" }, children: [
        /* @__PURE__ */ x.jsx("div", { children: g.sendCodeDigit }),
        /* @__PURE__ */ x.jsx("div", { className: D.phone_text, children: w.current })
      ] }),
      /* @__PURE__ */ x.jsx(
        Hn,
        {
          lang: e.lang,
          autoFocus: !0,
          onChange: C,
          error: m,
          sendOpt: _,
          number: h
        }
      ),
      /* @__PURE__ */ x.jsx(
        Kn,
        {
          render: () => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
            /* @__PURE__ */ x.jsx("div", { children: g.checkSpamEmail }),
            /* @__PURE__ */ x.jsxs("div", { children: [
              g.havingTrouble,
              " ",
              /* @__PURE__ */ x.jsx(Sl, { className: D.link, href: `/${d}/get-started`, children: g.otherOptions })
            ] })
          ] }),
          children: /* @__PURE__ */ x.jsx("span", { className: D.havingTroubleText, children: (g == null ? void 0 : g.needHelpText) || "Need help?" })
        }
      )
    ] }) }),
    j && kn.createPortal(/* @__PURE__ */ x.jsxs(
      "div",
      {
        className: D.backBox,
        style: { marginTop: u === 1 ? 20 : 60, paddingTop: 0 },
        onClick: Z,
        children: [
          /* @__PURE__ */ x.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ x.jsx(
            "path",
            {
              fill: "#707070",
              d: "m13.484 14.557-3.556-3.556 3.556-3.557a.913.913 0 1 0-1.292-1.293L7.984 10.36a.913.913 0 0 0 0 1.292l4.208 4.208a.913.913 0 0 0 1.292 0 .932.932 0 0 0 0-1.302Z"
            }
          ) }),
          /* @__PURE__ */ x.jsx("span", { children: g.back })
        ]
      }
    ), j)
  ] });
}
const am = (e) => {
  const {
    lang: t,
    isModal: n = !1,
    stepModal: r,
    setLoginData: o,
    handleEmailClick: a,
    loginData: i,
    setLoginType: l,
    handleBackClick: u,
    bannerType: p
  } = e, s = Qt().get("step"), [h, v] = me(1), [c, f] = me(!1), d = re(null);
  Se(() => {
    const w = [1, 2, 3, 4, 5, 6, 7].includes(+s);
    if (n) {
      v(r);
      return;
    }
    v(s && w ? Number(s) : 1);
  }, [s, r, n]), zi(p);
  const g = (w) => {
    f(w), w && d.current.getQrCodeFun();
  }, b = /* @__PURE__ */ x.jsxs(
    "div",
    {
      style: mn || n ? {} : {
        width: 1024,
        height: 640,
        display: "flex",
        flexDirection: "row",
        padding: 16,
        borderRadius: 16,
        boxShadow: "0px 4px 6px 0px rgba(162, 183, 203, 0.10)"
      },
      className: D.container,
      children: [
        !(mn || n) && /* @__PURE__ */ x.jsx("div", { className: D.leftContainer, children: /* @__PURE__ */ x.jsx(Ai, { bannerType: p, dictionary: t }) }),
        /* @__PURE__ */ x.jsxs("div", { id: "right-container", style: mn || n ? {} : { flex: 1, padding: "20px 34px" }, className: D.rightContainer, children: [
          !mn && !n && /* @__PURE__ */ x.jsx(
            "div",
            {
              onClick: () => {
              },
              style: {
                position: "absolute",
                top: 20,
                left: 34,
                width: 45,
                height: 45
                // cursor: 'pointer'
              },
              children: /* @__PURE__ */ x.jsx(Bi, {})
            }
          ),
          /* @__PURE__ */ x.jsx(
            Hi,
            {
              setQrCode: g,
              qrCode: c,
              dictionary: t,
              isModal: n
            }
          ),
          /* @__PURE__ */ x.jsx("div", { className: c ? D.qrCodeWrapper : "hide", children: /* @__PURE__ */ x.jsx(Wi, { ref: d, open: c, lang: t }) }),
          /* @__PURE__ */ x.jsxs(
            "div",
            {
              style: {
                width: "100%",
                padding: !(n || mn) && "0px 100px"
              },
              className: c ? "hide" : D.loginItems,
              children: [
                h === 1 && /* @__PURE__ */ x.jsx(
                  pd,
                  {
                    config: e.config,
                    lang: e.lang,
                    isModal: n,
                    bannerType: p,
                    setLoginData: o,
                    handleEmailClick: a
                  }
                ),
                h === 2 && /* @__PURE__ */ x.jsx(
                  M0,
                  {
                    lang: e.lang,
                    setStep: l,
                    isModal: n,
                    loginData: i,
                    handleBackClick: u
                  }
                ),
                h === 3 && /* @__PURE__ */ x.jsx(R0, { lang: e.lang }),
                h === 4 && /* @__PURE__ */ x.jsx($0, { lang: e.lang }),
                h === 5 && /* @__PURE__ */ x.jsx(G0, { lang: e.lang }),
                h === 6 && /* @__PURE__ */ x.jsx(D0, { lang: e.lang }),
                h === 7 && /* @__PURE__ */ x.jsx(K0, { lang: e.lang })
              ]
            }
          )
        ] })
      ]
    }
  );
  return /* @__PURE__ */ x.jsx(x.Fragment, { children: n ? b : /* @__PURE__ */ x.jsxs("div", { className: D.main, children: [
    /* @__PURE__ */ x.jsx("div", { className: D.bg }),
    b
  ] }) });
};
export {
  am as P
};
//# sourceMappingURL=PhoneLogin-ecc734d4.js.map
